var Gr = Object.defineProperty;
var qr = (e, t, n) => t in e ? Gr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var et = (e, t, n) => qr(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as s, jsxs as d, Fragment as re } from "react/jsx-runtime";
import { QueryClient as Vr, QueryClientProvider as Jr, useMutation as qe, useQueryClient as zn, useQuery as Pn } from "@tanstack/react-query";
import { useState as A, useCallback as J, useMemo as Q, useContext as Ee, createContext as je, useRef as z, useEffect as U, Component as Xr, useReducer as Yr, useLayoutEffect as ct, Fragment as Qr, memo as Ye } from "react";
import Zr from "ky";
import { useReducedMotion as ei, motion as Yt, AnimatePresence as ti } from "framer-motion";
import Dn from "react-markdown";
import En from "remark-gfm";
import { createPortal as Et } from "react-dom";
const ni = "agt_formant_chat", jn = "console.incidentsSeenRunIds", ri = 500, ii = 1440 * 60 * 1e3;
function ai() {
  try {
    const e = localStorage.getItem(jn);
    if (!e) return /* @__PURE__ */ new Set();
    const t = JSON.parse(e);
    return Array.isArray(t) ? new Set(t.filter((n) => typeof n == "string")) : /* @__PURE__ */ new Set();
  } catch {
    return /* @__PURE__ */ new Set();
  }
}
function si(e) {
  try {
    const t = [...e].slice(-ri);
    localStorage.setItem(jn, JSON.stringify(t));
  } catch {
  }
}
function Qt(e, t) {
  if (t.has(e.id)) return !1;
  const n = e.startedAt ?? e.createdAt, r = n ? new Date(n).getTime() : 0;
  return Date.now() - r <= ii;
}
const Ln = je(null), tt = [];
function oi({ children: e }) {
  const [t, n] = A({}), [r, i] = A({}), [a, o] = A(() => ai()), l = J((v) => {
    v && o((b) => {
      if (b.has(v)) return b;
      const C = new Set(b);
      return C.add(v), si(C), C;
    });
  }, []), c = J(
    (v, b) => {
      !v || !b || (n((C) => {
        const g = C[v] ?? tt;
        return g.includes(b) ? C : { ...C, [v]: [...g, b] };
      }), l(b));
    },
    [l]
  ), u = J((v, b) => {
    n((C) => {
      const g = C[v];
      return !g || !g.includes(b) ? C : { ...C, [v]: g.filter((M) => M !== b) };
    });
  }, []), f = J((v, b) => {
    !v || !b || (n((C) => {
      const g = C[v];
      return !g || !g.includes(b) ? C : { ...C, [v]: g.filter((M) => M !== b) };
    }), i((C) => {
      const g = C[v] ?? tt;
      return g.includes(b) ? C : { ...C, [v]: [...g, b] };
    }));
  }, []), h = J(
    (v) => t[v] ?? tt,
    [t]
  ), m = J(
    (v) => r[v] ?? tt,
    [r]
  ), y = Q(
    () => ({ injectionsFor: h, inject: c, remove: u, detach: f, detachedFor: m, seenIds: a, markSeen: l }),
    [h, c, u, f, m, a, l]
  );
  return /* @__PURE__ */ s(Ln.Provider, { value: y, children: e });
}
function jt() {
  const e = Ee(Ln);
  if (!e)
    throw new Error("useIncidentInjections must be used inside <IncidentInjectionProvider>");
  return e;
}
class li {
  constructor(t) {
    et(this, "http");
    this.http = Zr.create({
      prefixUrl: t.baseUrl.replace(/\/$/, ""),
      timeout: t.timeout ?? 3e4,
      hooks: {
        beforeRequest: [
          (n) => {
            t.jwt && n.headers.set("Authorization", `Bearer ${t.jwt}`);
          }
        ],
        afterResponse: [
          (n, r, i) => {
            var a;
            i.status === 401 && ((a = t.onUnauthorized) == null || a.call(t));
          }
        ]
      }
    });
  }
}
const On = je(null), ci = On.Provider;
function pt() {
  const e = Ee(On);
  if (!e)
    throw new Error("useCortexClient must be used within a <ChatProvider>.");
  return e;
}
function ui(e) {
  return e.startsWith("mcp_") ? e.slice(4) : e;
}
const Zt = 200;
let be = Object.freeze([]);
const at = /* @__PURE__ */ new Set();
function di() {
  for (const e of at)
    try {
      e();
    } catch (t) {
      console.error("mcp-activity-bus listener threw", t);
    }
}
function en(e) {
  const t = e.length > Zt ? e.slice(e.length - Zt) : e;
  be = Object.freeze(t), di();
}
const ut = {
  publishCall(e) {
    if (be.some((n) => n.id === e.toolCallId)) return;
    const t = {
      id: e.toolCallId,
      ts: Date.now(),
      source: e.source ?? "chat",
      threadId: e.threadId,
      name: ui(e.name),
      qualifiedName: e.name,
      args: e.args,
      status: "pending"
    };
    en([...be, t]);
  },
  publishResult(e) {
    const t = be.findIndex((a) => a.id === e.toolCallId);
    if (t === -1)
      return;
    const n = be[t];
    if (!n) return;
    const r = {
      id: n.id,
      ts: n.ts,
      source: n.source,
      threadId: n.threadId,
      name: n.name,
      qualifiedName: n.qualifiedName,
      args: n.args,
      status: e.error ? "error" : "ok",
      result: e.result,
      durationMs: e.durationMs,
      error: e.error
    }, i = be.slice();
    i[t] = r, en(i);
  },
  subscribe(e) {
    return at.add(e), () => {
      at.delete(e);
    };
  },
  getSnapshot() {
    return be;
  },
  /** Test-only. Drops every record and listener. */
  _reset() {
    be = Object.freeze([]), at.clear();
  }
};
let Lt = "";
function xl() {
  return Lt;
}
function fi(e) {
  Lt = (e ?? "").replace(/\/$/, "");
}
function Fn() {
  return `${Lt}/api`;
}
async function hi(e, t, n) {
  const r = { "Content-Type": t };
  n && (r.Authorization = `Bearer ${n}`);
  const i = await fetch(`${Fn()}/transcribe`, {
    method: "POST",
    headers: r,
    body: e
  });
  if (!i.ok) {
    let o = "";
    try {
      o = await i.text();
    } catch {
    }
    throw new Error(`transcribe failed: ${i.status} ${o}`.trim());
  }
  return (await i.json()).text;
}
async function mi(e, t, n = "leo") {
  const r = { "Content-Type": "application/json" };
  t && (r.Authorization = `Bearer ${t}`);
  const i = { text: e, voice: n }, a = await fetch(`${Fn()}/tts`, {
    method: "POST",
    headers: r,
    body: JSON.stringify(i)
  });
  if (!a.ok)
    throw new Error(`tts failed: ${a.status}`);
  return (await a.json()).audioUrl;
}
const Wn = je(null);
function Qe() {
  const e = Ee(Wn);
  if (!e)
    throw new Error(
      "useChatConfig must be used within a <ChatProvider>. Wrap your app (or the chat mount) in <ChatProvider>."
    );
  return e;
}
function pi(e) {
  if (!e) return "anon";
  try {
    const t = e.split(".")[1];
    if (!t) return "anon";
    const n = t.replace(/-/g, "+").replace(/_/g, "/"), r = n.padEnd(Math.ceil(n.length / 4) * 4, "="), i = JSON.parse(atob(r)), a = i.sub ?? i.org ?? i.orgId;
    return typeof a == "string" && a.length > 0 ? a : "anon";
  } catch {
    return "anon";
  }
}
function Cl({
  cortexApiBaseUrl: e,
  token: t,
  ready: n,
  onNavigate: r,
  pageCatalog: i,
  groupId: a,
  theopolisBaseUrl: o,
  onUnauthorized: l,
  onToolCall: c,
  onToolResult: u,
  queryClient: f,
  incidentsAdapter: h,
  onNotify: m,
  children: y
}) {
  fi(o);
  const [v] = A(
    () => new Vr({
      defaultOptions: {
        queries: { staleTime: 3e4, retry: 1, refetchOnWindowFocus: !1 }
      }
    })
  ), b = f ?? v, C = Q(() => pi(t), [t]), g = Q(
    () => new li({ baseUrl: e, jwt: t, onUnauthorized: l }),
    [e, t, l]
  ), M = Q(
    () => ({
      token: t,
      ready: n,
      cortexApiBaseUrl: e.replace(/\/$/, ""),
      groupId: a ?? ni,
      identityKey: C,
      pageCatalog: i ?? [],
      // Passed through as null when absent — a no-op stub here would make the
      // chat mark navigate_to_page tool calls handled while nothing happened.
      onNavigate: r ?? null,
      voiceEnabled: !!o,
      incidentsAdapter: h ?? null,
      onNotify: m ?? null
    }),
    [
      t,
      n,
      e,
      a,
      C,
      i,
      r,
      o,
      h,
      m
    ]
  ), $ = z(c), _ = z(u);
  U(() => {
    $.current = c, _.current = u;
  }, [c, u]);
  const P = z(/* @__PURE__ */ new Set()), j = z(/* @__PURE__ */ new Set());
  return U(() => {
    const x = () => {
      var N, S;
      for (const p of ut.getSnapshot())
        P.current.has(p.id) || (P.current.add(p.id), (N = $.current) == null || N.call($, p)), p.status !== "pending" && !j.current.has(p.id) && (j.current.add(p.id), (S = _.current) == null || S.call(_, p));
    };
    return x(), ut.subscribe(x);
  }, []), /* @__PURE__ */ s(Jr, { client: b, children: /* @__PURE__ */ s(ci, { value: g, children: /* @__PURE__ */ s(Wn.Provider, { value: M, children: /* @__PURE__ */ s(oi, { children: y }) }) }) });
}
const gi = 300 * 1e3;
function yi(e, t) {
  const { token: n } = Qe(), [r, i] = A("idle"), [a, o] = A(null), l = z(null), c = z(null), u = z([]), f = z("audio/webm"), h = z(null), m = z(!1);
  function y() {
    h.current !== null && (clearTimeout(h.current), h.current = null);
  }
  function v() {
    var _;
    (_ = c.current) == null || _.getTracks().forEach((P) => P.stop()), c.current = null, l.current = null;
  }
  async function b() {
    if (r === "idle") {
      o(null), t == null || t();
      try {
        const _ = await navigator.mediaDevices.getUserMedia({ audio: !0 });
        c.current = _;
        const P = bi();
        f.current = P;
        const j = new MediaRecorder(_, P ? { mimeType: P } : void 0);
        l.current = j, u.current = [], m.current = !1, j.addEventListener("dataavailable", (x) => {
          x.data && x.data.size > 0 && u.current.push(x.data);
        }), j.addEventListener("stop", () => {
          if (y(), m.current) {
            m.current = !1, u.current = [], v(), i("idle");
            return;
          }
          M();
        }), j.start(200), i("recording"), h.current = window.setTimeout(() => {
          var x;
          ((x = l.current) == null ? void 0 : x.state) === "recording" && l.current.stop();
        }, gi);
      } catch (_) {
        console.error("useDictation: getUserMedia failed", _), o("Microphone unavailable."), i("idle"), v();
      }
    }
  }
  function C() {
    var _;
    if (r === "recording") {
      i("transcribing");
      try {
        (_ = l.current) == null || _.stop();
      } catch (P) {
        console.error("useDictation: recorder.stop failed", P);
      }
    }
  }
  function g() {
    var _;
    if (r === "recording") {
      m.current = !0, y();
      try {
        (_ = l.current) == null || _.stop();
      } catch (P) {
        console.error("useDictation: recorder.stop (cancel) failed", P);
      }
    }
  }
  async function M() {
    const _ = u.current;
    u.current = [];
    const P = f.current || "audio/webm";
    if (v(), _.length === 0) {
      i("idle");
      return;
    }
    const j = new Blob(_, { type: P });
    try {
      const x = await hi(j, P, n);
      x.trim() && e(x.trim());
    } catch (x) {
      console.error("useDictation: transcribe failed", x), o("Could not transcribe audio — try again"), setTimeout(() => o(null), 4e3);
    } finally {
      i("idle");
    }
  }
  function $() {
    r === "recording" ? C() : r === "idle" && (b(), void 0);
  }
  return U(() => () => {
    var _;
    y();
    try {
      ((_ = l.current) == null ? void 0 : _.state) === "recording" && l.current.stop();
    } catch {
    }
    v();
  }, []), { state: r, error: a, toggle: $, start: () => (b(), void 0), stop: C, cancel: g };
}
function bi() {
  const e = ["audio/webm;codecs=opus", "audio/webm", "audio/ogg;codecs=opus", "audio/mp4"];
  for (const t of e)
    if (typeof MediaRecorder < "u" && MediaRecorder.isTypeSupported(t)) return t;
  return "";
}
const vi = { w: 720, h: 640 }, tn = 360, nn = 320, rn = 24, Bn = "console.chatPanelSize", Kn = "console.chatPanelPos", Un = "console.chatRailCollapsed";
function Mt(e, t) {
  const n = Math.max(tn, t.w - rn), r = Math.max(nn, t.h - rn);
  return {
    w: dt(e.w, tn, n),
    h: dt(e.h, nn, r)
  };
}
function an(e, t, n) {
  return {
    x: dt(e.x, 0, Math.max(0, n.w - t.w)),
    y: dt(e.y, 0, Math.max(0, n.h - t.h))
  };
}
function wi(e) {
  const t = Jn(Bn), n = Mi(t) ? { w: t.w, h: t.h } : vi;
  return Mt(n, e);
}
function ki(e) {
  Xn(Bn, { w: Math.round(e.w), h: Math.round(e.h) });
}
function _i() {
  const e = Jn(Kn);
  return $i(e) ? { x: e.x, y: e.y } : null;
}
function Ni(e) {
  Xn(Kn, { x: Math.round(e.x), y: Math.round(e.y) });
}
function xi() {
  try {
    return localStorage.getItem(Un) === "1";
  } catch {
    return !1;
  }
}
function sn(e) {
  try {
    localStorage.setItem(Un, e ? "1" : "0");
  } catch {
  }
}
const Hn = "console.incidentsRailOpen", Gn = "console.launcherIncidentsRailOpen";
function Sl() {
  try {
    return localStorage.getItem(Hn) === "1";
  } catch {
    return !1;
  }
}
function Ml(e) {
  try {
    localStorage.setItem(Hn, e ? "1" : "0");
  } catch {
  }
}
function Ci() {
  try {
    return localStorage.getItem(Gn) === "1";
  } catch {
    return !1;
  }
}
function Si(e) {
  try {
    localStorage.setItem(Gn, e ? "1" : "0");
  } catch {
  }
}
function qn(e, t) {
  try {
    const n = localStorage.getItem(`console.${e}`), r = n === null ? NaN : Number(n);
    return Number.isFinite(r) && r > 0 ? r : t;
  } catch {
    return t;
  }
}
function Vn(e, t) {
  try {
    localStorage.setItem(`console.${e}`, String(Math.round(t)));
  } catch {
  }
}
function dt(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function Mi(e) {
  return typeof e == "object" && e !== null && Number.isFinite(e.w) && Number.isFinite(e.h);
}
function $i(e) {
  return typeof e == "object" && e !== null && Number.isFinite(e.x) && Number.isFinite(e.y);
}
function Jn(e) {
  try {
    const t = localStorage.getItem(e);
    return t ? JSON.parse(t) : null;
  } catch {
    return null;
  }
}
function Xn(e, t) {
  try {
    localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
class Yn extends Xr {
  constructor() {
    super(...arguments);
    et(this, "state", { error: null });
    et(this, "reset", () => {
      this.setState({ error: null });
    });
  }
  static getDerivedStateFromError(n) {
    return { error: n };
  }
  componentDidCatch(n, r) {
    var i, a;
    console.error("[@formant/chat] contained a render error", n, r);
    try {
      (a = (i = this.props).onError) == null || a.call(i, n, r);
    } catch {
    }
  }
  render() {
    const { error: n } = this.state;
    if (!n)
      return this.props.children;
    const r = this.props.label ?? "Chat";
    return /* @__PURE__ */ s("div", { className: "chat-error-boundary", role: "alert", children: /* @__PURE__ */ d("div", { className: "chat-error-boundary__card", children: [
      /* @__PURE__ */ d("div", { className: "chat-error-boundary__title", children: [
        r,
        " stopped responding"
      ] }),
      /* @__PURE__ */ s("div", { className: "chat-error-boundary__body", children: "Something went wrong in the chat panel. The rest of the app is still running." }),
      /* @__PURE__ */ s("button", { type: "button", className: "chat-error-boundary__retry", onClick: this.reset, children: "Reload chat" })
    ] }) });
  }
}
function Ti(e, t, n, r, i, a) {
  const o = `${e.replace(/\/$/, "")}/v1/persistent-agent-groups/${t}/agents/${n}/stream`;
  let l = null, c = !1, u = null, f = null;
  const h = (g) => {
    try {
      i(JSON.parse(g.data));
    } catch (M) {
      console.info("console/sse:pa-watch-parse", M);
    }
  }, m = () => {
    var g, M;
    (g = a == null ? void 0 : a.onReconnect) == null || g.call(a), (M = a == null ? void 0 : a.onConnectionChange) == null || M.call(a, "live");
  }, y = () => {
    l && (l.removeEventListener("message", h), l.removeEventListener("open", m), l.removeEventListener("error", b), l.close(), l = null);
  }, v = () => {
    c || u !== null || (u = window.setTimeout(() => {
      u = null, C();
    }, 1500));
  }, b = () => {
    var g;
    l && l.readyState === EventSource.CLOSED && ((g = a == null ? void 0 : a.onConnectionChange) == null || g.call(a, "reconnecting"), y(), v());
  }, C = () => {
    var _;
    if (c) return;
    f !== null && (window.clearTimeout(f), f = null);
    const g = new URL(o), M = r();
    M && g.searchParams.set("access_token", M);
    const $ = Ii(M);
    if ($ !== null) {
      const P = $ * 1e3 - Date.now() - 6e4;
      P > 0 && (f = window.setTimeout(() => {
        f = null, y(), C();
      }, P));
    }
    try {
      l = new EventSource(g.toString(), { withCredentials: !0 });
    } catch (P) {
      console.warn("console/sse:pa-watch", P), (_ = a == null ? void 0 : a.onConnectionChange) == null || _.call(a, "reconnecting"), v();
      return;
    }
    l.addEventListener("message", h), l.addEventListener("open", m), l.addEventListener("error", b);
  };
  return C(), () => {
    c = !0, u !== null && (window.clearTimeout(u), u = null), f !== null && (window.clearTimeout(f), f = null), y();
  };
}
function Ii(e) {
  if (!e) return null;
  try {
    const t = e.split(".")[1];
    if (!t) return null;
    const n = JSON.parse(atob(t.replace(/-/g, "+").replace(/_/g, "/")));
    if (typeof n != "object" || n === null) return null;
    const r = n.exp;
    return typeof r == "number" ? r : null;
  } catch {
    return null;
  }
}
const Ri = 200, Ai = 1200, on = 200, zi = 2e3, Qn = {
  status: null,
  activity: null,
  facts: {},
  events: [],
  transcript: [],
  turns: {}
};
function Zn(e, t) {
  switch (t.kind) {
    case "fact":
      return {
        ...e,
        facts: {
          ...e.facts,
          [t.laneId]: {
            laneId: t.laneId,
            factType: t.factType,
            summary: t.summary,
            data: t.data,
            date: t.date
          }
        }
      };
    case "event":
      return {
        ...e,
        events: [
          {
            eventKind: t.eventKind,
            content: t.content,
            source: t.source,
            wokeFromIdle: t.wokeFromIdle,
            interrupted: t.interrupted,
            runId: t.runId,
            at: t.at
          },
          ...e.events
        ].slice(0, Ri)
      };
    case "status":
      return { ...e, status: t.status };
    case "activity":
      return { ...e, activity: { text: t.text, at: t.at } };
    case "chunk":
      return { ...e, transcript: [...e.transcript, t.part] };
    case "chunk-batch":
      return { ...e, transcript: [...e.transcript, ...t.parts] };
    case "turn":
      return { ...e, turns: { ...e.turns, [t.turn.id]: t.turn } };
    case "replay":
      return t.frames.reduce(Zn, Qn);
    default:
      return e;
  }
}
function Pi(e, t) {
  const { token: n, cortexApiBaseUrl: r } = Qe(), i = z(n);
  i.current = n;
  const [a, o] = Yr(Zn, Qn), [l, c] = A("live"), [u, f] = A(!1), h = z([]), m = z(null), y = z(!1), v = z([]), b = z(null), C = z(null), g = z(null);
  return U(() => {
    o({ kind: "replay", frames: [] }), f(!1);
    const M = 80, $ = () => {
      if (m.current !== null && (window.clearTimeout(m.current), m.current = null), h.current.length > 0) {
        const N = h.current;
        h.current = [], o({ kind: "chunk-batch", parts: N });
      }
    }, _ = () => {
      if (!y.current) return;
      y.current = !1, b.current !== null && (window.clearTimeout(b.current), b.current = null), C.current !== null && (window.clearTimeout(C.current), C.current = null);
      const N = v.current;
      v.current = [], o({ kind: "replay", frames: N }), f(!0);
    }, P = (N) => {
      if (N === "live") {
        g.current !== null && (window.clearTimeout(g.current), g.current = null), c("live");
        return;
      }
      g.current === null && (g.current = window.setTimeout(() => {
        g.current = null, c("reconnecting");
      }, Ai));
    }, j = r.replace(/\/$/, ""), x = Ti(
      j,
      e,
      t,
      () => i.current,
      (N) => {
        const S = N;
        if (y.current) {
          v.current.push(S), b.current !== null && window.clearTimeout(b.current), b.current = window.setTimeout(_, on);
          return;
        }
        if (S.kind === "chunk") {
          h.current.push(S.part), m.current === null && (m.current = window.setTimeout($, M));
          return;
        }
        $(), o(S);
      },
      {
        onConnectionChange: P,
        onReconnect: () => {
          h.current = [], m.current !== null && (clearTimeout(m.current), m.current = null), y.current = !0, v.current = [], b.current !== null && window.clearTimeout(b.current), b.current = window.setTimeout(_, on), C.current !== null && window.clearTimeout(C.current), C.current = window.setTimeout(_, zi);
        }
      }
    );
    return () => {
      $(), x(), g.current !== null && (window.clearTimeout(g.current), g.current = null), b.current !== null && (window.clearTimeout(b.current), b.current = null), C.current !== null && (window.clearTimeout(C.current), C.current = null);
    };
  }, [e, t, r]), { ...a, connection: l, hasLoaded: u };
}
function er({ tone: e = "agent" }) {
  return /* @__PURE__ */ d("span", { className: `pa-chat-dots pa-chat-dots--${e}`, "aria-hidden": "true", children: [
    /* @__PURE__ */ s("span", {}),
    /* @__PURE__ */ s("span", {}),
    /* @__PURE__ */ s("span", {})
  ] });
}
function ft({ inline: e = !1 }) {
  const t = e ? 14 : 32, n = {
    width: t,
    height: t,
    borderRadius: "50%",
    border: `${e ? 1.5 : 3}px solid var(--border)`,
    borderTopColor: "var(--horizon-glow)"
  };
  return e ? /* @__PURE__ */ s("span", { className: "pa-chat-spinner", style: { ...n, display: "inline-block" } }) : /* @__PURE__ */ s("div", { style: { display: "grid", placeItems: "center", padding: "var(--sp-9) 0" }, children: /* @__PURE__ */ s("div", { className: "pa-chat-spinner", style: n }) });
}
const Di = new Intl.DateTimeFormat(void 0, {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit"
}), $t = new Intl.DateTimeFormat(void 0, {
  hour: "numeric",
  minute: "2-digit"
}), Ve = "—", tr = new Intl.DateTimeFormat(void 0, { weekday: "short" }), nr = new Intl.DateTimeFormat(void 0, { month: "short", day: "numeric" });
function Je(e) {
  if (!e) return null;
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? null : t;
}
function Ot(e, t) {
  let n = null;
  if (typeof e == "number")
    n = e;
  else {
    const l = Je(e), c = Je(t ?? null);
    if (!l) return Ve;
    n = ((c == null ? void 0 : c.getTime()) ?? Date.now()) - l.getTime();
  }
  if (n === null || n < 0 || !Number.isFinite(n)) return Ve;
  if (n < 1e3) return `${n.toFixed(0)} ms`;
  const r = Math.floor(n / 1e3);
  if (r < 60) return `${r}s`;
  const i = Math.floor(r / 60), a = r % 60;
  return i < 60 ? a ? `${i}m ${a}s` : `${i}m` : `${Math.floor(i / 60)}h ${i % 60}m`;
}
function rr(e) {
  const t = Je(e);
  if (!t) return Ve;
  const n = t.getTime() - Date.now(), r = Math.abs(n), i = Math.round(r / 1e3);
  let a, o;
  return i < 60 ? (a = i, o = "s") : i < 3600 ? (a = Math.round(i / 60), o = "m") : i < 86400 ? (a = Math.round(i / 3600), o = "h") : (a = Math.round(i / 86400), o = "d"), n < 0 ? `${a}${o} ago` : `in ${a}${o}`;
}
function Ei(e) {
  const t = Je(e);
  if (!t) return Ve;
  const n = /* @__PURE__ */ new Date(), r = n.getTime() - t.getTime(), i = Math.round(r / 1e3);
  if (i < 60) return "just now";
  if (i < 3600) return `${Math.round(i / 60)}m ago`;
  const a = new Date(n.getFullYear(), n.getMonth(), n.getDate()), o = new Date(a.getTime() - 864e5), l = new Date(a.getTime() - 6 * 864e5);
  return t >= a ? $t.format(t) : t >= o ? "Yesterday" : t >= l ? tr.format(t) : nr.format(t);
}
function ir(e) {
  const t = Je(e);
  if (!t) return Ve;
  const n = /* @__PURE__ */ new Date(), r = new Date(n.getFullYear(), n.getMonth(), n.getDate());
  if (t >= r) return $t.format(t);
  const i = $t.format(t), a = new Date(r.getTime() - 864e5);
  if (t >= a) return `Yesterday ${i}`;
  const o = new Date(r.getTime() - 6 * 864e5);
  return t >= o ? `${tr.format(t)} ${i}` : t.getFullYear() === n.getFullYear() ? `${nr.format(t)}, ${i}` : Di.format(t);
}
function ar({
  images: e,
  index: t,
  onClose: n,
  onNavigate: r
}) {
  const i = z(null);
  return U(() => {
    var l, c;
    const a = document.activeElement, o = (l = i.current) == null ? void 0 : l.querySelectorAll("button");
    return (c = o == null ? void 0 : o[o.length - 1]) == null || c.focus(), () => {
      var u;
      return (u = a == null ? void 0 : a.focus) == null ? void 0 : u.call(a);
    };
  }, []), U(() => {
    function a(o) {
      if (o.key === "Escape") {
        n();
        return;
      }
      if (o.key === "ArrowLeft" && t > 0) {
        r(t - 1);
        return;
      }
      if (o.key === "ArrowRight" && t < e.length - 1) {
        r(t + 1);
        return;
      }
      if (o.key !== "Tab") return;
      const l = i.current;
      if (!l) return;
      const c = Array.from(l.querySelectorAll("button:not([disabled])")), u = c[0], f = c[c.length - 1];
      if (!u || !f) {
        o.preventDefault();
        return;
      }
      const h = document.activeElement;
      l.contains(h) ? o.shiftKey && h === u ? (o.preventDefault(), f.focus()) : !o.shiftKey && h === f && (o.preventDefault(), u.focus()) : (o.preventDefault(), u.focus());
    }
    return document.addEventListener("keydown", a), () => document.removeEventListener("keydown", a);
  }, [t, e.length, n, r]), Et(
    /* @__PURE__ */ d(
      "div",
      {
        ref: i,
        className: "pa-chat-lightbox",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": `Image ${t + 1} of ${e.length}`,
        onClick: n,
        children: [
          /* @__PURE__ */ s(
            "img",
            {
              src: e[t],
              alt: `Image ${t + 1} of ${e.length}`,
              className: "pa-chat-lightbox-img",
              onClick: (a) => a.stopPropagation()
            }
          ),
          e.length > 1 && /* @__PURE__ */ d("div", { className: "pa-chat-lightbox-nav", onClick: (a) => a.stopPropagation(), children: [
            /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                disabled: t === 0,
                onClick: () => r(t - 1),
                "aria-label": "Previous image",
                children: "←"
              }
            ),
            /* @__PURE__ */ d("span", { children: [
              t + 1,
              " / ",
              e.length
            ] }),
            /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                disabled: t === e.length - 1,
                onClick: () => r(t + 1),
                "aria-label": "Next image",
                children: "→"
              }
            )
          ] }),
          /* @__PURE__ */ s("button", { type: "button", className: "pa-chat-lightbox-close", onClick: n, "aria-label": "Close", children: "✕" })
        ]
      }
    ),
    document.body
  );
}
function Ft({ images: e }) {
  const [t, n] = A(null);
  return e.length === 0 ? null : /* @__PURE__ */ d(re, { children: [
    /* @__PURE__ */ s("div", { className: "pa-chat-tool-images", children: e.map((r, i) => /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "pa-chat-tool-image-link",
        onClick: () => n(i),
        title: "View image",
        children: /* @__PURE__ */ s(
          "img",
          {
            src: r,
            alt: `tool image ${i + 1}`,
            className: "pa-chat-tool-image",
            loading: "lazy",
            decoding: "async"
          }
        )
      },
      `${i}-${r.slice(0, 32)}`
    )) }),
    t !== null && /* @__PURE__ */ s(
      ar,
      {
        images: e,
        index: t,
        onClose: () => n(null),
        onNavigate: n
      }
    )
  ] });
}
function ji({
  src: e,
  alt: t,
  className: n
}) {
  const [r, i] = A(!1);
  return /* @__PURE__ */ d(re, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "pa-chat-img-zoom",
        onClick: () => i(!0),
        title: "Expand image",
        children: /* @__PURE__ */ s("img", { src: e, alt: t ?? "", className: n, loading: "lazy", decoding: "async" })
      }
    ),
    r && /* @__PURE__ */ s(
      ar,
      {
        images: [e],
        index: 0,
        onClose: () => i(!1),
        onNavigate: () => {
        }
      }
    )
  ] });
}
function Li(e) {
  const t = [], n = (i, a) => {
    if (!a) return;
    const o = t[t.length - 1];
    o && o.kind === i ? o.text += a : t.push({ kind: i, text: a });
  }, r = (i) => i ? t.find(
    (a) => a.kind === "tool" && a.toolCallId === i
  ) ?? null : null;
  for (const i of e)
    switch (i.type) {
      case "user":
        t.push({
          kind: "user",
          text: i.text,
          source: i.source,
          eventKind: i.eventKind
        });
        break;
      case "text":
        n("text", i.text);
        break;
      case "reasoning":
        n("reasoning", i.text);
        break;
      case "tool-call": {
        const a = r(i.toolCallId);
        a ? (a.name = i.name || a.name, i.args !== void 0 && (a.args = i.args), i.mcpName && (a.mcpName = i.mcpName)) : t.push({
          kind: "tool",
          toolCallId: i.toolCallId,
          name: i.name,
          args: i.args,
          ...i.mcpName ? { mcpName: i.mcpName } : {},
          hasResult: !1
        });
        break;
      }
      case "tool-result": {
        const a = r(i.toolCallId);
        a ? (a.result = i.result, a.durationMs = i.durationMs, a.hasResult = !0, i.isError && (a.isError = !0)) : t.push({
          kind: "tool",
          toolCallId: i.toolCallId,
          name: i.name ?? "tool",
          args: void 0,
          result: i.result,
          durationMs: i.durationMs,
          hasResult: !0,
          ...i.isError ? { isError: !0 } : {}
        });
        break;
      }
      case "goal": {
        const a = t[t.length - 1];
        a && a.kind === "goal" ? (a.objective = i.objective ?? a.objective, a.passed = i.passed ?? a.passed, a.status = i.status ?? a.status, a.reason = i.reason ?? a.reason, a.iteration = i.iteration ?? a.iteration, a.maxRuns = i.maxRuns ?? a.maxRuns) : t.push({
          kind: "goal",
          objective: i.objective,
          passed: i.passed,
          status: i.status,
          reason: i.reason,
          iteration: i.iteration,
          maxRuns: i.maxRuns
        });
        break;
      }
      case "error":
        t.push({
          kind: "error",
          message: i.message,
          kindCode: i.kind
        });
        break;
    }
  return t;
}
function Oi(e) {
  const t = Li(e.transcript), n = [];
  let r = null, i = null, a = "head", o = 0;
  const l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Map(), u = (m) => {
    r && r.length > 0 && i && n.push({
      kind: "turn",
      key: i,
      streaming: (m == null ? void 0 : m.streaming) === !0,
      blocks: r
    }), r = null, i = null;
  }, f = (m) => {
    r === null && (r = [], o += 1, i = `turn-${a}-${o}`);
    const y = r[r.length - 1];
    m.type === "tools" && (y == null ? void 0 : y.type) === "tools" ? y.calls.push(...m.calls) : r.push(m);
  }, h = /* @__PURE__ */ new Map();
  for (const m of t)
    switch (m.kind) {
      case "user": {
        u();
        const y = `${m.source ?? "system"}\0${m.text}`, v = (h.get(y) ?? 0) + 1;
        h.set(y, v);
        const b = `user-${wt(y)}-${v}`;
        a = b, o = 0, n.push({
          kind: "user",
          key: b,
          text: m.text,
          source: m.source ?? "system",
          eventKind: m.eventKind,
          state: "delivered",
          wokeFromIdle: !1,
          interrupted: !1
        });
        break;
      }
      case "text":
        f({ type: "text", text: m.text });
        break;
      case "reasoning":
        f({ type: "reasoning", text: m.text });
        break;
      case "tool":
        f({
          type: "tools",
          calls: [
            {
              toolCallId: m.toolCallId,
              name: m.name,
              args: m.args,
              ...m.mcpName ? { mcpName: m.mcpName } : {},
              result: m.result,
              durationMs: m.durationMs,
              hasResult: m.hasResult,
              ...m.isError ? { isError: !0 } : {}
            }
          ]
        });
        break;
      case "goal":
        u();
        {
          const y = `${m.objective ?? ""}\0${m.status ?? ""}\0${m.iteration ?? ""}`, v = (l.get(y) ?? 0) + 1;
          l.set(y, v), n.push({
            kind: "goal",
            key: `goal-${wt(y)}-${v}`,
            objective: m.objective,
            passed: m.passed,
            status: m.status,
            reason: m.reason,
            iteration: m.iteration,
            maxRuns: m.maxRuns
          });
        }
        break;
      case "error":
        u();
        {
          const y = m.message, v = (c.get(y) ?? 0) + 1;
          c.set(y, v), n.push({
            kind: "error",
            key: `error-${wt(y)}-${v}`,
            message: m.message,
            kindCode: m.kindCode
          });
        }
        break;
    }
  return u({ streaming: e.status === "WORKING" }), Ui(n, e.optimistic), Ki(n, e.events ?? []), Bi(n, e.queued ?? []), Wi(n, e.incidents ?? []), Fi(n, e.compactions ?? []), n;
}
function Fi(e, t) {
  const n = [...t].sort((r, i) => Date.parse(r.at) - Date.parse(i.at));
  for (const r of n) {
    const i = {
      kind: "compaction",
      // Version is unique per thread (the write is CAS-guarded), so it is a
      // stable React key with no occurrence counting needed.
      key: `compaction-v${r.version}`,
      version: r.version,
      msgCount: r.msgCount,
      summarizedCount: r.summarizedCount,
      forced: r.forced,
      summary: r.summary,
      at: r.at
    };
    let a = e.length;
    const o = Date.parse(r.at);
    if (!Number.isNaN(o))
      for (let l = 0; l < e.length; l += 1) {
        const c = e[l];
        if ((c == null ? void 0 : c.kind) === "user" && c.at && Date.parse(c.at) > o) {
          a = l;
          break;
        }
      }
    e.splice(a, 0, i);
  }
}
function Wi(e, t) {
  for (const n of t) {
    const r = {
      kind: "incident",
      key: `incident-${n.runId}`,
      runId: n.runId,
      ...n.at ? { at: n.at } : {}
    };
    let i = e.length;
    if (n.at) {
      const a = Date.parse(n.at);
      if (!Number.isNaN(a))
        for (let o = 0; o < e.length; o += 1) {
          const l = e[o];
          if ((l == null ? void 0 : l.kind) === "user" && l.at && Date.parse(l.at) > a) {
            i = o;
            break;
          }
        }
    }
    e.splice(i, 0, r);
  }
}
function Ze(e, t) {
  return e === t || JSON.stringify(e) === JSON.stringify(t);
}
function Bi(e, t) {
  for (const n of t) {
    const r = n.trim();
    for (let i = e.length - 1; i >= 0; i -= 1) {
      const a = e[i];
      if (a && a.kind === "user" && a.state === "delivered" && a.text.trim() === r) {
        e.splice(i, 1);
        break;
      }
    }
  }
}
function Ki(e, t) {
  if (t.length === 0) return;
  const n = [...t].reverse(), r = /* @__PURE__ */ new Set();
  for (const i of e) {
    if (i.kind !== "user" || i.state !== "delivered") continue;
    let a = -1;
    for (let l = 0; l < n.length; l += 1) {
      const c = n[l];
      if (!r.has(l) && c && c.content.trim() === i.text.trim() && c.source === i.source) {
        a = l;
        break;
      }
    }
    if (a < 0) continue;
    const o = n[a];
    o && (r.add(a), i.wokeFromIdle = o.wokeFromIdle, o.interrupted && (i.interrupted = !0), i.at = o.at);
  }
}
function Ui(e, t) {
  const n = /* @__PURE__ */ new Set(), r = (i) => {
    const a = e.findIndex(
      (l, c) => !n.has(c) && l.kind === "user" && l.state === "delivered" && l.text.trim() === i.text.trim()
    );
    if (a < 0) return !1;
    n.add(a);
    const o = e[a];
    return (o == null ? void 0 : o.kind) === "user" && (o.key = `optimistic-${i.localId}`, o.delivery = i.delivery, o.eventKind = i.kind, o.interrupted = i.delivery === "interrupt" && i.wasWorking), !0;
  };
  for (const i of t) {
    if (i.failed) {
      if (r(i)) continue;
      e.push(Gi(i));
      continue;
    }
    r(i) || e.push({
      kind: "user",
      key: `optimistic-${i.localId}`,
      text: i.text,
      source: "user:me",
      eventKind: i.kind,
      delivery: i.delivery,
      state: "pending",
      wokeFromIdle: !1,
      interrupted: i.delivery === "interrupt" && i.wasWorking
    });
  }
}
function Hi(e, t, n, r, i) {
  let a = !1, o = null;
  const l = e.map((c) => {
    if (c.failed || t.has(c.text.trim())) return c;
    const u = n.get(c.localId);
    if (u == null) return c;
    const f = r - u;
    if (f >= i)
      return a = !0, { ...c, failed: !0 };
    const h = i - f;
    return o = o == null ? h : Math.min(o, h), c;
  });
  return { changed: a, next: l, nextDeadlineMs: o };
}
function Gi(e) {
  return {
    kind: "user",
    key: `optimistic-${e.localId}`,
    text: e.text,
    source: "user:me",
    eventKind: e.kind,
    delivery: e.delivery,
    state: "failed",
    wokeFromIdle: !1,
    interrupted: !1
  };
}
function wt(e) {
  let t = 2166136261;
  for (let n = 0; n < e.length; n += 1)
    t ^= e.charCodeAt(n), t = Math.imul(t, 16777619);
  return (t >>> 0).toString(36);
}
function sr(e, t) {
  try {
    const n = qi(e);
    if (!n || typeof n != "object") return null;
    const r = n;
    return r.geometry && typeof r.geometry == "object" ? Yi(r) : Array.isArray(r.buckets) ? na(r) : Array.isArray(r.datapoints) ? Zi(r) : Array.isArray(r.items) ? un(r.items, ga) : Array.isArray(r.values) ? un(r.values, ya) : la(r.columns) && Array.isArray(r.rows) ? cn(ua(r.columns, r.rows)) : Array.isArray(r.rows) && ca(t == null ? void 0 : t.toolName) ? cn(da(r.rows)) : null;
  } catch {
    return null;
  }
}
function qi(e) {
  let t = e;
  for (let n = 0; n < 4; n += 1) {
    if (!t || typeof t != "object") return t;
    const r = t;
    if (r.isError === !0) return null;
    if (r.structuredContent && typeof r.structuredContent == "object") {
      t = r.structuredContent;
      continue;
    }
    if (Array.isArray(r.content)) {
      const i = r.content.map((a) => {
        if (!a || typeof a != "object") return null;
        const o = a;
        return o.type === "text" && typeof o.text == "string" ? o.text : null;
      }).find((a) => a !== null);
      if (i === void 0) return null;
      try {
        t = JSON.parse(i);
        continue;
      } catch {
        return null;
      }
    }
    if (typeof r.success == "boolean") {
      if (!r.success) return null;
      t = r.data;
      continue;
    }
    return t;
  }
  return t;
}
const Vi = 5e4, Ji = 500, Xi = /* @__PURE__ */ new Set(["scan", "cloud", "path", "tf"]);
function Yi(e) {
  const t = e.geometry, n = t.kind;
  if (!Xi.has(n)) return null;
  const r = [];
  if (Array.isArray(t.points))
    for (const l of t.points.slice(0, Vi)) {
      const c = ln(l);
      c && r.push(c);
    }
  const i = [];
  if (Array.isArray(t.frames))
    for (const l of t.frames.slice(0, Ji)) {
      if (!l || typeof l != "object") continue;
      const c = l, u = ln(c.position), f = Qi(c.rotation);
      typeof c.name != "string" || !c.name || !u || !f || i.push({
        name: c.name,
        parent: typeof c.parent == "string" && c.parent ? c.parent : null,
        position: u,
        rotation: f
      });
    }
  if (n === "tf" ? i.length === 0 : r.length < 2) return null;
  const a = typeof e.deviceName == "string" ? e.deviceName : null, o = typeof e.streamName == "string" ? e.streamName : null;
  return {
    kind: "geometry",
    title: Bt(a, o),
    geometry: { kind: n, points: r, frames: i }
  };
}
function Ce(e) {
  return typeof e == "number" && Number.isFinite(e);
}
function ln(e) {
  if (!Array.isArray(e) || e.length < 3) return null;
  const [t, n, r] = e;
  return !Ce(t) || !Ce(n) || !Ce(r) ? null : [t, n, r];
}
function Qi(e) {
  if (!Array.isArray(e) || e.length !== 4) return null;
  const [t, n, r, i] = e;
  if (!Ce(t) || !Ce(n) || !Ce(r) || !Ce(i))
    return null;
  const a = Math.hypot(t, n, r, i);
  return a < 1e-9 ? null : [t / a, n / a, r / a, i / a];
}
function Zi(e) {
  var o;
  const t = typeof e.deviceName == "string" ? e.deviceName : null, n = typeof e.streamName == "string" ? e.streamName : null, r = Bt(t, n), i = e.datapoints.map((l) => {
    if (!l || typeof l != "object") return null;
    const c = l;
    return { t: Me(c.time ?? c.timestamp), value: c.value };
  }).filter((l) => l !== null && l.value !== void 0);
  if (i.length === 0) return null;
  switch (e.streamType === "json" ? "json" : lr((o = i[0]) == null ? void 0 : o.value)) {
    case "numeric": {
      const l = ea(i, r ?? "value");
      if (!l) return null;
      const c = l.points.length === 1 ? l.points[0] : void 0;
      return c ? {
        kind: "values",
        title: null,
        tiles: [
          {
            label: n ?? "value",
            ...t ? { sublabel: t } : {},
            t: c.t,
            value: { type: "numeric", value: c.v }
          }
        ]
      } : { kind: "timeseries", title: r === l.label ? null : r, series: [l] };
    }
    case "battery": {
      const l = i.map((u) => {
        const f = u.value.percentage;
        return typeof f == "number" && u.t !== null ? { t: u.t, v: f } : null;
      }).filter((u) => u !== null);
      if (l.length === 0) return null;
      const c = r ?? "battery";
      return {
        kind: "timeseries",
        title: r === c ? null : r,
        series: [{ label: c, unit: "%", points: Le(l) }]
      };
    }
    case "numeric-set":
      return ta(i, r);
    case "location": {
      const l = i.map((c) => {
        const u = c.value;
        return cr(u.latitude, u.longitude) ? { latitude: u.latitude, longitude: u.longitude, t: c.t } : null;
      }).filter((c) => c !== null);
      return l.length === 0 ? null : { kind: "map", title: r, points: ka(l), variant: "trail" };
    }
    case "image": {
      const l = i.map((c) => {
        const u = c.value;
        return ht(u.url) ? { url: u.url, t: c.t } : null;
      }).filter((c) => c !== null);
      return l.length === 0 ? null : { kind: "images", title: r, items: l };
    }
    case "video": {
      const l = i.map((c) => {
        const u = c.value;
        return ht(u.url) ? {
          url: u.url,
          t: c.t,
          durationMs: typeof u.duration == "number" ? u.duration : null,
          mimeType: typeof u.mimeType == "string" ? u.mimeType : "video/mp4"
        } : null;
      }).filter((c) => c !== null);
      return l.length === 0 ? null : { kind: "videos", title: r, items: l };
    }
    case "json": {
      const l = i.map((c) => ({ t: c.t, value: Wt(c.value) })).filter((c) => c.value !== null);
      return l.length === 0 ? null : {
        kind: "record",
        title: r,
        field: typeof e.field == "string" && e.field ? e.field : null,
        samples: [...l].sort((c, u) => (c.t ?? 0) - (u.t ?? 0))
      };
    }
    default:
      return null;
  }
}
function ea(e, t) {
  const n = e.map((r) => typeof r.value == "number" && r.t !== null ? { t: r.t, v: r.value } : null).filter((r) => r !== null);
  return n.length === 0 ? null : { label: t, points: Le(n) };
}
function ta(e, t) {
  const n = /* @__PURE__ */ new Map();
  for (const i of e)
    if (!(i.t === null || !Array.isArray(i.value)))
      for (const a of i.value) {
        if (!a || typeof a != "object") continue;
        const o = a;
        if (typeof o.value != "number") continue;
        const l = typeof o.label == "string" && o.label ? o.label : "value";
        let c = n.get(l);
        c || (c = {
          label: l,
          unit: typeof o.unit == "string" ? o.unit : void 0,
          points: []
        }, n.set(l, c)), c.points.push({ t: i.t, v: o.value });
      }
  const r = [...n.values()].map((i) => ({ ...i, points: Le(i.points) }));
  return r.length === 0 ? null : { kind: "timeseries", title: t, series: r };
}
function na(e) {
  const t = typeof e.stream_name == "string" ? e.stream_name : null, n = [], r = [];
  for (const i of e.buckets) {
    if (!i || typeof i != "object") continue;
    const a = i, o = Me(a.bucket_start);
    o !== null && (typeof a.avg == "number" && n.push({ t: o, v: a.avg }), typeof a.min == "number" && typeof a.max == "number" && r.push({ t: o, min: a.min, max: a.max }));
  }
  return n.length === 0 ? null : {
    kind: "timeseries",
    title: t,
    series: [
      {
        label: t ?? "avg",
        points: Le(n),
        band: r.length > 0 ? r : void 0
      }
    ]
  };
}
const ra = 2e3, ia = 200, aa = /^\d{4}-\d{2}-\d{2}$/, sa = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2}(\.\d+)?)?(Z|[+-]\d{2}:?\d{2})?$/, oa = /^-?\d+(\.\d+)?$/;
function la(e) {
  return Array.isArray(e) && e.every((t) => typeof t == "string");
}
function ca(e) {
  return typeof e == "string" && /analytics|query/i.test(e);
}
function ua(e, t) {
  const n = [];
  for (const r of t) {
    if (!Array.isArray(r)) continue;
    const i = {};
    e.forEach((a, o) => {
      i[a] = r[o];
    }), n.push(i);
  }
  return { columns: e, rows: n };
}
function da(e) {
  const t = [];
  for (const r of e) {
    if (!r || typeof r != "object" || Array.isArray(r)) return null;
    t.push(r);
  }
  const n = t[0];
  return n ? { columns: Object.keys(n), rows: t } : null;
}
function fa(e) {
  return typeof e != "string" || !aa.test(e) && !sa.test(e) ? !1 : Me(e) !== null;
}
function gt(e) {
  return typeof e == "number" ? Number.isFinite(e) ? e : null : typeof e == "string" && oa.test(e) ? Number(e) : null;
}
function cn(e) {
  if (!e) return null;
  const { columns: t, rows: n } = e;
  if (n.length === 0 || n.length > ra) return null;
  const r = n.slice(0, ia), i = [];
  for (const f of t) {
    const h = r.map((b) => b[f]).filter((b) => b != null);
    if (h.length < r.length * 0.5) continue;
    const m = h.length * 0.95, y = h.filter(fa).length, v = h.filter((b) => gt(b) !== null).length;
    y >= m ? i.push({ name: f, kind: "time", distinct: 0, nonNull: h.length }) : v >= m ? i.push({ name: f, kind: "numeric", distinct: 0, nonNull: h.length }) : h.every((b) => typeof b == "string") ? i.push({
      name: f,
      kind: "categorical",
      distinct: new Set(h).size,
      nonNull: h.length
    }) : i.push({ name: f, kind: "other", distinct: 0, nonNull: h.length });
  }
  if (i.some((f) => f.kind === "other")) return null;
  const a = i.filter((f) => f.kind === "time"), o = i.filter((f) => f.kind === "numeric"), l = i.filter((f) => f.kind === "categorical"), c = a[0], u = l[0];
  if (a.length === 1 && c) {
    if (o.length === 1 && l.length === 1 && u && u.distinct >= 2 && u.distinct <= 8) {
      const f = o[0];
      return f ? ha(n, c.name, f.name, u.name) : null;
    }
    return o.length >= 1 && o.length <= 8 && n.length >= 2 && l.every((f) => f.distinct <= 1) ? ma(n, c.name, o) : null;
  }
  return a.length === 0 && l.length === 1 && u && u.distinct >= u.nonNull * 0.9 && o.length >= 1 && o.length <= 4 && n.length <= 30 ? pa(n, u.name, o) : null;
}
function ha(e, t, n, r) {
  const i = /* @__PURE__ */ new Map();
  for (const o of e) {
    const l = Me(o[t]), c = gt(o[n]), u = o[r];
    if (l === null || c === null || typeof u != "string") continue;
    let f = i.get(u);
    f || (f = [], i.set(u, f)), f.push({ t: l, v: c });
  }
  const a = [...i.entries()].map(([o, l]) => ({
    label: o,
    points: Le(l)
  }));
  return or(a) ? { kind: "timeseries", title: null, series: a } : null;
}
function ma(e, t, n) {
  const r = [];
  for (const i of n) {
    const a = [];
    for (const o of e) {
      const l = Me(o[t]), c = gt(o[i.name]);
      l !== null && c !== null && a.push({ t: l, v: c });
    }
    a.length > 0 && r.push({ label: i.name, points: Le(a) });
  }
  return or(r) ? { kind: "timeseries", title: null, series: r } : null;
}
function or(e) {
  return e.reduce((t, n) => t + n.points.length, 0) >= 2;
}
function pa(e, t, n) {
  const r = [];
  for (const a of e) {
    const o = a[t];
    typeof o == "string" && r.push({ category: o, row: a });
  }
  if (r.length === 0) return null;
  const i = n.map((a) => ({
    label: a.name,
    values: r.map(({ row: o }) => gt(o[a.name]))
  }));
  return i.some((a) => a.values.some((o) => o !== null)) ? {
    kind: "bars",
    title: null,
    categories: r.map(({ category: a }) => a),
    series: i
  } : null;
}
function ga(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  return "currentValue" in t ? {
    deviceName: typeof t.deviceName == "string" ? t.deviceName : null,
    streamName: typeof t.streamName == "string" ? t.streamName : null,
    streamType: typeof t.streamType == "string" ? t.streamType : null,
    t: Me(t.currentValueTime),
    value: t.currentValue
  } : null;
}
function ya(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  return !("value" in t) || !("streamName" in t) ? null : {
    deviceName: typeof t.deviceName == "string" ? t.deviceName : null,
    streamName: typeof t.streamName == "string" ? t.streamName : null,
    streamType: null,
    t: Me(t.timestamp),
    value: t.value
  };
}
function un(e, t) {
  var f;
  const n = e.map(t).filter((h) => h !== null);
  if (n.length === 0) return null;
  const i = n.map((h) => ({
    ...h,
    tile: ba(h.value, h.streamType)
  })).filter(
    (h) => h.tile !== null
  );
  if (i.length === 0) return null;
  const [a] = i;
  if (i.length === 1 && (a == null ? void 0 : a.tile.type) === "json")
    return {
      kind: "record",
      title: Bt(a.deviceName, a.streamName),
      field: null,
      samples: [{ t: a.t, value: a.tile.value }]
    };
  if (i.every((h) => h.tile.type === "location"))
    return { kind: "map", title: null, points: i.map((m) => {
      const y = m.tile;
      return {
        latitude: y.latitude,
        longitude: y.longitude,
        t: m.t,
        label: m.deviceName ?? m.streamName ?? void 0
      };
    }), variant: "markers" };
  const o = new Set(i.map((h) => h.deviceName)).size > 1, l = i.map((h) => ({
    label: h.streamName ?? "value",
    sublabel: o ? h.deviceName ?? void 0 : void 0,
    t: h.t,
    value: h.tile
  }));
  return { kind: "values", title: new Set(i.map((h) => h.deviceName)).size === 1 ? ((f = i[0]) == null ? void 0 : f.deviceName) ?? null : null, tiles: l };
}
function lr(e) {
  if (typeof e == "number") return "numeric";
  if (typeof e == "string") return Wt(e) ? "json" : "text";
  if (Array.isArray(e)) {
    const n = e[0];
    return n && typeof n == "object" && typeof n.value == "number" ? "numeric-set" : "unknown";
  }
  if (!e || typeof e != "object") return "unknown";
  const t = e;
  return typeof t.latitude == "number" && typeof t.longitude == "number" ? "location" : Array.isArray(t.keys) && Array.isArray(t.values) ? "bitset" : typeof t.percentage == "number" ? "battery" : typeof t.status == "string" && Object.keys(t).length <= 2 ? "health" : typeof t.url == "string" ? typeof t.duration == "number" || typeof t.mimeType == "string" ? "video" : typeof t.filename == "string" || "worldToLocal" in t ? "unknown" : "image" : "unknown";
}
function ba(e, t) {
  switch (va(t) ?? lr(e)) {
    case "numeric":
      return typeof e == "number" ? { type: "numeric", value: e } : null;
    case "text":
      return typeof e == "string" ? { type: "text", value: e } : null;
    case "battery": {
      const r = e;
      return typeof (r == null ? void 0 : r.percentage) == "number" ? {
        type: "battery",
        percentage: r.percentage,
        voltage: typeof r.voltage == "number" ? r.voltage : void 0
      } : null;
    }
    case "health": {
      const r = e;
      return typeof (r == null ? void 0 : r.status) == "string" ? { type: "health", status: r.status } : null;
    }
    case "bitset": {
      const r = e, i = Array.isArray(r == null ? void 0 : r.keys) ? r.keys : null, a = Array.isArray(r == null ? void 0 : r.values) ? r.values : null;
      if (!i || !a) return null;
      const o = i.map(
        (l, c) => typeof l == "string" && typeof a[c] == "boolean" ? { key: l, value: a[c] === !0 } : null
      ).filter((l) => l !== null);
      return o.length > 0 ? { type: "bitset", entries: o } : null;
    }
    case "numeric-set": {
      if (!Array.isArray(e)) return null;
      const r = [];
      for (const i of e) {
        if (!i || typeof i != "object") continue;
        const a = i;
        typeof a.value == "number" && r.push({
          label: typeof a.label == "string" ? a.label : "value",
          value: a.value,
          unit: typeof a.unit == "string" ? a.unit : void 0
        });
      }
      return r.length > 0 ? { type: "numeric-set", entries: r } : null;
    }
    case "location": {
      const r = e;
      return cr(r == null ? void 0 : r.latitude, r == null ? void 0 : r.longitude) ? { type: "location", latitude: r.latitude, longitude: r.longitude } : null;
    }
    case "image": {
      const r = e;
      return ht(r == null ? void 0 : r.url) ? { type: "image", url: r.url } : null;
    }
    case "video": {
      const r = e;
      return ht(r == null ? void 0 : r.url) ? {
        type: "video",
        url: r.url,
        durationMs: typeof r.duration == "number" ? r.duration : null,
        mimeType: typeof r.mimeType == "string" ? r.mimeType : "video/mp4"
      } : null;
    }
    case "json": {
      const r = Wt(e);
      return r ? { type: "json", value: r } : null;
    }
    default:
      return null;
  }
}
function va(e) {
  switch (e) {
    case "numeric":
      return "numeric";
    case "numeric set":
      return "numeric-set";
    case "location":
      return "location";
    case "image":
      return "image";
    case "video":
      return "video";
    case "bitset":
      return "bitset";
    case "battery":
      return "battery";
    case "health":
      return "health";
    case "text":
      return "text";
    case "json":
      return "json";
    default:
      return e === null ? null : "unknown";
  }
}
function Wt(e) {
  if (e !== null && typeof e == "object") return e;
  if (typeof e != "string") return null;
  const t = e.trim();
  if (!t.startsWith("{") && !t.startsWith("[")) return null;
  try {
    const n = JSON.parse(t);
    return n !== null && typeof n == "object" ? n : null;
  } catch {
    return null;
  }
}
function ht(e) {
  return typeof e == "string" && (e.startsWith("https://") || e.startsWith("http://"));
}
function cr(e, t) {
  return typeof e == "number" && typeof t == "number" && Number.isFinite(e) && Number.isFinite(t) && Math.abs(e) <= 90 && Math.abs(t) <= 180;
}
const wa = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;
function Me(e) {
  if (typeof e == "number" && Number.isFinite(e)) return e;
  if (typeof e != "string" || !e) return null;
  const t = wa.test(e) ? `${e.replace(" ", "T")}Z` : e, n = Date.parse(t);
  return Number.isNaN(n) ? null : n;
}
function Le(e) {
  return [...e].sort((t, n) => t.t - n.t);
}
function ka(e) {
  return [...e].sort((t, n) => (t.t ?? 0) - (n.t ?? 0));
}
function Bt(e, t) {
  return e && t ? `${e} · ${t}` : e ?? t;
}
const ur = "Rejected — do not proceed.";
function _a({
  options: e,
  capabilities: t
}) {
  if (e.length > 0)
    return t.accept ? e.map((r, i) => ({
      key: r.id,
      label: r.label,
      description: r.description,
      primary: i === 0,
      body: { action: "accept", optionId: r.id }
    })) : [];
  const n = [];
  return t.accept && n.push({ key: "approve", label: "Approve", primary: !0, body: { action: "accept" } }), t.respond && n.push({
    key: "reject",
    label: "Reject",
    primary: !1,
    body: { action: "respond", text: ur }
  }), n;
}
const dr = je(null), Na = dr.Provider;
function xa() {
  return Ee(dr);
}
function Be(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e) ? e : null;
}
function Ca(e) {
  const t = Be(e);
  if (!t) return {};
  const n = Be(t.input) ?? Be(t.context);
  return n && (typeof n.question == "string" || Array.isArray(n.options)) ? n : t;
}
function Sa(e) {
  let t = e;
  for (let n = 0; n < 6; n += 1) {
    if (typeof t == "string") {
      const i = t.trim();
      if (!i) return null;
      try {
        t = JSON.parse(i);
        continue;
      } catch {
        return null;
      }
    }
    const r = Be(t);
    if (!r) return null;
    if (typeof r.elicitationId == "string" && r.elicitationId.length > 0)
      return r.elicitationId;
    if ((r.type === "json" || r.type === "text") && r.value !== void 0) {
      t = r.value;
      continue;
    }
    if (r.output !== void 0 && r.output !== r) {
      t = r.output;
      continue;
    }
    if (r.result !== void 0 && r.result !== r && r.elicitationId === void 0) {
      t = r.result;
      continue;
    }
    return null;
  }
  return null;
}
function Ma(e) {
  return Array.isArray(e) ? e.filter((t) => t && typeof t.id == "string" && typeof t.label == "string").map((t) => ({
    id: t.id,
    label: t.label,
    description: typeof t.description == "string" ? t.description : void 0
  })) : [];
}
function $a(e) {
  if (e.name !== "request_human_input" || e.isError) return null;
  const t = Ca(e.args), n = typeof t.question == "string" ? t.question : "", r = Sa(e.result) ?? "";
  return !r && !n ? null : { elicitationId: r, question: n, options: Ma(t.options) };
}
const Ta = { accept: !0, respond: !0 };
function Ia(e) {
  var n;
  if (Array.isArray(e)) return e;
  const t = (n = Be(e)) == null ? void 0 : n.items;
  return Array.isArray(t) ? t : [];
}
const Ra = 8, fr = (e) => e.type === "text" ? e.value ?? "" : (e.children ?? []).map(fr).join("");
function Aa({ node: e, children: t, ...n }) {
  var f, h, m;
  const [r, i] = A(!1), a = (f = e == null ? void 0 : e.children) == null ? void 0 : f.find((y) => y.tagName === "code"), o = a ? fr(a).replace(/\n$/, "") : "", l = o ? o.split(`
`).length : 0;
  if (l <= Ra) return /* @__PURE__ */ s("pre", { ...n, children: t });
  const c = (h = a == null ? void 0 : a.properties) == null ? void 0 : h.className, u = (m = (Array.isArray(c) ? c : []).map(String).find((y) => y.startsWith("language-"))) == null ? void 0 : m.slice(9);
  return /* @__PURE__ */ d("div", { className: "pa-elicitation-card__script", "data-open": r, children: [
    /* @__PURE__ */ d("div", { className: "pa-elicitation-card__script-head", children: [
      /* @__PURE__ */ d("span", { className: "pa-elicitation-card__script-summary", children: [
        u ?? "script",
        " · ",
        l,
        " lines"
      ] }),
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: "pa-elicitation-card__script-toggle",
          "aria-expanded": r,
          onClick: () => i((y) => !y),
          children: r ? "Hide script" : "Show script"
        }
      )
    ] }),
    r ? /* @__PURE__ */ s("pre", { ...n, children: t }) : null
  ] });
}
const za = { pre: Aa }, Pa = /<<-?[ \t]*(['"]?)(\w+)\1[ \t]*\n([\s\S]*?)\n\2(?=\s|$)/g, Da = (e) => e.includes("```") ? e : e.replace(
  Pa,
  (t, n, r, i) => `<<${n}${r}${n}

\`\`\`${/^py/i.test(r) ? "python" : ""}
${i}
\`\`\`

${r}`
);
function Ea({ elicitationId: e, question: t, options: n }) {
  var T;
  const r = pt(), i = xa(), [a, o] = A("PENDING"), [l, c] = A(null), [u, f] = A(null), [h, m] = A(null), [y, v] = A([]), [b, C] = A(Ta), g = i ? `v1/persistent-agent-groups/${i.groupId}/agents/${i.threadId}/elicitations` : null, [M, $] = A(e);
  U(() => {
    e && $(e);
  }, [e]);
  const _ = J(async () => {
    if (g)
      try {
        const R = Ia(await r.http.get(g).json()), w = (M ? R.find((k) => k.id === M) : void 0) ?? R.find((k) => k.status === "PENDING" && k.question === t) ?? R.find((k) => k.status === "PENDING");
        w && ($(w.id), o(w.status), c(w.decision ?? null), w.options && v(w.options), w.capabilities && C(w.capabilities));
      } catch {
      }
  }, [r, g, M, t]);
  U(() => {
    _().catch(() => {
    });
  }, [_]);
  const P = n.length > 0 ? n : y, j = _a({ options: P, capabilities: b }), x = async (R) => {
    if (!(!g || u || !M)) {
      f(R.key), m(null);
      try {
        await r.http.post(`${g}/${M}/answer`, { json: R.body }), o("ANSWERED"), c(R.body);
      } catch (w) {
        m(w instanceof Error ? w.message : "Could not record the decision");
      } finally {
        f(null);
      }
    }
  }, N = (l == null ? void 0 : l.text) === ur || !!(l != null && l.optionId) && /reject|keep|no|discard/i.test(l.optionId), S = a === "ANSWERED" ? ((T = P.find((R) => R.id === (l == null ? void 0 : l.optionId))) == null ? void 0 : T.label) ?? (N ? "Rejected" : null) ?? ((l == null ? void 0 : l.action) === "accept" ? "Approved" : null) ?? (l == null ? void 0 : l.text) ?? "Answered" : null;
  return /* @__PURE__ */ d(
    "div",
    {
      className: "pa-elicitation-card",
      "data-status": a === "ANSWERED" ? N ? "REJECTED" : "APPROVED" : a,
      role: "group",
      "aria-label": "Decision requested",
      children: [
        /* @__PURE__ */ s("div", { className: "pa-elicitation-card__head", children: /* @__PURE__ */ s("span", { className: "pa-elicitation-card__badge", children: a === "PENDING" ? "Awaiting your decision" : a === "ANSWERED" ? `Decided · ${S}` : a.toLowerCase() }) }),
        /* @__PURE__ */ s("div", { className: "pa-elicitation-card__body", children: /* @__PURE__ */ s(Dn, { remarkPlugins: [En], components: za, children: Da(t) }) }),
        a === "PENDING" && j.length > 0 ? /* @__PURE__ */ s("div", { className: "pa-elicitation-card__actions", children: j.map((R) => /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: R.primary ? "btn btn--primary btn--sm" : "btn btn--ghost btn--sm",
            disabled: !g || !M || u !== null,
            title: R.description,
            onClick: () => {
              x(R).catch(() => {
              });
            },
            children: u === R.key ? "Recording…" : R.label
          },
          R.key
        )) }) : null,
        h ? /* @__PURE__ */ s("div", { className: "pa-elicitation-card__error", children: h }) : null
      ]
    }
  );
}
const hr = je(null), ja = hr.Provider;
function La() {
  return Ee(hr);
}
function mr({ refs: e }) {
  const t = La(), n = e.join(`
`), r = Q(() => n ? n.split(`
`) : [], [n]), [i, a] = A(null);
  return U(() => {
    if (a(null), !t || r.length === 0) return;
    let o = !1;
    const l = [];
    return Promise.all(r.map((c) => t.fetchImage(c).catch(() => null))).then((c) => {
      const u = [];
      for (const f of c)
        f && u.push(URL.createObjectURL(f));
      if (o) {
        for (const f of u) URL.revokeObjectURL(f);
        return;
      }
      l.push(...u), a(u);
    }).catch(() => {
    }), () => {
      o = !0;
      for (const c of l) URL.revokeObjectURL(c);
    };
  }, [t, r]), !t || r.length === 0 ? null : i === null ? /* @__PURE__ */ s("div", { className: "pa-chat-tool-images", "aria-hidden": "true", children: r.map((o) => /* @__PURE__ */ s("span", { className: "pa-chat-tool-image-placeholder" }, o)) }) : i.length === 0 ? null : /* @__PURE__ */ s(Ft, { images: i });
}
const Oa = 8, dn = 864e5;
function st(e) {
  return `var(--chart-${e % Oa + 1})`;
}
function pr(e, t) {
  const n = Math.abs(e), r = n >= 100 ? 0 : n >= 1 ? 1 : 3;
  return `${e.toFixed(r)}${t ? ` ${t}` : ""}`;
}
function gr(e, t) {
  const n = Math.abs(e);
  if (n >= 1e4) return `${(e / 1e3).toFixed(0)}k`;
  if (n >= 1e3) return `${(e / 1e3).toFixed(1)}k`;
  if (Number.isInteger(e)) return String(e);
  const r = t ? Math.max(0, Math.ceil(-Math.log10(t) - 1e-9)) : n >= 1 ? 1 : 2;
  return String(parseFloat(e.toFixed(r)));
}
function yr(e, t, n, r) {
  const i = new Date(e);
  return n !== void 0 && n >= dn && e % dn === 0 ? i.toLocaleString(void 0, { timeZone: "UTC", month: "short", day: "numeric" }) : t > 24 * 36e5 ? i.toLocaleString(void 0, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZone: r
  }) : i.toLocaleTimeString(void 0, { hour: "numeric", minute: "2-digit", timeZone: r });
}
function Tt(e, t, n = 3) {
  if (t === e) return { ticks: [e, e + 1], top: e + 1 };
  const i = (t - e) / n, a = 10 ** Math.floor(Math.log10(i)), o = i / a, l = (o < 1.5 ? 1 : o < 3.5 ? 2 : o < 7.5 ? 5 : 10) * a, c = Math.ceil(e / l) * l, u = Math.ceil(t / l) * l, f = [];
  for (let h = c; h <= u + l / 2; h += l)
    f.push(parseFloat(h.toPrecision(12)));
  return { ticks: f, top: u };
}
const We = 132, Fa = 18, fn = We + Fa, Wa = 560, Ie = 6, Ba = 12;
function Ka({ model: e }) {
  var S;
  const t = z(null), [n, r] = A(Wa), [i, a] = A(null);
  U(() => {
    const p = t.current;
    if (!p) return;
    const T = new ResizeObserver((R) => {
      var k;
      const w = (k = R[0]) == null ? void 0 : k.contentRect.width;
      w && w > 0 && r(Math.round(w));
    });
    return T.observe(p), () => T.disconnect();
  }, []);
  const { categories: o } = e, l = e.series.filter((p) => p.values.some((T) => T !== null));
  if (o.length === 0 || l.length === 0) return null;
  const c = l.flatMap((p) => p.values).filter((p) => p !== null), u = Math.min(...c, 0), { ticks: f, top: h } = Tt(u, Math.max(...c, 0)), m = (f[1] ?? 0) - (f[0] ?? 0) || void 0, y = (p) => {
    const T = (p - u) / (h - u || 1);
    return We - T * (We - Ba);
  }, v = y(0), b = (n - 2 * Ie) / o.length, C = b * 0.7, g = C / l.length, M = Math.max(4, Math.floor(b / 6.5)), _ = new Set(l.map((p) => p.unit ?? "")).size === 1 ? ((S = l[0]) == null ? void 0 : S.unit) ?? "" : "", P = i === null ? null : o[i] ?? null, j = 200, x = i === null ? null : Ie + i * b + b / 2, N = x === null ? null : x + 12 + j > n ? Math.max(0, x - 12 - j) : x + 12;
  return /* @__PURE__ */ d("div", { className: "fleet-viz__chart", children: [
    /* @__PURE__ */ s("div", { className: "fleet-viz__legend", children: l.map((p, T) => /* @__PURE__ */ d("span", { className: "fleet-viz__legend-item", children: [
      /* @__PURE__ */ s("span", { className: "fleet-viz__legend-swatch", style: { background: st(T) } }),
      p.label,
      p.unit ? ` (${p.unit})` : ""
    ] }, p.label)) }),
    /* @__PURE__ */ d("div", { ref: t, style: { position: "relative" }, children: [
      /* @__PURE__ */ d(
        "svg",
        {
          width: n,
          height: fn,
          viewBox: `0 0 ${n} ${fn}`,
          style: { display: "block" },
          role: "img",
          "aria-label": `Bar chart: ${l.map((p) => p.label).join(", ")} by ${o.length} categories`,
          onMouseLeave: () => a(null),
          onMouseMove: (p) => {
            const T = p.currentTarget.getBoundingClientRect(), R = p.clientX - T.left, w = Math.floor((R - Ie) / b);
            a(Math.min(Math.max(w, 0), o.length - 1));
          },
          children: [
            f.map((p, T) => {
              const R = y(p), w = T === 0 && p === 0;
              return /* @__PURE__ */ d("g", { children: [
                /* @__PURE__ */ s(
                  "line",
                  {
                    x1: 0,
                    x2: n,
                    y1: R,
                    y2: R,
                    stroke: "var(--border-subtle)",
                    strokeWidth: 1,
                    strokeOpacity: w ? 0.9 : 0.35,
                    vectorEffect: "non-scaling-stroke"
                  }
                ),
                w ? null : /* @__PURE__ */ d("text", { x: 4, y: R - 3, className: "fleet-viz__axis-label", children: [
                  gr(p, m),
                  T === f.length - 1 && _ ? ` ${_}` : ""
                ] })
              ] }, `y-${p}`);
            }),
            i !== null ? /* @__PURE__ */ s(
              "rect",
              {
                x: Ie + i * b,
                y: 0,
                width: b,
                height: We,
                fill: "var(--text-secondary)",
                opacity: 0.08
              }
            ) : null,
            o.map((p, T) => {
              const R = Ie + T * b + (b - C) / 2;
              return /* @__PURE__ */ d("g", { children: [
                l.map((w, k) => {
                  const F = w.values[T];
                  if (F == null) return null;
                  const B = y(F);
                  return /* @__PURE__ */ s(
                    "rect",
                    {
                      x: R + k * g,
                      y: Math.min(B, v),
                      width: Math.max(g - 1, 1),
                      height: Math.abs(B - v),
                      fill: st(k)
                    },
                    w.label
                  );
                }),
                /* @__PURE__ */ d(
                  "text",
                  {
                    x: Ie + T * b + b / 2,
                    y: We + 13,
                    textAnchor: "middle",
                    className: "fleet-viz__axis-label",
                    children: [
                      /* @__PURE__ */ s("title", { children: p }),
                      p.length > M ? `${p.slice(0, M - 1)}…` : p
                    ]
                  }
                )
              ] }, `bars-${p}-${T}`);
            })
          ]
        }
      ),
      i !== null && P !== null && N !== null ? /* @__PURE__ */ d(
        "div",
        {
          className: "fleet-viz__hover-pane",
          role: "tooltip",
          style: { left: N, width: j },
          children: [
            /* @__PURE__ */ s("div", { className: "fleet-viz__hover-time", children: P }),
            l.map((p, T) => {
              const R = p.values[i];
              return /* @__PURE__ */ d("div", { className: "fleet-viz__hover-row", children: [
                /* @__PURE__ */ d("span", { className: "fleet-viz__hover-label", children: [
                  /* @__PURE__ */ s(
                    "span",
                    {
                      className: "fleet-viz__legend-swatch",
                      style: { background: st(T) }
                    }
                  ),
                  p.label
                ] }),
                /* @__PURE__ */ s("span", { className: "fleet-viz__hover-value", children: R != null ? pr(R, p.unit) : "—" })
              ] }, p.label);
            })
          ]
        }
      ) : null
    ] })
  ] });
}
const hn = { yaw: 0, pitch: Math.PI / 2 }, mn = { yaw: -Math.PI / 5, pitch: Math.PI / 5 }, Ua = 5 * Math.PI / 180, Ha = Math.PI / 2;
function br([e, t, n], r) {
  const i = Math.cos(r.yaw), a = Math.sin(r.yaw), o = e * i - t * a, l = e * a + t * i, c = Math.sin(r.pitch), u = Math.cos(r.pitch);
  return { sx: -l, sy: o * c + n * u, depth: -o * u + n * c };
}
function Ga([e, t, n, r], [i, a, o]) {
  const l = 2 * (t * o - n * a), c = 2 * (n * i - e * o), u = 2 * (e * a - t * i);
  return [
    i + r * l + (t * u - n * c),
    a + r * c + (n * l - e * u),
    o + r * u + (e * c - t * l)
  ];
}
function qa(e, t, n, r, i = 24) {
  if (e.length === 0) return { scale: 100, cx: 0, cy: 0 };
  let a = 1 / 0, o = -1 / 0, l = 1 / 0, c = -1 / 0;
  for (const m of e) {
    const { sx: y, sy: v } = br(m, t);
    y < a && (a = y), y > o && (o = y), v < l && (l = v), v > c && (c = v);
  }
  const u = Math.max(o - a, 0.2), f = Math.max(c - l, 0.2);
  return { scale: Math.min((n - 2 * i) / u, (r - 2 * i) / f), cx: (a + o) / 2, cy: (l + c) / 2 };
}
function Va(e, t, n, r) {
  return [n / 2 + (e.sx - t.cx) * t.scale, r / 2 - (e.sy - t.cy) * t.scale];
}
function Kt(e) {
  if (e.length === 0) return { x: 0, y: 0, z: 0 };
  let [t, n, r] = [1 / 0, 1 / 0, 1 / 0], [i, a, o] = [-1 / 0, -1 / 0, -1 / 0];
  for (const [l, c, u] of e)
    t = Math.min(t, l), n = Math.min(n, c), r = Math.min(r, u), i = Math.max(i, l), a = Math.max(a, c), o = Math.max(o, u);
  return { x: i - t, y: a - n, z: o - r };
}
function pn(e) {
  const t = Math.min(1, Math.max(0, e)), n = 55 + t * 175, r = 58 - t * 8;
  return `hsl(${n.toFixed(0)} 80% ${r.toFixed(0)}%)`;
}
function Ja(e) {
  return [0.1, 0.25, 0.5, 1, 2, 5, 10, 25, 50, 100].find((n) => e / n <= 10) ?? 100;
}
function vr(e, t = 0.6) {
  if (e.length <= 2) return e;
  const n = /* @__PURE__ */ new Map();
  for (const h of e) n.set(h.parent, [...n.get(h.parent) ?? [], h]);
  const r = /* @__PURE__ */ new Map(), i = (h, m) => {
    if (m.has(h.name)) return 0;
    m.add(h.name);
    const y = 1 + (n.get(h.name) ?? []).reduce((v, b) => v + i(b, m), 0);
    return r.set(h.name, y), y;
  }, a = n.get(null) ?? [];
  for (const h of a) i(h, /* @__PURE__ */ new Set());
  const o = (h, m) => (r.get(m.name) ?? 0) - (r.get(h.name) ?? 0), l = [...a].sort(o)[0];
  if (!l) return e;
  let c = l;
  for (; ; ) {
    const h = [...n.get(c.name) ?? []].sort(o)[0];
    if (!h || (r.get(h.name) ?? 0) < t * e.length) break;
    c = h;
  }
  const u = [], f = (h, m) => {
    if (!m.has(h.name)) {
      m.add(h.name), u.push(h);
      for (const y of n.get(h.name) ?? []) f(y, m);
    }
  };
  return f(c, /* @__PURE__ */ new Set()), u.length >= 2 ? u : e;
}
const Ke = 320, Xa = 560, kt = ["#e5484d", "#30a46c", "#3e63dd"];
function Ya({ geometry: e }) {
  const t = z(null), n = z(null), [r, i] = A(Xa), a = e.kind === "scan" || e.kind === "path" ? hn : mn, [o, l] = A(a), [c, u] = A(1), [f, h] = A(e.frames.length > 0 && e.frames.length <= 24), m = z(null);
  U(() => {
    const g = t.current;
    if (!g) return;
    const M = new ResizeObserver(($) => {
      var P;
      const _ = (P = $[0]) == null ? void 0 : P.contentRect.width;
      _ && _ > 0 && i(Math.round(_));
    });
    return M.observe(g), () => M.disconnect();
  }, []);
  const y = Q(() => Qa(e), [e]);
  U(() => {
    const g = n.current;
    if (!g) return;
    const M = window.devicePixelRatio || 1;
    g.width = Math.round(r * M), g.height = Math.round(Ke * M);
    const $ = g.getContext("2d");
    $ && ($.setTransform(M, 0, 0, M, 0, 0), es($, y, e, o, c, f, r, Za(t.current)));
  }, [y, e, o, c, f, r]);
  const v = (g) => {
    g.currentTarget.setPointerCapture(g.pointerId), m.current = { x: g.clientX, y: g.clientY, view: o };
  }, b = (g) => {
    const M = m.current;
    if (!M) return;
    const $ = M.view.yaw - (g.clientX - M.x) * 0.01, _ = Math.min(Ha, Math.max(Ua, M.view.pitch + (g.clientY - M.y) * 0.01));
    l({ yaw: $, pitch: _ });
  }, C = () => {
    m.current = null;
  };
  return /* @__PURE__ */ d("div", { className: "fleet-viz__geometry", ref: t, children: [
    /* @__PURE__ */ s(
      "canvas",
      {
        ref: n,
        className: "fleet-viz__geometry-canvas",
        style: { width: r, height: Ke },
        role: "img",
        "aria-label": gn(e),
        onPointerDown: v,
        onPointerMove: b,
        onPointerUp: C,
        onPointerCancel: C,
        onDoubleClick: () => {
          l(a), u(1);
        }
      }
    ),
    /* @__PURE__ */ d("div", { className: "fleet-viz__geometry-bar", children: [
      /* @__PURE__ */ s("span", { className: "fleet-viz__geometry-caption", children: gn(e) }),
      /* @__PURE__ */ d("span", { className: "fleet-viz__geometry-controls", children: [
        /* @__PURE__ */ s("button", { type: "button", onClick: () => l(hn), children: "Top" }),
        /* @__PURE__ */ s("button", { type: "button", onClick: () => l(mn), children: "3D" }),
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            "aria-label": "Zoom out",
            onClick: () => u((g) => Math.max(0.25, g / 1.5)),
            children: "−"
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            "aria-label": "Zoom in",
            onClick: () => u((g) => Math.min(20, g * 1.5)),
            children: "+"
          }
        ),
        e.kind === "tf" ? /* @__PURE__ */ s("button", { type: "button", "aria-pressed": f, onClick: () => h((g) => !g), children: "Labels" }) : null
      ] })
    ] })
  ] });
}
function Qa(e) {
  if (e.kind === "tf") {
    const n = vr(e.frames), r = Kt(n.map((o) => o.position)), i = Math.min(0.5, Math.max(0.02, Math.max(r.x, r.y, r.z) * 0.15)), a = [];
    for (const o of n) {
      a.push(o.position);
      for (const l of wr(o, i)) a.push(l);
    }
    return { bounds: a, shade: [], axis: i };
  }
  let t;
  if (e.kind === "scan") {
    const n = e.points.map(([i, a]) => Math.hypot(i, a)), r = Math.max(...n, 1e-6);
    t = n.map((i) => i / r);
  } else if (e.kind === "cloud") {
    const n = e.points.map((a) => a[2]), r = Math.min(...n), i = Math.max(...n) - r || 1;
    t = n.map((a) => (a - r) / i);
  } else
    t = e.points.map((n, r) => r / Math.max(1, e.points.length - 1));
  return { bounds: [...e.points, [0, 0, 0]], shade: t, axis: 0 };
}
function wr(e, t) {
  return [
    [t, 0, 0],
    [0, t, 0],
    [0, 0, t]
  ].map((n) => {
    const r = Ga(e.rotation, n);
    return [e.position[0] + r[0], e.position[1] + r[1], e.position[2] + r[2]];
  });
}
function Za(e) {
  const t = e ? getComputedStyle(e) : null, n = (r, i) => (t == null ? void 0 : t.getPropertyValue(r).trim()) || i;
  return {
    grid: n("--border-subtle", "rgba(128,128,128,0.25)"),
    text: n("--text-secondary", "#8a8f98"),
    muted: n("--text-muted", "#6b7079"),
    link: n("--text-muted", "#6b7079")
  };
}
function es(e, t, n, r, i, a, o, l) {
  e.clearRect(0, 0, o, Ke);
  const c = qa(t.bounds, r, o, Ke), u = { ...c, scale: c.scale * i }, f = (m) => Va(br(m, r), u, o, Ke);
  if (ts(e, t.bounds, f, l), n.kind === "tf") {
    is(e, n.frames, t.axis, f, a, l);
    return;
  }
  const h = n.points.length > 4e3 ? 1.2 : n.points.length > 800 ? 1.8 : 2.6;
  n.kind === "path" ? (e.lineWidth = 2, n.points.forEach((m, y) => {
    const v = n.points[y - 1];
    if (!v) return;
    const [b, C] = f(v), [g, M] = f(m);
    e.strokeStyle = pn(t.shade[y] ?? 0), e.beginPath(), e.moveTo(b, C), e.lineTo(g, M), e.stroke();
  }), rs(e, n.points, f, l)) : n.points.forEach((m, y) => {
    const [v, b] = f(m);
    e.fillStyle = pn(t.shade[y] ?? 0), e.fillRect(v - h / 2, b - h / 2, h, h);
  }), ns(e, n.kind, f, l);
}
function ts(e, t, n, r) {
  const i = Kt(t), a = Math.max(i.x, i.y, 0.2), o = Ja(a);
  let l = 1 / 0, c = -1 / 0, u = 1 / 0, f = -1 / 0;
  for (const [g, M] of t)
    l = Math.min(l, g), c = Math.max(c, g), u = Math.min(u, M), f = Math.max(f, M);
  const h = Math.floor(l / o) * o, m = Math.ceil(c / o) * o, y = Math.floor(u / o) * o, v = Math.ceil(f / o) * o;
  e.strokeStyle = r.grid, e.lineWidth = 1, e.beginPath();
  for (let g = h; g <= m + 1e-9; g += o) {
    const [M, $] = n([g, y, 0]), [_, P] = n([g, v, 0]);
    e.moveTo(M, $), e.lineTo(_, P);
  }
  for (let g = y; g <= v + 1e-9; g += o) {
    const [M, $] = n([h, g, 0]), [_, P] = n([m, g, 0]);
    e.moveTo(M, $), e.lineTo(_, P);
  }
  e.stroke(), e.fillStyle = r.muted, e.font = "10px ui-monospace, SFMono-Regular, Menlo, monospace";
  const [b, C] = n([h, y, 0]);
  e.fillText(
    `grid ${o < 1 ? `${o * 100} cm` : `${o} m`}`,
    Math.min(b, 8) + 6,
    Math.max(C, 16)
  );
}
function ns(e, t, n, r) {
  const [i, a] = n([0, 0, 0]), [o, l] = n([0.25, 0, 0]), c = Math.atan2(l - a, o - i), u = 7;
  e.fillStyle = r.text, e.beginPath(), e.moveTo(i + Math.cos(c) * u * 1.6, a + Math.sin(c) * u * 1.6), e.lineTo(i + Math.cos(c + 2.5) * u, a + Math.sin(c + 2.5) * u), e.lineTo(i + Math.cos(c - 2.5) * u, a + Math.sin(c - 2.5) * u), e.closePath(), e.fill(), e.font = "10px ui-monospace, SFMono-Regular, Menlo, monospace", e.fillText(t === "path" ? "origin" : "sensor", i + 10, a + 14);
}
function rs(e, t, n, r) {
  const i = t[0], a = t[t.length - 1];
  if (!i || !a) return;
  if (e.font = "10px ui-monospace, SFMono-Regular, Menlo, monospace", Math.hypot(a[0] - i[0], a[1] - i[1], a[2] - i[2]) < 0.01) {
    const [f, h] = n(a);
    e.fillStyle = r.text, e.beginPath(), e.arc(f, h, 5, 0, Math.PI * 2), e.fill(), e.fillText("robot", f + 8, h - 6);
    return;
  }
  const [o, l] = n(i);
  e.strokeStyle = r.text, e.lineWidth = 1.5, e.beginPath(), e.arc(o, l, 5, 0, Math.PI * 2), e.stroke();
  const [c, u] = n(a);
  e.fillStyle = r.text, e.beginPath(), e.arc(c, u, 5, 0, Math.PI * 2), e.fill(), e.font = "10px ui-monospace, SFMono-Regular, Menlo, monospace", e.fillText("start", o + 8, l - 6), e.fillText("now", c + 8, u - 6);
}
function is(e, t, n, r, i, a) {
  const o = new Map(t.map((c) => [c.name, c]));
  e.strokeStyle = a.link, e.lineWidth = 1, e.setLineDash([3, 3]), e.beginPath();
  for (const c of t) {
    const u = c.parent ? o.get(c.parent) : void 0;
    if (!u) continue;
    const [f, h] = r(u.position), [m, y] = r(c.position);
    e.moveTo(f, h), e.lineTo(m, y);
  }
  e.stroke(), e.setLineDash([]), e.lineWidth = 2;
  for (const c of t) {
    const [u, f] = r(c.position);
    wr(c, n).forEach((h, m) => {
      const [y, v] = r(h);
      e.strokeStyle = kt[m] ?? kt[0], e.beginPath(), e.moveTo(u, f), e.lineTo(y, v), e.stroke();
    }), e.fillStyle = c.parent ? a.text : kt[0], e.beginPath(), e.arc(u, f, c.parent ? 2.5 : 4, 0, Math.PI * 2), e.fill();
  }
  if (!i) return;
  e.fillStyle = a.text, e.font = "10px ui-monospace, SFMono-Regular, Menlo, monospace";
  const l = /* @__PURE__ */ new Map();
  for (const c of t) {
    const [u, f] = r(c.position), h = `${Math.round(u / 6)}:${Math.round(f / 6)}`, m = l.get(h) ?? 0;
    l.set(h, m + 1), e.fillText(c.name, u + 6, f - 4 + m * 11);
  }
}
function gn(e) {
  if (e.kind === "tf") {
    const r = e.frames.find((o) => !o.parent), i = vr(e.frames)[0];
    let a = "";
    if (r && i && i.name !== r.name) {
      const [o, l, c] = r.position, [u, f, h] = i.position, m = Math.hypot(u - o, f - l, h - c);
      a = ` · framed on ${i.name}, ${m.toFixed(2)} m from ${r.name}`;
    }
    return `${e.frames.length} frames · root ${(r == null ? void 0 : r.name) ?? "?"}${a} · drag to orbit`;
  }
  const t = Kt(e.points), n = `${t.x.toFixed(1)} × ${t.y.toFixed(1)}${e.kind === "cloud" ? ` × ${t.z.toFixed(1)}` : ""} m`;
  if (e.kind === "path") {
    let r = 0;
    e.points.forEach((a, o) => {
      const l = e.points[o - 1];
      l && (r += Math.hypot(a[0] - l[0], a[1] - l[1], a[2] - l[2]));
    });
    const i = e.points[e.points.length - 1];
    return r < 0.01 && i ? `${e.points.length} poses · stationary at (${i[0].toFixed(2)}, ${i[1].toFixed(2)}) m` : `${e.points.length} poses · travelled ${r.toFixed(2)} m · ${n}`;
  }
  return `${e.points.length} ${e.kind === "scan" ? "returns" : "points"} · ${n} · drag to orbit`;
}
const as = 8;
function ss({ items: e }) {
  const [t, n] = A(null), r = [...e].sort((o, l) => (l.t ?? 0) - (o.t ?? 0)), i = r.slice(0, as), a = r.length - i.length;
  return /* @__PURE__ */ d("div", { className: "fleet-viz__images", children: [
    i.map((o, l) => /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: `fleet-viz__image-thumb ${l === 0 ? "is-primary" : ""}`,
        onClick: () => n(l),
        title: o.t ? new Date(o.t).toLocaleString() : void 0,
        children: [
          /* @__PURE__ */ s("img", { src: o.url, alt: o.label ?? "Device camera frame", loading: "lazy" }),
          l === 0 && o.t ? /* @__PURE__ */ s("span", { className: "fleet-viz__image-time", children: new Date(o.t).toLocaleTimeString() }) : null
        ]
      },
      `${o.url}-${l}`
    )),
    a > 0 ? /* @__PURE__ */ d("span", { className: "fleet-viz__image-more", children: [
      "+",
      a,
      " more"
    ] }) : null,
    t !== null ? /* @__PURE__ */ s(os, { items: i, index: t, onIndex: n }) : null
  ] });
}
function os({
  items: e,
  index: t,
  onIndex: n
}) {
  const r = e[t];
  return U(() => {
    function i(a) {
      if (a.key === "Escape") {
        a.stopPropagation(), a.preventDefault(), n(null);
        return;
      }
      a.key === "ArrowLeft" && t > 0 && (a.stopPropagation(), n(t - 1)), a.key === "ArrowRight" && t < e.length - 1 && (a.stopPropagation(), n(t + 1));
    }
    return document.addEventListener("keydown", i, !0), () => document.removeEventListener("keydown", i, !0);
  }, [t, e.length, n]), r ? Et(
    /* @__PURE__ */ d(
      "div",
      {
        className: "fleet-viz__lightbox",
        role: "dialog",
        "aria-label": "Image viewer",
        onClick: () => n(null),
        children: [
          /* @__PURE__ */ s(
            "img",
            {
              src: r.url,
              alt: r.label ?? "Device camera frame",
              onClick: (i) => i.stopPropagation()
            }
          ),
          /* @__PURE__ */ d("div", { className: "fleet-viz__lightbox-caption", onClick: (i) => i.stopPropagation(), children: [
            r.t ? /* @__PURE__ */ s("span", { children: new Date(r.t).toLocaleString() }) : null,
            e.length > 1 ? /* @__PURE__ */ d("span", { className: "fleet-viz__lightbox-nav", children: [
              /* @__PURE__ */ s(
                "button",
                {
                  type: "button",
                  disabled: t === 0,
                  onClick: () => n(t - 1),
                  "aria-label": "Previous image",
                  children: "‹"
                }
              ),
              t + 1,
              " / ",
              e.length,
              /* @__PURE__ */ s(
                "button",
                {
                  type: "button",
                  disabled: t === e.length - 1,
                  onClick: () => n(t + 1),
                  "aria-label": "Next image",
                  children: "›"
                }
              )
            ] }) : null,
            /* @__PURE__ */ s("a", { href: r.url, target: "_blank", rel: "noreferrer", children: "Open original ↗" })
          ] }),
          /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: "fleet-viz__lightbox-close",
              "aria-label": "Close image viewer",
              onClick: () => n(null),
              children: "✕"
            }
          )
        ]
      }
    ),
    document.body
  ) : null;
}
const le = 132, ls = 18, yn = le + ls, cs = 560, nt = 6, _t = 12, Nt = 500;
function us(e) {
  if (e.length <= Nt) return e;
  const t = e.length / Nt, n = [];
  for (let a = 0; a < Nt; a += 1) {
    const o = e[Math.floor(a * t)];
    o && n.push(o);
  }
  const r = e[e.length - 1], i = n[n.length - 1];
  return r && i && i.t !== r.t && n.push(r), n;
}
function ds(e, t, n = 5) {
  const r = t - e, i = [
    15e3,
    3e4,
    6e4,
    12e4,
    3e5,
    6e5,
    9e5,
    18e5,
    36e5,
    72e5,
    108e5,
    216e5,
    432e5,
    864e5,
    1728e5,
    6048e5
  ], a = i.find((l) => r / l <= n) ?? i[i.length - 1] ?? 6048e5, o = [];
  for (let l = Math.ceil(e / a) * a; l <= t; l += a) o.push(l);
  return { ticks: o, step: a };
}
function kr({ series: e }) {
  var R;
  const t = z(null), [n, r] = A(cs), [i, a] = A(null);
  U(() => {
    const w = t.current;
    if (!w) return;
    const k = new ResizeObserver((F) => {
      var K;
      const B = (K = F[0]) == null ? void 0 : K.contentRect.width;
      B && B > 0 && r(Math.round(B));
    });
    return k.observe(w), () => k.disconnect();
  }, []);
  const o = e.filter((w) => w.points.length > 0);
  if (o.length === 0) return null;
  const l = o.flatMap((w) => w.points.map((k) => k.t)), c = Math.min(...l), u = Math.max(...l), f = Math.max(u - c, 1), h = (w) => nt + (w - c) / f * (n - 2 * nt), m = new Set(o.map((w) => w.unit ?? "")), y = o.length === 1 || m.size === 1, v = (w) => {
    const k = w.flatMap((D) => D.points.map((L) => L.v)), F = Math.max(
      ...w.map((D) => D.band ? Math.max(...D.band.map((L) => L.max)) : -1 / 0)
    ), B = Math.min(
      ...w.map((D) => D.band ? Math.min(...D.band.map((L) => L.min)) : 1 / 0)
    ), K = Math.max(...k, F === -1 / 0 ? 0 : F, 0);
    return { min: Math.min(...k, B === 1 / 0 ? 0 : B, 0), max: K };
  }, b = v(o), C = Tt(b.min, b.max), g = (w, k) => (F) => {
    const B = (F - k) / (w - k || 1);
    return le - B * (le - _t);
  }, M = g(C.top, Math.min(b.min, 0)), $ = o.map((w, k) => {
    const F = us(w.points);
    let B = M;
    if (!y) {
      const K = v([w]), G = Tt(Math.min(K.min, 0), K.max).top;
      B = g(G, Math.min(K.min, 0));
    }
    return { label: w.label, unit: w.unit, color: st(k), points: F, yAt: B, band: w.band };
  }), _ = y ? C.ticks : [], P = (_[1] ?? 0) - (_[0] ?? 0) || void 0, j = y ? [] : [0.25, 0.5, 0.75].map((w) => le - w * (le - _t)), { ticks: x, step: N } = ds(c, u), S = y ? ((R = o[0]) == null ? void 0 : R.unit) ?? "" : "", p = i === null ? null : $.map((w) => {
    let k = null;
    for (const F of w.points)
      (k === null || Math.abs(F.t - i) < Math.abs(k.t - i)) && (k = F);
    return { series: w, point: k };
  }), T = i === null ? null : h(i);
  return /* @__PURE__ */ d("div", { className: "fleet-viz__chart", children: [
    /* @__PURE__ */ s("div", { className: "fleet-viz__legend", children: $.map((w) => /* @__PURE__ */ d("span", { className: "fleet-viz__legend-item", children: [
      /* @__PURE__ */ s("span", { className: "fleet-viz__legend-swatch", style: { background: w.color } }),
      w.label,
      w.unit ? ` (${w.unit})` : ""
    ] }, w.label)) }),
    /* @__PURE__ */ d("div", { ref: t, style: { position: "relative" }, children: [
      /* @__PURE__ */ d(
        "svg",
        {
          width: n,
          height: yn,
          viewBox: `0 0 ${n} ${yn}`,
          style: { display: "block" },
          role: "img",
          "aria-label": `Time series chart: ${$.map((w) => w.label).join(", ")}`,
          onMouseLeave: () => a(null),
          onMouseMove: (w) => {
            const k = w.currentTarget.getBoundingClientRect(), F = w.clientX - k.left, B = Math.min(Math.max((F - nt) / (n - 2 * nt), 0), 1);
            a(c + B * f);
          },
          children: [
            _.map((w, k) => {
              const F = M(w), B = k === 0 && w === 0;
              return /* @__PURE__ */ d("g", { children: [
                /* @__PURE__ */ s(
                  "line",
                  {
                    x1: 0,
                    x2: n,
                    y1: F,
                    y2: F,
                    stroke: "var(--border-subtle)",
                    strokeWidth: 1,
                    strokeOpacity: B ? 0.9 : 0.35,
                    vectorEffect: "non-scaling-stroke"
                  }
                ),
                B ? null : /* @__PURE__ */ d("text", { x: 4, y: F - 3, className: "fleet-viz__axis-label", children: [
                  gr(w, P),
                  k === _.length - 1 && S ? ` ${S}` : ""
                ] })
              ] }, `y-${w}`);
            }),
            j.map((w) => /* @__PURE__ */ s(
              "line",
              {
                x1: 0,
                x2: n,
                y1: w,
                y2: w,
                stroke: "var(--border-subtle)",
                strokeWidth: 1,
                strokeOpacity: 0.25,
                vectorEffect: "non-scaling-stroke"
              },
              `fg-${w}`
            )),
            y ? null : /* @__PURE__ */ s(
              "line",
              {
                x1: 0,
                x2: n,
                y1: le,
                y2: le,
                stroke: "var(--border-subtle)",
                strokeWidth: 1,
                strokeOpacity: 0.9,
                vectorEffect: "non-scaling-stroke"
              }
            ),
            x.map((w) => {
              const k = h(w), F = k < 40 ? "start" : k > n - 40 ? "end" : "middle";
              return /* @__PURE__ */ d("g", { children: [
                /* @__PURE__ */ s(
                  "line",
                  {
                    x1: k,
                    x2: k,
                    y1: _t / 2,
                    y2: le,
                    stroke: "var(--border-subtle)",
                    strokeWidth: 1,
                    strokeOpacity: 0.18,
                    vectorEffect: "non-scaling-stroke"
                  }
                ),
                /* @__PURE__ */ s(
                  "line",
                  {
                    x1: k,
                    x2: k,
                    y1: le,
                    y2: le + 4,
                    stroke: "var(--text-muted)",
                    strokeWidth: 1,
                    strokeOpacity: 0.6,
                    vectorEffect: "non-scaling-stroke"
                  }
                ),
                /* @__PURE__ */ s("text", { x: k, y: le + 13, textAnchor: F, className: "fleet-viz__axis-label", children: yr(w, f, N) })
              ] }, `x-${w}`);
            }),
            $.map((w) => {
              const k = w.band;
              if (!k || k.length < 2) return null;
              const F = k.map((K) => `${h(K.t)},${w.yAt(K.max)}`), B = [...k].reverse().map((K) => `${h(K.t)},${w.yAt(K.min)}`);
              return /* @__PURE__ */ s(
                "polygon",
                {
                  points: [...F, ...B].join(" "),
                  fill: w.color,
                  opacity: 0.12
                },
                `band-${w.label}`
              );
            }),
            $.map((w) => /* @__PURE__ */ s(
              "polyline",
              {
                points: w.points.map((k) => `${h(k.t)},${w.yAt(k.v)}`).join(" "),
                fill: "none",
                stroke: w.color,
                strokeWidth: 1.5,
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
              },
              w.label
            )),
            T !== null ? /* @__PURE__ */ s(
              "line",
              {
                x1: T,
                x2: T,
                y1: 0,
                y2: le,
                stroke: "var(--text-secondary)",
                strokeWidth: 1,
                opacity: 0.5,
                vectorEffect: "non-scaling-stroke"
              }
            ) : null,
            p ? p.map(
              ({ series: w, point: k }) => k ? /* @__PURE__ */ s(
                "circle",
                {
                  cx: h(k.t),
                  cy: w.yAt(k.v),
                  r: 3.5,
                  fill: w.color
                },
                `dot-${w.label}`
              ) : null
            ) : null
          ]
        }
      ),
      p && T !== null ? /* @__PURE__ */ s(fs, { entries: p, x: T, chartWidth: n, spanMs: f, stepMs: N }) : null
    ] })
  ] });
}
function fs({
  entries: e,
  x: t,
  chartWidth: n,
  spanMs: r,
  stepMs: i
}) {
  var c;
  const o = t + 12 + 200 > n ? Math.max(0, t - 12 - 200) : t + 12, l = ((c = e.find((u) => u.point !== null)) == null ? void 0 : c.point) ?? null;
  return /* @__PURE__ */ d("div", { className: "fleet-viz__hover-pane", role: "tooltip", style: { left: o, width: 200 }, children: [
    l ? /* @__PURE__ */ s("div", { className: "fleet-viz__hover-time", children: yr(l.t, r, i) }) : null,
    e.map(({ series: u, point: f }) => /* @__PURE__ */ d("div", { className: "fleet-viz__hover-row", children: [
      /* @__PURE__ */ d("span", { className: "fleet-viz__hover-label", children: [
        /* @__PURE__ */ s("span", { className: "fleet-viz__legend-swatch", style: { background: u.color } }),
        u.label
      ] }),
      /* @__PURE__ */ s("span", { className: "fleet-viz__hover-value", children: f ? pr(f.v, u.unit) : "—" })
    ] }, u.label))
  ] });
}
function we(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function Xe(e) {
  return typeof e == "number" && Number.isFinite(e);
}
function ot(e) {
  return e.reduce((t, n) => typeof n == "number" ? `${t}[${n}]` : t ? `${t}.${n}` : n, "");
}
function hs(e) {
  const t = [];
  for (const n of e.split(".")) {
    const r = /^([^[\]]*)((?:\[\d+\])*)$/.exec(n);
    if (!r) return [];
    r[1] && t.push(r[1]);
    for (const i of (r[2] ?? "").matchAll(/\[(\d+)\]/g)) t.push(Number(i[1]));
  }
  return t;
}
function bn(e, t) {
  let n = e;
  for (const r of t) {
    if (n === null || typeof n != "object") return;
    n = n[String(r)];
  }
  return n;
}
function ms(e) {
  if (!we(e) || !we(e.header)) return null;
  const t = e.header, n = we(t.stamp) ? t.stamp : null, r = n ? n.sec ?? n.secs : void 0, i = n ? n.nanosec ?? n.nsecs ?? 0 : 0;
  return {
    frameId: typeof t.frame_id == "string" && t.frame_id ? t.frame_id : null,
    stamp: Xe(r) ? r + (Xe(i) ? i / 1e9 : 0) : null
  };
}
function ps(e) {
  return e > 1e9 ? new Date(e * 1e3).toISOString().replace("T", " ").slice(0, 23) + "Z" : `${e.toFixed(3)} s (sim clock)`;
}
function _r(e, t) {
  return Object.keys(e).length === t.length && t.every((r) => Xe(e[r]));
}
function Nr(e) {
  return we(e) && _r(e, ["x", "y", "z", "w"]);
}
function xr(e) {
  return we(e) && _r(e, ["x", "y", "z"]);
}
function gs(e) {
  const t = Math.hypot(e.x, e.y, e.z, e.w) || 1, n = e.x / t, r = e.y / t, i = e.z / t, a = e.w / t, o = Math.atan2(2 * (a * n + r * i), 1 - 2 * (n * n + r * r)), l = Math.asin(Math.max(-1, Math.min(1, 2 * (a * r - i * n)))), c = Math.atan2(2 * (a * i + n * r), 1 - 2 * (r * r + i * i)), u = 180 / Math.PI;
  return [o * u, l * u, c * u];
}
function ys(e, t) {
  return !/covariance/i.test(e) || !t.every(Xe) ? null : t.length === 9 ? 3 : t.length === 36 ? 6 : null;
}
function bs(e) {
  for (const [t, n] of Object.entries(e)) {
    if (!Array.isArray(n) || n.length === 0 || !n.every((i) => typeof i == "string")) continue;
    const r = Object.entries(e).filter(
      ([i, a]) => i !== t && Array.isArray(a) && a.length === n.length && a.every(Xe)
    ).map(([i, a]) => ({ key: i, values: a }));
    if (r.length > 0) return { labelKey: t, labels: n, columns: r };
  }
  return null;
}
function Ut(e) {
  if (e === 0) return "0";
  const t = Math.abs(e);
  return t >= 1e6 || t < 1e-3 ? e.toExponential(2) : Number.isInteger(e) ? String(e) : String(Number(e.toPrecision(4)));
}
const xt = 24, lt = 40;
function Cr({
  samples: e,
  field: t = null,
  compact: n = !1
}) {
  var m;
  const r = (m = e[e.length - 1]) == null ? void 0 : m.value, i = ms(r), a = !n && e.length >= 2, [o, l] = A(() => {
    if (!t) return null;
    const y = hs(t);
    return y.length && typeof bn(r, y) == "number" ? y : null;
  }), c = o ? ot(o) : null, u = Q(() => {
    if (!a || !o) return null;
    const y = e.map((v, b) => {
      const C = bn(v.value, o);
      return typeof C == "number" && Number.isFinite(C) ? { t: v.t ?? b * 1e3, v: C } : null;
    }).filter((v) => v !== null);
    return y.length >= 2 ? [{ label: ot(o), points: y }] : null;
  }, [e, o, a]);
  if (!r) return null;
  const f = {
    selectable: a,
    selected: c,
    toggle: (y) => l(ot(y) === c ? null : y)
  }, h = i && we(r) ? Object.fromEntries(Object.entries(r).filter(([y]) => y !== "header")) : r;
  return /* @__PURE__ */ d("div", { className: n ? "fleet-viz__record is-compact" : "fleet-viz__record", children: [
    !n && (i || e.length > 1) ? /* @__PURE__ */ d("div", { className: "fleet-viz__record-meta", children: [
      i != null && i.frameId ? /* @__PURE__ */ d("span", { className: "fleet-viz__record-chip", children: [
        "frame ",
        /* @__PURE__ */ s("b", { children: i.frameId })
      ] }) : null,
      (i == null ? void 0 : i.stamp) != null ? /* @__PURE__ */ d("span", { className: "fleet-viz__record-chip", children: [
        "stamp ",
        /* @__PURE__ */ s("b", { children: ps(i.stamp) })
      ] }) : null,
      e.length > 1 ? /* @__PURE__ */ d("span", { className: "fleet-viz__record-chip", children: [
        e.length,
        " samples"
      ] }) : null
    ] }) : null,
    /* @__PURE__ */ s(Sr, { value: h, path: [], depth: 0, pick: f }),
    u ? /* @__PURE__ */ s("div", { className: "fleet-viz__record-chart", children: /* @__PURE__ */ s(kr, { series: u }) }) : null,
    a ? /* @__PURE__ */ s("div", { className: "fleet-viz__record-hint", children: u ? `Charting ${c} across ${e.length} samples — click another number to switch.` : `Click any number to chart it across the ${e.length} samples.` }) : null,
    n ? null : /* @__PURE__ */ d("details", { className: "fleet-viz__record-raw", children: [
      /* @__PURE__ */ s("summary", { children: "raw JSON" }),
      /* @__PURE__ */ s("pre", { children: JSON.stringify(r, null, 2) })
    ] })
  ] });
}
function Sr({
  value: e,
  path: t,
  depth: n,
  pick: r
}) {
  if (Array.isArray(e))
    return /* @__PURE__ */ d("div", { className: "fleet-viz__record-fields", children: [
      e.slice(0, lt).map((o, l) => /* @__PURE__ */ s(vn, { name: `[${l}]`, value: o, path: [...t, l], depth: n, pick: r }, l)),
      e.length > lt ? /* @__PURE__ */ d("div", { className: "fleet-viz__record-more", children: [
        "+",
        e.length - lt,
        " more"
      ] }) : null
    ] });
  if (!we(e)) return /* @__PURE__ */ s(Mr, { value: e, path: t, pick: r });
  const i = bs(e), a = new Set(i ? [i.labelKey, ...i.columns.map((o) => o.key)] : []);
  return /* @__PURE__ */ d("div", { className: "fleet-viz__record-fields", children: [
    i ? /* @__PURE__ */ s(vs, { table: i, path: t, pick: r }) : null,
    Object.entries(e).filter(([o]) => !a.has(o)).map(([o, l]) => /* @__PURE__ */ s(vn, { name: o, value: l, path: [...t, o], depth: n, pick: r }, o))
  ] });
}
function vn({
  name: e,
  value: t,
  path: n,
  depth: r,
  pick: i
}) {
  if (we(t) && !Nr(t) && !xr(t) || Array.isArray(t) && t.some((o) => o !== null && typeof o == "object")) {
    const o = Array.isArray(t) ? `${t.length} items` : `${Object.keys(t).length} fields`;
    return /* @__PURE__ */ d("details", { className: "fleet-viz__record-group", open: r < 2, children: [
      /* @__PURE__ */ d("summary", { children: [
        /* @__PURE__ */ s("span", { className: "fleet-viz__record-key", children: e }),
        /* @__PURE__ */ s("span", { className: "fleet-viz__record-dim", children: o })
      ] }),
      /* @__PURE__ */ s(Sr, { value: t, path: n, depth: r + 1, pick: i })
    ] });
  }
  return /* @__PURE__ */ d("div", { className: "fleet-viz__record-row", children: [
    /* @__PURE__ */ s("span", { className: "fleet-viz__record-key", children: e }),
    /* @__PURE__ */ s("span", { className: "fleet-viz__record-value", children: /* @__PURE__ */ s(Mr, { value: t, path: n, pick: i, name: e }) })
  ] });
}
function Mr({
  value: e,
  path: t,
  pick: n,
  name: r = ""
}) {
  if (typeof e == "number") return /* @__PURE__ */ s(ze, { v: e, path: t, pick: n });
  if (typeof e == "boolean")
    return /* @__PURE__ */ s("span", { className: e ? "fleet-viz__record-on" : "fleet-viz__record-off", children: e ? "true" : "false" });
  if (typeof e == "string")
    return e ? /* @__PURE__ */ s("span", { className: "fleet-viz__record-str", children: e }) : /* @__PURE__ */ s("span", { className: "fleet-viz__record-dim", children: "empty" });
  if (e == null)
    return /* @__PURE__ */ s("span", { className: "fleet-viz__record-dim", children: "null" });
  if (Nr(e)) {
    const [i, a, o] = gs(e);
    return /* @__PURE__ */ d("span", { className: "fleet-viz__record-inline", children: [
      ["x", "y", "z", "w"].map((l) => /* @__PURE__ */ s(ze, { label: l, v: e[l], path: [...t, l], pick: n }, l)),
      /* @__PURE__ */ d("span", { className: "fleet-viz__record-derived", children: [
        "roll ",
        i.toFixed(1),
        "° · pitch ",
        a.toFixed(1),
        "° · yaw ",
        o.toFixed(1),
        "°"
      ] })
    ] });
  }
  if (xr(e))
    return /* @__PURE__ */ d("span", { className: "fleet-viz__record-inline", children: [
      ["x", "y", "z"].map((i) => /* @__PURE__ */ s(ze, { label: i, v: e[i], path: [...t, i], pick: n }, i)),
      /* @__PURE__ */ d("span", { className: "fleet-viz__record-derived", children: [
        "|v| ",
        Ut(Math.hypot(e.x, e.y, e.z))
      ] })
    ] });
  if (Array.isArray(e)) {
    if (e.length === 0) return /* @__PURE__ */ s("span", { className: "fleet-viz__record-dim", children: "empty" });
    const i = ys(r, e);
    return i ? /* @__PURE__ */ s(ws, { values: e, size: i, path: t, pick: n }) : /* @__PURE__ */ d("span", { className: "fleet-viz__record-inline", children: [
      e.slice(0, xt).map(
        (a, o) => typeof a == "number" ? /* @__PURE__ */ s(ze, { v: a, path: [...t, o], pick: n }, o) : /* @__PURE__ */ s("span", { className: "fleet-viz__record-chip", children: String(a) }, o)
      ),
      e.length > xt ? /* @__PURE__ */ d("span", { className: "fleet-viz__record-dim", children: [
        "+",
        e.length - xt,
        " more"
      ] }) : null
    ] });
  }
  return /* @__PURE__ */ s("span", { className: "fleet-viz__record-str", children: JSON.stringify(e) });
}
function ze({
  v: e,
  path: t,
  pick: n,
  label: r
}) {
  const i = /* @__PURE__ */ d(re, { children: [
    r ? /* @__PURE__ */ s("i", { children: r }) : null,
    Ut(e)
  ] });
  if (!n.selectable) return /* @__PURE__ */ s("span", { className: "fleet-viz__record-num", children: i });
  const a = ot(t);
  return /* @__PURE__ */ s(
    "button",
    {
      type: "button",
      className: n.selected === a ? "fleet-viz__record-num is-active" : "fleet-viz__record-num",
      title: `Chart ${a}`,
      onClick: () => n.toggle(t),
      children: i
    }
  );
}
function vs({
  table: e,
  path: t,
  pick: n
}) {
  return /* @__PURE__ */ d("table", { className: "fleet-viz__record-table", children: [
    /* @__PURE__ */ s("thead", { children: /* @__PURE__ */ d("tr", { children: [
      /* @__PURE__ */ s("th", { children: e.labelKey }),
      e.columns.map((r) => /* @__PURE__ */ s("th", { children: r.key }, r.key))
    ] }) }),
    /* @__PURE__ */ s("tbody", { children: e.labels.slice(0, lt).map((r, i) => /* @__PURE__ */ d("tr", { children: [
      /* @__PURE__ */ s("td", { className: "fleet-viz__record-rowlabel", children: r }),
      e.columns.map((a) => /* @__PURE__ */ s("td", { children: /* @__PURE__ */ s(ze, { v: a.values[i] ?? 0, path: [...t, a.key, i], pick: n }) }, a.key))
    ] }, `${r}-${i}`)) })
  ] });
}
function ws({
  values: e,
  size: t,
  path: n,
  pick: r
}) {
  const [i, a] = A(!1), o = Array.from({ length: t }, (c, u) => e[u * t + u] ?? 0), l = e.every((c) => c === 0) ? "all zero" : `diag ${o.map(Ut).join(" · ")}`;
  return /* @__PURE__ */ d("span", { className: "fleet-viz__record-cov", children: [
    /* @__PURE__ */ d("button", { type: "button", className: "fleet-viz__record-toggle", onClick: () => a(!i), children: [
      t,
      "×",
      t,
      " · ",
      l,
      " ",
      i ? "▾" : "▸"
    ] }),
    i ? /* @__PURE__ */ s(
      "span",
      {
        className: "fleet-viz__record-matrix",
        style: { gridTemplateColumns: `repeat(${t}, auto)` },
        children: e.map((c, u) => /* @__PURE__ */ s(ze, { v: c, path: [...n, u], pick: r }, u))
      }
    ) : null
  ] });
}
const Ae = 260, ks = 560, fe = 256, It = 3, $r = 18;
function Rt(e, t) {
  return (e + 180) / 360 * 2 ** t * fe;
}
function At(e, t) {
  const r = Math.max(Math.min(e, 85.051), -85.051) * Math.PI / 180;
  return (1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2 * 2 ** t * fe;
}
function _s(e, t) {
  if (e.length <= 1) return 16;
  for (let n = $r; n >= It; n -= 1) {
    const r = e.map((l) => Rt(l.longitude, n)), i = e.map((l) => At(l.latitude, n)), a = Math.max(...r) - Math.min(...r), o = Math.max(...i) - Math.min(...i);
    if (a <= t * 0.8 && o <= Ae * 0.8) return n;
  }
  return It;
}
function Tr({
  points: e,
  variant: t = "trail"
}) {
  const n = z(null), [r, i] = A(ks), [a, o] = A(0);
  if (U(() => {
    const p = n.current;
    if (!p) return;
    const T = new ResizeObserver((R) => {
      var k;
      const w = (k = R[0]) == null ? void 0 : k.contentRect.width;
      w && w > 0 && i(Math.round(w));
    });
    return T.observe(p), () => T.disconnect();
  }, []), e.length === 0) return null;
  const l = Math.max(It, Math.min($r, _s(e, r) + a)), c = e.reduce((p, T) => p + T.latitude, 0) / e.length, u = e.reduce((p, T) => p + T.longitude, 0) / e.length, f = Rt(u, l), h = At(c, l), m = f - r / 2, y = h - Ae / 2, v = 2 ** l, b = [], C = Math.floor(m / fe), g = Math.floor(y / fe), M = Math.floor((m + r) / fe), $ = Math.floor((y + Ae) / fe), _ = 48;
  e: for (let p = C; p <= M; p += 1)
    for (let T = g; T <= $; T += 1) {
      if (b.length >= _) break e;
      if (T < 0 || T >= v) continue;
      const R = (p % v + v) % v;
      b.push({
        key: `${l}/${p}/${T}`,
        url: `https://tile.openstreetmap.org/${l}/${R}/${T}.png`,
        left: p * fe - m,
        top: T * fe - y
      });
    }
  const P = (p) => ({
    x: Rt(p.longitude, l) - m,
    y: At(p.latitude, l) - y
  }), j = e.map(P), x = j[j.length - 1], N = e.filter((p) => p.label), S = e.length === 1 && e[0] ? `https://www.openstreetmap.org/?mlat=${e[0].latitude}&mlon=${e[0].longitude}#map=${l}/${e[0].latitude}/${e[0].longitude}` : `https://www.openstreetmap.org/#map=${l}/${c}/${u}`;
  return /* @__PURE__ */ d("div", { className: "fleet-viz__map", ref: n, children: [
    /* @__PURE__ */ d("div", { className: "fleet-viz__map-canvas", style: { height: Ae }, children: [
      b.map((p) => /* @__PURE__ */ s(
        "img",
        {
          src: p.url,
          alt: "",
          width: fe,
          height: fe,
          loading: "lazy",
          draggable: !1,
          className: "fleet-viz__map-tile",
          style: { left: p.left, top: p.top }
        },
        p.key
      )),
      /* @__PURE__ */ d(
        "svg",
        {
          className: "fleet-viz__map-overlay",
          width: r,
          height: Ae,
          viewBox: `0 0 ${r} ${Ae}`,
          role: "img",
          "aria-label": `Map with ${e.length} device position${e.length === 1 ? "" : "s"}`,
          children: [
            t === "trail" && N.length <= 1 && j.length > 1 ? /* @__PURE__ */ s(
              "polyline",
              {
                points: j.map((p) => `${p.x},${p.y}`).join(" "),
                fill: "none",
                stroke: "var(--interface-iris)",
                strokeWidth: 2,
                strokeLinejoin: "round",
                strokeOpacity: 0.75
              }
            ) : null,
            t === "markers" || N.length > 1 ? (
              // Multi-device map: every labelled point is a current position.
              e.map((p, T) => {
                const R = P(p);
                return /* @__PURE__ */ d("g", { children: [
                  /* @__PURE__ */ s(
                    "circle",
                    {
                      cx: R.x,
                      cy: R.y,
                      r: 6,
                      fill: "var(--interface-iris)",
                      stroke: "white",
                      strokeWidth: 2
                    }
                  ),
                  p.label ? /* @__PURE__ */ s("text", { x: R.x + 9, y: R.y + 4, className: "fleet-viz__map-label", children: p.label }) : null
                ] }, `${p.label ?? "pt"}-${T}`);
              })
            ) : x ? /* @__PURE__ */ d("g", { children: [
              /* @__PURE__ */ s(
                "circle",
                {
                  cx: x.x,
                  cy: x.y,
                  r: 7,
                  fill: "var(--interface-iris)",
                  fillOpacity: 0.25
                }
              ),
              /* @__PURE__ */ s(
                "circle",
                {
                  cx: x.x,
                  cy: x.y,
                  r: 5,
                  fill: "var(--interface-iris)",
                  stroke: "white",
                  strokeWidth: 2
                }
              )
            ] }) : null
          ]
        }
      ),
      /* @__PURE__ */ d("div", { className: "fleet-viz__map-controls", children: [
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            "aria-label": "Zoom in",
            onClick: () => o((p) => Math.min(p + 1, 6)),
            children: "+"
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            "aria-label": "Zoom out",
            onClick: () => o((p) => Math.max(p - 1, -6)),
            children: "−"
          }
        )
      ] }),
      /* @__PURE__ */ s("div", { className: "fleet-viz__map-attribution", children: /* @__PURE__ */ s("a", { href: "https://www.openstreetmap.org/copyright", target: "_blank", rel: "noreferrer", children: "© OpenStreetMap" }) })
    ] }),
    /* @__PURE__ */ d("div", { className: "fleet-viz__map-footer", children: [
      /* @__PURE__ */ s("span", { className: "fleet-viz__map-coords", children: e.length === 1 && e[0] ? `${e[0].latitude.toFixed(5)}, ${e[0].longitude.toFixed(5)}` : `${e.length} positions` }),
      /* @__PURE__ */ s("a", { href: S, target: "_blank", rel: "noreferrer", children: "Open map ↗" })
    ] })
  ] });
}
function Ns({ tiles: e }) {
  return /* @__PURE__ */ s("div", { className: "fleet-viz__tiles", children: e.map((t, n) => /* @__PURE__ */ d("div", { className: "fleet-viz__tile", children: [
    /* @__PURE__ */ d("div", { className: "fleet-viz__tile-head", children: [
      /* @__PURE__ */ s("span", { className: "fleet-viz__tile-label", title: t.label, children: t.label }),
      t.sublabel ? /* @__PURE__ */ s("span", { className: "fleet-viz__tile-sub", children: t.sublabel }) : null
    ] }),
    /* @__PURE__ */ s(xs, { value: t.value }),
    t.t ? /* @__PURE__ */ s("div", { className: "fleet-viz__tile-time", children: new Date(t.t).toLocaleString() }) : null
  ] }, `${t.label}-${t.sublabel ?? ""}-${n}`)) });
}
function xs({ value: e }) {
  switch (e.type) {
    case "numeric":
      return /* @__PURE__ */ d("div", { className: "fleet-viz__tile-stat", children: [
        Ct(e.value),
        e.unit ? /* @__PURE__ */ s("span", { className: "fleet-viz__tile-unit", children: e.unit }) : null
      ] });
    case "battery": {
      const t = Math.max(0, Math.min(100, e.percentage));
      return /* @__PURE__ */ d("div", { children: [
        /* @__PURE__ */ d("div", { className: "fleet-viz__tile-stat", children: [
          Ct(e.percentage),
          /* @__PURE__ */ s("span", { className: "fleet-viz__tile-unit", children: "%" })
        ] }),
        /* @__PURE__ */ s("div", { className: "fleet-viz__battery-track", children: /* @__PURE__ */ s(
          "div",
          {
            className: `fleet-viz__battery-fill ${t <= 20 ? "is-low" : ""}`,
            style: { width: `${t}%` }
          }
        ) })
      ] });
    }
    case "health":
      return /* @__PURE__ */ d("div", { className: `fleet-viz__health is-${e.status}`, children: [
        /* @__PURE__ */ s("span", { className: "fleet-viz__health-dot" }),
        e.status
      ] });
    case "bitset":
      return /* @__PURE__ */ s("div", { className: "fleet-viz__bitset", children: e.entries.map((t, n) => /* @__PURE__ */ s(
        "span",
        {
          className: `fleet-viz__flag ${t.value ? "is-on" : "is-off"}`,
          children: Ss(t.key)
        },
        `${t.key}-${n}`
      )) });
    case "numeric-set":
      return /* @__PURE__ */ d("div", { className: "fleet-viz__setlist", children: [
        e.entries.slice(0, 6).map((t, n) => /* @__PURE__ */ d("div", { className: "fleet-viz__setrow", children: [
          /* @__PURE__ */ s("span", { className: "fleet-viz__setlabel", title: t.label, children: t.label }),
          /* @__PURE__ */ d("span", { className: "fleet-viz__setvalue", children: [
            Ct(t.value),
            t.unit ? ` ${t.unit}` : ""
          ] })
        ] }, `${t.label}-${n}`)),
        e.entries.length > 6 ? /* @__PURE__ */ d("div", { className: "fleet-viz__setrow fleet-viz__setrow--more", children: [
          "+",
          e.entries.length - 6,
          " more"
        ] }) : null
      ] });
    case "location":
      return /* @__PURE__ */ s("div", { className: "fleet-viz__tile-map", children: /* @__PURE__ */ s(Tr, { points: [{ latitude: e.latitude, longitude: e.longitude, t: null }] }) });
    case "image":
      return /* @__PURE__ */ s(Cs, { url: e.url });
    case "video":
      return /* @__PURE__ */ s("figure", { className: "fleet-viz__video fleet-viz__video--tile", children: /* @__PURE__ */ s("video", { controls: !0, preload: "metadata", src: e.url }) });
    case "text":
      return /* @__PURE__ */ s("div", { className: "fleet-viz__tile-text", title: e.value, children: e.value });
    case "json":
      return /* @__PURE__ */ s(Cr, { samples: [{ t: null, value: e.value }], compact: !0 });
    default:
      return null;
  }
}
function Cs({ url: e }) {
  const [t, n] = A(!1);
  return /* @__PURE__ */ d(re, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "fleet-viz__image-thumb",
        onClick: () => n((r) => !r),
        children: /* @__PURE__ */ s("img", { src: e, alt: "Latest camera frame", loading: "lazy" })
      }
    ),
    t ? /* @__PURE__ */ s("a", { href: e, target: "_blank", rel: "noreferrer", className: "fleet-viz__tile-open", children: "Open original ↗" }) : null
  ] });
}
function Ct(e) {
  const t = Math.abs(e);
  return t >= 1e3 ? e.toLocaleString(void 0, { maximumFractionDigits: 0 }) : t >= 100 ? e.toFixed(0) : t >= 1 ? e.toFixed(1) : e.toFixed(3);
}
function Ss(e) {
  return e.split("/").filter(Boolean).pop() ?? e;
}
function Ms({ items: e }) {
  const t = [...e].sort((n, r) => (r.t ?? 0) - (n.t ?? 0));
  return /* @__PURE__ */ s("div", { className: "fleet-viz__videos", children: t.map((n, r) => /* @__PURE__ */ d("figure", { className: "fleet-viz__video", children: [
    /* @__PURE__ */ s("video", { controls: !0, preload: "metadata", src: n.url }),
    /* @__PURE__ */ d("figcaption", { children: [
      n.t ? /* @__PURE__ */ s("span", { children: new Date(n.t).toLocaleString() }) : null,
      n.durationMs !== null ? /* @__PURE__ */ d("span", { children: [
        (n.durationMs / 1e3).toFixed(1),
        "s"
      ] }) : null,
      /* @__PURE__ */ s("a", { href: n.url, target: "_blank", rel: "noreferrer", children: "Open original ↗" })
    ] })
  ] }, `${n.url}-${r}`)) });
}
function Ir({ model: e }) {
  return /* @__PURE__ */ d("div", { className: "fleet-viz", children: [
    e.title ? /* @__PURE__ */ s("div", { className: "fleet-viz__title", children: e.title }) : null,
    /* @__PURE__ */ s($s, { model: e })
  ] });
}
function $s({ model: e }) {
  switch (e.kind) {
    case "timeseries":
      return /* @__PURE__ */ s(kr, { series: e.series });
    case "bars":
      return /* @__PURE__ */ s(Ka, { model: e });
    case "images":
      return /* @__PURE__ */ s(ss, { items: e.items });
    case "videos":
      return /* @__PURE__ */ s(Ms, { items: e.items });
    case "map":
      return /* @__PURE__ */ s(Tr, { points: e.points, variant: e.variant });
    case "values":
      return /* @__PURE__ */ s(Ns, { tiles: e.tiles });
    case "geometry":
      return /* @__PURE__ */ s(Ya, { geometry: e.geometry });
    case "record":
      return /* @__PURE__ */ s(Cr, { samples: e.samples, field: e.field });
    default:
      return null;
  }
}
const Ts = /^img-[0-9a-f-]{36}\.[a-z0-9]{2,5}$/;
function Ue(e, t = [], n = 0) {
  if (n > 12 || e == null) return t;
  if (typeof e == "string") {
    const a = Is(e);
    return a !== void 0 && Ue(a, t, n + 1), t;
  }
  if (Array.isArray(e)) {
    for (const a of e) Ue(a, t, n + 1);
    return t;
  }
  if (typeof e != "object") return t;
  const r = e, i = r.image_refs;
  if (Array.isArray(i))
    for (const a of i) {
      if (a === null || typeof a != "object" || !("ref" in a)) continue;
      const o = a.ref;
      typeof o != "string" || !Ts.test(o) || t.includes(o) || t.push(o);
    }
  for (const a of Object.values(r))
    (typeof a == "string" || typeof a == "object" && a !== null) && Ue(a, t, n + 1);
  return t;
}
function Is(e) {
  const t = e.trim(), n = t.startsWith("{") && t.endsWith("}"), r = t.startsWith("[") && t.endsWith("]");
  if (!(!n && !r))
    try {
      return JSON.parse(t);
    } catch {
      return;
    }
}
const Rr = je({}), Rs = Rr.Provider;
function Ht() {
  return Ee(Rr);
}
function As({ calls: e, live: t }) {
  const { renderToolCall: n } = Ht(), { customCards: r, otherCalls: i } = Q(() => {
    const a = [], o = [];
    for (const l of e) {
      const c = n ? n(l) : null;
      if (c) {
        a.push({ call: l, node: c });
        continue;
      }
      const u = $a(l);
      if (u) {
        a.push({ call: l, node: /* @__PURE__ */ s(Ea, { ...u }) });
        continue;
      }
      o.push(l);
    }
    return { customCards: a, otherCalls: o };
  }, [e, n]);
  return /* @__PURE__ */ d(re, { children: [
    r.map(({ call: a, node: o }) => /* @__PURE__ */ s(Qr, { children: o }, a.toolCallId)),
    i.length > 0 ? /* @__PURE__ */ s(zs, { calls: i, live: t }) : null
  ] });
}
function zs({ calls: e, live: t }) {
  const [n, r] = A(!1), i = z(t);
  ct(() => {
    i.current && !t && r(!0), i.current = t;
  }, [t]);
  const a = e[0];
  if (e.length === 1 && a)
    return /* @__PURE__ */ s("div", { className: "pa-chat-tools", children: /* @__PURE__ */ s(wn, { call: a, live: t }) });
  const o = e.reduce((h, m) => h + (m.durationMs ?? 0), 0), l = [...new Set(e.map((h) => h.name))], c = l.slice(0, 3).join(", ") + (l.length > 3 ? " +" : ""), u = e.filter((h) => !h.hasResult).length, f = t || n;
  return /* @__PURE__ */ d("div", { className: "pa-chat-tools", children: [
    t ? null : /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: "pa-chat-tools-summary",
        onClick: () => r((h) => !h),
        "aria-expanded": n,
        children: [
          /* @__PURE__ */ s("span", { children: n ? "▾" : "▸" }),
          /* @__PURE__ */ d("span", { children: [
            "⚙ ",
            e.length,
            " tool call",
            e.length === 1 ? "" : "s",
            o > 0 ? ` · ${Ot(o)}` : ""
          ] }),
          /* @__PURE__ */ d("span", { className: "t-muted", children: [
            "· ",
            c
          ] }),
          u > 0 && /* @__PURE__ */ d("span", { className: "t-muted", children: [
            "· ",
            u,
            " interrupted"
          ] })
        ]
      }
    ),
    f ? e.map((h) => /* @__PURE__ */ s(wn, { call: h, live: t }, h.toolCallId)) : (
      // Even with the per-call rows collapsed, media results (camera
      // frames, charts, fleet viz) stay visible — an operator should never
      // have to expand a tool group to see an image the agent fetched.
      e.map((h) => /* @__PURE__ */ s(Ar, { call: h }, h.toolCallId))
    )
  ] });
}
function wn({ call: e, live: t }) {
  const [n, r] = A(!1), i = !e.hasResult && !t;
  return /* @__PURE__ */ d(re, { children: [
    /* @__PURE__ */ d("div", { className: "pa-chat-tool-row", onClick: () => r((a) => !a), children: [
      e.hasResult ? /* @__PURE__ */ s("span", { className: "pa-chat-tool-ok", children: "✓" }) : t ? /* @__PURE__ */ s("span", { className: "pa-chat-spinner-dot" }) : /* @__PURE__ */ s("span", { className: "pa-chat-tool-stopped", children: "✕" }),
      /* @__PURE__ */ s("span", { className: "pa-chat-tool-name", children: e.name }),
      e.mcpName ? /* @__PURE__ */ s("span", { className: "pa-chat-tool-mcp", children: e.mcpName }) : null,
      /* @__PURE__ */ s("span", { className: "pa-chat-tool-args", children: Ds(e.args) }),
      /* @__PURE__ */ s("span", { className: "pa-chat-tool-status", children: e.hasResult ? typeof e.durationMs == "number" && Ot(e.durationMs) : t ? "running…" : "interrupted" })
    ] }),
    n && /* @__PURE__ */ d("div", { className: "pa-chat-tool-detail", children: [
      e.mcpName ? /* @__PURE__ */ d("div", { className: "pa-chat-tool-pane-label", children: [
        "via MCP: ",
        /* @__PURE__ */ s("span", { className: "pa-chat-tool-mcp", children: e.mcpName })
      ] }) : null,
      /* @__PURE__ */ d("div", { children: [
        /* @__PURE__ */ s("div", { className: "pa-chat-tool-pane-label", children: "args" }),
        /* @__PURE__ */ s(He, { value: e.args })
      ] }),
      e.hasResult && /* @__PURE__ */ d("div", { children: [
        /* @__PURE__ */ s("div", { className: "pa-chat-tool-pane-label", children: "result" }),
        /* @__PURE__ */ s(He, { value: e.result, toolName: e.name })
      ] }),
      i && /* @__PURE__ */ s("div", { className: "pa-chat-tool-pane-label", style: { color: "var(--text-muted)" }, children: "no result — run was interrupted" })
    ] }),
    !n && /* @__PURE__ */ s(Ar, { call: e })
  ] });
}
function Ar({ call: e }) {
  const { renderToolValueExtra: t } = Ht(), n = Q(
    () => e.hasResult ? Ue(e.result) : [],
    [e.hasResult, e.result]
  ), r = Q(
    () => e.hasResult && n.length === 0 ? xe(e.result) : [],
    [e.hasResult, e.result, n.length]
  ), i = Q(() => {
    if (!e.hasResult) return null;
    const a = t == null ? void 0 : t(e.result);
    if (a) return a;
    const o = sr(e.result, { toolName: e.name });
    return o ? /* @__PURE__ */ s(Ir, { model: o }) : null;
  }, [e.hasResult, e.result, e.name, t]);
  return !e.hasResult || !i && r.length === 0 && n.length === 0 ? null : /* @__PURE__ */ d("div", { className: "pa-chat-tool-inline-media", children: [
    i,
    /* @__PURE__ */ s(Ft, { images: r }),
    /* @__PURE__ */ s(mr, { refs: n })
  ] });
}
function He({ value: e, toolName: t }) {
  const { renderToolValueExtra: n } = Ht(), r = (n == null ? void 0 : n(e)) ?? null, i = r ? null : sr(e, { toolName: t }), a = r ?? (i ? /* @__PURE__ */ s(Ir, { model: i }) : null), o = Ue(e), l = o.length === 0 ? xe(e) : [], c = zt(e, {
    redactImages: l.length > 0 || !!a
  }), u = c !== "(image)" && c.trim().length > 0;
  return /* @__PURE__ */ d("div", { className: "pa-chat-tool-value", children: [
    a,
    /* @__PURE__ */ s(Ft, { images: l }),
    /* @__PURE__ */ s(mr, { refs: o }),
    u ? /* @__PURE__ */ s(Ps, { text: c }) : null
  ] });
}
function Ps({ text: e }) {
  const [t, n] = A(!1), [r, i] = A(!1), a = z(null);
  return ct(() => {
    const o = a.current;
    if (!o) return;
    const c = t ? o.scrollHeight > 320 + 1 : o.scrollHeight > o.clientHeight + 1;
    i(c);
  }, [e, t]), /* @__PURE__ */ d("div", { className: "pa-chat-tool-json", children: [
    /* @__PURE__ */ s(
      "pre",
      {
        ref: a,
        className: t ? "pa-chat-tool-pane is-expanded" : "pa-chat-tool-pane",
        children: e
      }
    ),
    r ? /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "pa-chat-tool-expand",
        "aria-expanded": t,
        onClick: (o) => {
          o.stopPropagation(), n((l) => !l);
        },
        children: t ? "Show less" : "Show more"
      }
    ) : null
  ] });
}
function Ds(e) {
  if (e == null) return "";
  if (typeof e != "object") return rt(String(e), 60);
  if (!Se(e)) return rt(zt(e), 60);
  for (const t of ["command", "path", "name", "query", "url", "prompt", "message"]) {
    const n = e[t];
    if (typeof n == "string") return rt(`${t}: ${n}`, 60);
  }
  return rt(zt(e), 60);
}
function zt(e, t) {
  if (e === void 0) return "(none)";
  const n = t != null && t.redactImages ? Pt(Ge(e)) : Ge(e);
  if (typeof n == "string")
    return n === "[image]" ? "(image)" : n;
  try {
    return JSON.stringify(n, null, 2);
  } catch {
    return String(e);
  }
}
function Pt(e, t = 0) {
  if (t > 10) return e;
  if (typeof e == "string")
    return ie(e) ? "[image]" : e.length > 200 && Pe(e) ? "[image data]" : e;
  if (Array.isArray(e))
    return e.map((r) => Pt(r, t + 1));
  if (!Se(e)) return e;
  const n = {};
  for (const [r, i] of Object.entries(e)) {
    const a = r.toLowerCase();
    if (typeof i == "string" && (a === "data" || a === "base64" || a === "b64" || a === "image_base64" || a === "image" || a.endsWith("_base64")) && (i.length > 80 || ie(i))) {
      n[r] = ie(i) ? "[image]" : "[image data]";
      continue;
    }
    if (a === "image_url" && typeof i == "string" && ie(i)) {
      n[r] = "[image]";
      continue;
    }
    n[r] = Pt(i, t + 1);
  }
  return n;
}
function Pe(e) {
  if (e.length < 200) return !1;
  const t = e.slice(0, 400).replace(/\s+/g, "");
  return /^[A-Za-z0-9+/]+=*$/.test(t);
}
function Ge(e, t = 0) {
  if (t > 8) return e;
  if (typeof e == "string") {
    const n = Gt(e);
    return n === void 0 ? e : Ge(n, t + 1);
  }
  if (Array.isArray(e))
    return e.map((n) => Ge(n, t + 1));
  if (Se(e)) {
    const n = {};
    for (const [r, i] of Object.entries(e))
      n[r] = Ge(i, t + 1);
    return n;
  }
  return e;
}
function Gt(e) {
  const t = e.trim();
  if (t.length < 2) return;
  if (t.startsWith('"') && t.endsWith('"'))
    try {
      const i = JSON.parse(t);
      if (typeof i == "string") return Gt(i);
    } catch {
    }
  const n = t.startsWith("{") && t.endsWith("}"), r = t.startsWith("[") && t.endsWith("]");
  if (!(!n && !r))
    try {
      return JSON.parse(t);
    } catch {
      return;
    }
}
function Se(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function xe(e, t = [], n = 0) {
  if (n > 12 || e == null) return t;
  if (typeof e == "string") {
    const l = Gt(e);
    return l !== void 0 ? xe(l, t, n + 1) : (ie(e) || ve(e) ? Ne(t, e) : e.length > 200 && Pe(e) && Ne(t, `data:image/png;base64,${De(e)}`), t);
  }
  if (Array.isArray(e)) {
    for (const l of e) xe(l, t, n + 1);
    return t;
  }
  if (!Se(e)) return t;
  const r = typeof e.type == "string" ? e.type.toLowerCase() : "", i = r === "image" || r === "image_url" || r === "input_image" || r === "media" || r === "file" || r === "blob";
  if (i) {
    const l = Es(e);
    l && Ne(t, l);
  }
  if (Se(e.source)) {
    const l = zr(e.source);
    l && Ne(t, l);
  }
  const a = ge(e, [
    "mimeType",
    "media_type",
    "mediaType",
    "mime",
    "contentType",
    "content_type"
  ]), o = ge(e, [
    "data",
    "base64",
    "image_base64",
    "b64",
    "imageData",
    "image_data",
    "bytes"
  ]);
  if (o && (a != null && a.startsWith("image/") || i || Pe(o)))
    if (ie(o))
      Ne(t, o);
    else if (ve(o))
      Ne(t, o);
    else {
      const l = a != null && a.startsWith("image/") ? a : "image/png";
      Ne(t, `data:${l};base64,${De(o)}`);
    }
  for (const l of [
    "content",
    "parts",
    "messages",
    "message",
    "result",
    "output",
    "outputs",
    "image",
    "images",
    "image_url",
    "thumbnail",
    "preview",
    "file",
    "files",
    "resource",
    "resources",
    "artifacts"
  ])
    l in e && xe(e[l], t, n + 1);
  if (n < 6)
    for (const [l, c] of Object.entries(e))
      (typeof c == "string" && /image|thumb|preview|photo|frame|snapshot/i.test(l) || typeof c == "object" && c !== null) && xe(c, t, n + 1);
  return t;
}
function Ne(e, t) {
  e.includes(t) || e.push(t);
}
function Es(e) {
  if ("image_url" in e) {
    const r = e.image_url;
    if (typeof r == "string") {
      if (ve(r) || ie(r)) return r;
      if (Pe(r)) return `data:image/png;base64,${De(r)}`;
    }
    if (Se(r)) {
      const i = ge(r, ["url", "image_url"]);
      if (i) {
        if (ve(i) || ie(i)) return i;
        if (Pe(i)) return `data:image/png;base64,${De(i)}`;
      }
    }
  }
  if ("url" in e && typeof e.url == "string" && (ve(e.url) || ie(e.url)))
    return e.url;
  if ("source" in e && Se(e.source))
    return zr(e.source);
  const t = ge(e, [
    "mimeType",
    "media_type",
    "mediaType",
    "mime",
    "contentType"
  ]), n = ge(e, ["data", "base64", "image_base64", "b64", "imageData"]);
  if (n) {
    if (ie(n) || ve(n)) return n;
    const r = t != null && t.startsWith("image/") ? t : "image/png";
    if (t != null && t.startsWith("image/") || Pe(n) || n.length > 80)
      return `data:${r};base64,${De(n)}`;
  }
  return null;
}
function zr(e) {
  const t = typeof e.type == "string" ? e.type.toLowerCase() : "";
  if (t === "url" || t === "image_url") {
    const r = ge(e, ["url", "image_url"]);
    if (r && (ve(r) || ie(r))) return r;
  }
  if (t === "base64" || t === "base64_image" || t === "image" || t === "") {
    const r = ge(e, ["media_type", "mediaType", "mimeType", "mime", "contentType"]) ?? "image/png", i = ge(e, ["data", "base64", "image_base64", "b64"]);
    if (i)
      return ie(i) ? i : `data:${r.startsWith("image/") ? r : "image/png"};base64,${De(i)}`;
  }
  const n = ge(e, ["url"]);
  return n && (ve(n) || ie(n)) ? n : null;
}
function ge(e, t) {
  for (const n of t) {
    const r = e[n];
    if (typeof r == "string" && r.length > 0) return r;
  }
  return null;
}
function ie(e) {
  return /^data:image\/[a-z0-9.+-]+;base64,/i.test(e.trim());
}
function ve(e) {
  return /^https?:\/\//i.test(e) ? !!(/\.(png|jpe?g|gif|webp|bmp|svg)(\?|#|$)/i.test(e) || /[?&](format|fm)=(png|jpe?g|gif|webp)\b/i.test(e) || /\/(image|images|img|media|photo|thumbnail|thumb|snapshot|frame)\b/i.test(e)) : !1;
}
function De(e) {
  const t = e.trim(), n = /^data:image\/[a-z0-9.+-]+;base64,(.+)$/i.exec(t);
  return (n == null ? void 0 : n[1]) ?? t.replace(/\s+/g, "");
}
function rt(e, t) {
  return e.length > t ? `${e.slice(0, t - 1)}…` : e;
}
const js = Ye(
  function({ item: t }) {
    var a;
    const n = [];
    for (const o of t.blocks)
      o.type === "tools" || n.length === 0 ? n.push([o]) : (a = n[n.length - 1]) == null || a.push(o);
    const r = t.blocks.length;
    let i = 0;
    return /* @__PURE__ */ d("div", { className: `pa-chat-turn${t.streaming ? " is-streaming" : ""}`, children: [
      /* @__PURE__ */ s("div", { className: "pa-chat-turn-rail", children: /* @__PURE__ */ s("span", { className: "pa-chat-turn-dot" }) }),
      /* @__PURE__ */ d("div", { className: "pa-chat-turn-blocks", children: [
        t.at && /* @__PURE__ */ s("div", { className: "pa-chat-turn-meta", children: /* @__PURE__ */ s("span", { className: "pa-chat-turn-time", children: ir(t.at) }) }),
        n.map((o, l) => /* @__PURE__ */ d("div", { className: "pa-chat-turn-step", children: [
          l > 0 && /* @__PURE__ */ s("div", { className: "pa-chat-turn-step-sep", "aria-hidden": "true" }),
          o.map((c) => {
            const u = i++;
            return /* @__PURE__ */ s(
              Os,
              {
                block: c,
                live: t.streaming && u === r - 1
              },
              u
            );
          })
        ] }, l))
      ] })
    ] });
  },
  (e, t) => Ze(e.item, t.item)
), Ls = {
  img({ src: e, alt: t }) {
    return typeof e != "string" || !e ? null : /* @__PURE__ */ s(ji, { src: e, alt: t, className: "md-prose-img" });
  },
  // A markdown image can be wrapped in a link — `[![alt](img)](href)`. Since our
  // `img` renders a <button> (the lightbox trigger), a naive render nests a
  // <button> inside the <a>: invalid HTML (interactive content inside
  // interactive content) and two competing click targets. When an anchor wraps
  // an image, drop the anchor and let the image open the in-app lightbox;
  // otherwise render a normal link unchanged.
  a({
    href: e,
    title: t,
    children: n,
    node: r
  }) {
    var a;
    return ((a = r == null ? void 0 : r.children) == null ? void 0 : a.some((o) => o.type === "element" && o.tagName === "img")) ? /* @__PURE__ */ s(re, { children: n }) : /* @__PURE__ */ s("a", { href: e, title: t, children: n });
  }
};
function Os({ block: e, live: t }) {
  switch (e.type) {
    case "text":
      return /* @__PURE__ */ d("div", { className: "pa-chat-text", children: [
        /* @__PURE__ */ s("div", { className: "md-prose", children: /* @__PURE__ */ s(Dn, { remarkPlugins: [En], components: Ls, children: e.text }) }),
        t && /* @__PURE__ */ s("span", { className: "pa-chat-caret" })
      ] });
    case "reasoning":
      return /* @__PURE__ */ s(Fs, { text: e.text, live: t });
    case "tools":
      return /* @__PURE__ */ s(As, { calls: e.calls, live: t });
    default:
      return null;
  }
}
function Fs({ text: e, live: t }) {
  const [n, r] = A(!1);
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: `pa-chat-reasoning-toggle${t ? " is-shimmer" : ""}`,
        onClick: () => r((i) => !i),
        children: [
          /* @__PURE__ */ s("span", { children: n ? "▾" : "▸" }),
          /* @__PURE__ */ s("span", { children: t ? "Thinking…" : "Thought process" })
        ]
      }
    ),
    n && /* @__PURE__ */ s("div", { className: "pa-chat-reasoning-body", children: e })
  ] });
}
const Ws = Ye(
  function({ item: t }) {
    const [n, r] = A(!1), i = Math.max(0, t.msgCount - t.summarizedCount);
    return /* @__PURE__ */ d("div", { className: "pa-chat-compaction", children: [
      /* @__PURE__ */ d(
        "button",
        {
          type: "button",
          className: "pa-chat-compaction__bar",
          "aria-expanded": n,
          onClick: () => r((a) => !a),
          title: t.forced ? "An operator compacted this thread here — click to see the summary the agent carries" : "The thread passed its message threshold and compacted here — click to see the summary the agent carries",
          children: [
            /* @__PURE__ */ d("span", { className: "pa-chat-compaction__label", children: [
              "Context compacted",
              t.forced ? /* @__PURE__ */ s("span", { className: "pa-chat-compaction__forced", children: " · manual" }) : null
            ] }),
            /* @__PURE__ */ d("span", { className: "pa-chat-compaction__meta", children: [
              "v",
              t.version,
              " · ",
              t.summarizedCount,
              " of ",
              t.msgCount,
              " messages summarized",
              i > 0 ? `, ${i} kept verbatim` : ""
            ] }),
            /* @__PURE__ */ s("span", { className: "pa-chat-compaction__chevron", "aria-hidden": "true", children: n ? "▴" : "▾" })
          ]
        }
      ),
      n && /* @__PURE__ */ d("div", { className: "pa-chat-compaction__body", children: [
        /* @__PURE__ */ s("p", { className: "pa-chat-compaction__note", children: "Everything above this point is what the agent now remembers as the summary below — the messages are still here, but its working context holds this instead." }),
        /* @__PURE__ */ s("pre", { className: "pa-chat-compaction__summary", children: t.summary })
      ] })
    ] });
  },
  (e, t) => Ze(e.item, t.item)
), Bs = /\b(out of credits?|insufficient[_ ]?(quota|funds|balance|credits?)|credit(?:s)? (?:exhausted|depleted|limit)|billing|payment[_ ]required|spend(?:ing)?[_ -]?limit|prepaid|top[- ]?up|add credits?|personal-team-blocked|need a grok subscription|run out of (?:available )?credits?|quota[_ ]?exceeded)\b/i, Ks = /\b(invalid[_ ]?(api[_ ]?)?key|incorrect[_ ]api[_ ]key|unauthorized|authentication[_ ]?(failed|error)|api key (?:is )?invalid|invalid_api_key)\b/i, Us = /\b(rate[_ ]?limit(?:ed)?|too many requests|retry[- ]after)\b/i, Hs = /\b(xai|x\.ai|grok)\b/i;
function Gs(e, t) {
  const n = t ?? qs(e), r = Hs.test(e);
  switch (n) {
    case "billing":
      return {
        kind: "billing",
        title: r ? "Grok / xAI credits exhausted" : "Provider credits exhausted",
        remediation: r ? "Add credits or raise the spend limit at console.x.ai, then retry. Updating the API key alone will not fix this." : "Top up the provider account or raise the spend/quota limit, then retry.",
        tone: "billing"
      };
    case "auth":
      return {
        kind: "auth",
        title: "API key rejected",
        remediation: "Update the model config with a valid API key and re-test.",
        tone: "auth"
      };
    case "rate_limit":
      return {
        kind: "rate_limit",
        title: "Provider rate limit",
        remediation: "The provider throttled this account. Wait a moment and retry.",
        tone: "rate"
      };
    case "provider_unavailable":
      return {
        kind: "provider_unavailable",
        title: "Provider temporarily unavailable",
        remediation: "Retry shortly; if it persists, check the provider status page.",
        tone: "danger"
      };
    case "bad_request":
      return {
        kind: "bad_request",
        title: "Provider rejected the request",
        remediation: "Check prompts, tools, and multimodal payloads for this model.",
        tone: "danger"
      };
    case "provider_error":
    default:
      return {
        kind: "provider_error",
        title: "Provider error",
        remediation: "See details below. Verify the model config if this keeps happening.",
        tone: "danger"
      };
  }
}
function qs(e) {
  return Bs.test(e) || /\b402\b/.test(e) ? "billing" : Ks.test(e) || /\b401\b/.test(e) ? "auth" : Us.test(e) || /\b429\b/.test(e) ? "rate_limit" : "provider_error";
}
const Vs = Ye(
  function({ item: t }) {
    const n = t.passed, r = n === !0 ? "badge badge--success" : n === !1 ? "badge badge--warning" : "badge badge--neutral", i = n === !0 ? "passed" : n === !1 ? "not completed" : "pending";
    return /* @__PURE__ */ d("div", { className: `pa-chat-goal${n === !0 ? " is-passed" : ""}`, children: [
      /* @__PURE__ */ d("div", { style: { display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }, children: [
        /* @__PURE__ */ s(
          "span",
          {
            className: "badge badge--outline",
            style: { fontSize: 9, fontFamily: "var(--font-mono)", textTransform: "uppercase" },
            children: t.status ?? "evaluating"
          }
        ),
        /* @__PURE__ */ s("span", { className: r, style: { fontSize: 9 }, children: i }),
        (typeof t.iteration == "number" || typeof t.maxRuns == "number") && /* @__PURE__ */ d(
          "span",
          {
            className: "t-xs t-muted",
            style: { marginLeft: "auto", fontFamily: "var(--font-mono)" },
            children: [
              t.iteration ?? "?",
              "/",
              t.maxRuns ?? "?"
            ]
          }
        )
      ] }),
      t.objective && /* @__PURE__ */ s(
        "div",
        {
          style: {
            fontSize: "var(--fs-xs)",
            lineHeight: 1.6,
            color: "var(--text-primary)",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word"
          },
          children: t.objective
        }
      ),
      t.reason && /* @__PURE__ */ s(
        "div",
        {
          style: {
            fontSize: 12,
            lineHeight: 1.5,
            color: "var(--text-secondary)",
            marginTop: 6,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word"
          },
          children: t.reason
        }
      )
    ] });
  },
  (e, t) => Ze(e.item, t.item)
), Js = Ye(
  function({ item: t }) {
    const n = Gs(
      t.message,
      t.kindCode ?? null
    ), r = n.tone === "billing" ? "is-billing" : n.tone === "auth" ? "is-auth" : n.tone === "rate" ? "is-rate" : "";
    return /* @__PURE__ */ d("div", { className: `pa-chat-error ${r}`.trim(), children: [
      /* @__PURE__ */ s("div", { className: "pa-chat-error__title", children: n.title }),
      /* @__PURE__ */ s("div", { className: "pa-chat-error__remediation", children: n.remediation }),
      /* @__PURE__ */ d("details", { className: "pa-chat-error__details", children: [
        /* @__PURE__ */ s("summary", { children: "Technical details" }),
        /* @__PURE__ */ s("pre", { children: t.message })
      ] })
    ] });
  },
  (e, t) => Ze(e.item, t.item)
);
function Xs(e, t) {
  const [n, r] = e.split(/:(.+)/);
  switch (n) {
    case "user":
      return r ?? "";
    case "slack":
      return `${r ?? ""} (Slack)`;
    case "system":
      return `system · ${r ?? ""}`;
    case "timer":
      return r === "heartbeat" ? "♥ heartbeat" : "⏰ timer";
    case "agent":
      return `agent: ${Ys(r ?? "", t)}`;
    case "webhook":
      return `webhook · ${r ?? ""}`;
    default:
      return e;
  }
}
function Ys(e, t) {
  const n = t == null ? void 0 : t[e];
  return n ? `${n.name ?? e.slice(0, 8)} (${n.agentName})` : e.slice(0, 8);
}
function $l(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    if (n != null && n.startsWith("agent:")) {
      const r = n.slice(6);
      r && t.add(r);
    }
  return [...t].sort();
}
const Qs = {
  interrupt: { label: "⚡ STEER", className: "pa-chat-chip--steer" },
  now: null,
  "next-turn": { label: "NEXT TURN", className: "" },
  "when-idle": { label: "WHEN IDLE", className: "" },
  inbox: { label: "INBOX", className: "pa-chat-chip--muted" }
}, Zs = Ye(
  function({
    item: t,
    onRetry: n,
    agentNames: r,
    minimalChrome: i
  }) {
    const a = t.source.startsWith("slack:"), o = t.source.startsWith("user:") || a, l = !i && t.delivery ? Qs[t.delivery] : null, c = t.state === "failed";
    return /* @__PURE__ */ d("div", { className: `pa-chat-user${o ? "" : " pa-chat-user--other"}`, children: [
      t.interrupted && /* @__PURE__ */ s("div", { className: "pa-chat-interrupt-divider", children: "interrupted previous run" }),
      /* @__PURE__ */ s(
        "div",
        {
          className: `pa-chat-user-bubble${c ? " is-failed" : ""}`,
          onClick: c && n ? () => n(t.key) : void 0,
          title: c ? "Tap to retry" : void 0,
          children: t.text
        }
      ),
      /* @__PURE__ */ d("div", { className: "pa-chat-user-meta", children: [
        (!o || a) && t.source && /* @__PURE__ */ s("span", { className: "pa-chat-chip", title: t.source, children: Xs(t.source, r) }),
        l && /* @__PURE__ */ s("span", { className: `pa-chat-chip ${l.className}`, children: l.label }),
        t.at && /* @__PURE__ */ s("span", { children: ir(t.at) }),
        t.state === "pending" && /* @__PURE__ */ d("span", { className: "pa-chat-user-sending pa-chat-pending-text", children: [
          /* @__PURE__ */ s(er, { tone: "user" }),
          " Sending…"
        ] }),
        c && /* @__PURE__ */ s(
          "span",
          {
            className: "pa-chat-chip pa-chat-chip--failed",
            onClick: n ? () => n(t.key) : void 0,
            children: "failed — tap to retry"
          }
        )
      ] })
    ] });
  },
  (e, t) => e.onRetry === t.onRetry && e.agentNames === t.agentNames && e.minimalChrome === t.minimalChrome && Ze(e.item, t.item)
), qt = 6e4, Dt = 60 * qt, kn = 24 * Dt, eo = 10 * qt;
function to(e, t) {
  if (!e || !t) return null;
  const n = Date.parse(e), r = Date.parse(t);
  if (Number.isNaN(n) || Number.isNaN(r)) return null;
  const i = r - n;
  return i < eo ? null : i < Dt ? `${Math.round(i / qt)}m` : i < kn ? `${Math.round(i / Dt)}h` : `${Math.round(i / kn)}d`;
}
function no() {
  return /* @__PURE__ */ d(
    "svg",
    {
      className: "pa-chat-empty__mark",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.75",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ s("rect", { x: "4", y: "7", width: "16", height: "12", rx: "2" }),
        /* @__PURE__ */ s("path", { d: "M9 12h.01M15 12h.01" }),
        /* @__PURE__ */ s("path", { d: "M12 3v4" })
      ]
    }
  );
}
const ro = 96, _n = [
  "Thinking…",
  "Working…",
  "Computing…",
  "Reasoning…",
  "Planning…",
  "Analyzing…",
  "Routing…",
  "Invoking…",
  "Calibrating…",
  "Processing…",
  "Perceiving…",
  "Pathfinding…"
], Nn = 80, io = 6e3, ao = 6, so = 1e4;
function it(e) {
  return e.scrollHeight - e.scrollTop - e.clientHeight <= ro;
}
function oo(e, t) {
  return e || t;
}
function lo(e) {
  const t = e.querySelectorAll("img");
  for (let n = 0; n < t.length; n += 1) {
    const r = t[n];
    if (r && !r.complete) return !0;
  }
  return !1;
}
function co({
  items: e,
  status: t,
  activity: n,
  connection: r,
  loading: i,
  emptyMark: a,
  leadingSlot: o,
  onRetry: l,
  renderIncident: c,
  agentNames: u,
  minimalChrome: f
}) {
  var W;
  const h = ei() ?? !1, m = z(null), y = z(null), v = z(null), b = z(!0), [C, g] = A(!0), [M, $] = A(0), _ = z(0), [P, j] = A(0), x = z(0), N = z(!1), S = z(!0), p = z(null), T = z(0), R = z(!1), w = z(null), k = z(null), F = k.current ?? new Set(e.map((I) => I.key));
  k.current === null && (k.current = F);
  const B = () => {
    const I = m.current;
    if (!I) return;
    const O = Math.max(I.scrollHeight, I.offsetHeight, 0);
    I.scrollTop = O, requestAnimationFrame(() => {
      const q = m.current;
      q && (S.current || b.current) && (q.scrollTop = Math.max(q.scrollHeight, q.offsetHeight, 0));
    });
  }, K = () => {
    S.current && (S.current = !1, p.current = null, T.current = 0, B(), b.current = !0, g(!0));
  }, G = () => {
    S.current = !1, p.current = null, T.current = 0, R.current = !0, b.current && (b.current = !1, g(!1));
  }, D = () => {
    const I = m.current;
    if (!I || S.current) return;
    const O = it(I);
    if (R.current)
      if (!O) R.current = !1;
      else return;
    O !== b.current && (b.current = O, g(O)), O && $(0);
  }, L = (I) => {
    if (I.deltaY < 0) {
      G();
      return;
    }
    if (I.deltaY > 0 && R.current) {
      const O = m.current;
      O && it(O) && (R.current = !1);
    }
  }, Z = e.some((I) => I.kind === "turn" && I.streaming), ee = t === "WORKING" && !Z;
  ee && !N.current && (x.current = (x.current + 1) % _n.length), N.current = ee;
  const ae = _n[x.current] ?? "Working…", se = Math.max(0, e.length - Nn - P), ue = Q(() => e.slice(se), [e, se]), he = se, ye = e.length > 0 ? ((W = e[e.length - 1]) == null ? void 0 : W.key) ?? null : null;
  let oe;
  for (let I = Math.max(0, se - 1); I < se; I += 1) {
    const O = e[I];
    O != null && O.at && (oe = O.at);
  }
  const ce = ue.map((I) => {
    const O = I.at ? to(oe, I.at) : null;
    return I.at && (oe = I.at), O;
  });
  ct(() => {
    const I = m.current;
    if (!I) return;
    const O = w.current;
    if (O) {
      w.current = null;
      const me = I.scrollHeight - O.prevScrollHeight;
      me > 0 && (I.scrollTop = O.prevScrollTop + me), _.current = e.length;
      return;
    }
    const q = e[e.length - 1], te = (q == null ? void 0 : q.kind) === "user" && q.state === "pending", _e = e.length > _.current;
    S.current && e.length > 0 && p.current === null && (p.current = performance.now(), T.current = 0), oo(S.current, te) && (b.current = !0, g(!0), te && $(0)), b.current || S.current ? B() : _e && $((me) => me + (e.length - _.current)), _.current = e.length;
  }, [e, P, ye, ee]), ct(() => {
    const I = m.current;
    if (!I) return;
    let O = 0, q = !1;
    const te = performance.now();
    let _e = -1, me = -1, Fe = 0;
    const pe = () => {
      q || O || (O = requestAnimationFrame(() => {
        O = 0, yt();
      }));
    }, yt = () => {
      if (q) return;
      const E = m.current;
      if (!E) return;
      const H = E.scrollHeight, Y = e.length, X = lo(E), V = H === _e, de = Y === me;
      if (_e = H, me = Y, S.current) {
        if (Y === 0) {
          pe();
          return;
        }
        B(), Fe = it(E) && V && de && !X && H > 0 ? Fe + 1 : 0;
        const Xt = performance.now();
        p.current === null && (p.current = Xt);
        const Ur = p.current, Hr = Xt - Ur >= io;
        if (Fe >= ao || Hr) {
          E.scrollTop = E.scrollHeight, K(), (!V || !de || X) && pe();
          return;
        }
        pe();
        return;
      }
      if (b.current) {
        const vt = !V || !de || X;
        (!it(E) || vt) && B();
        const Jt = performance.now() - te >= so;
        vt && !Jt && pe();
      }
    }, bt = () => {
      q || (S.current || b.current) && (B(), pe());
    }, Te = () => {
      q || (S.current || b.current) && (B(), pe());
    };
    (S.current || b.current) && B(), pe();
    const ne = typeof ResizeObserver < "u" ? new ResizeObserver(bt) : null;
    return ne == null || ne.observe(I), y.current && (ne == null || ne.observe(y.current)), v.current && (ne == null || ne.observe(v.current)), I.addEventListener("load", Te, !0), I.addEventListener("error", Te, !0), () => {
      q = !0, O && cancelAnimationFrame(O), ne == null || ne.disconnect(), I.removeEventListener("load", Te, !0), I.removeEventListener("error", Te, !0);
    };
  }, [e.length, P, ee]);
  const Oe = () => {
    R.current = !1, b.current = !0, g(!0), $(0), B(), S.current && K();
  }, $e = () => {
    const I = m.current;
    I && (w.current = {
      prevScrollHeight: I.scrollHeight,
      prevScrollTop: I.scrollTop
    }), b.current = !1, g(!1), j((O) => O + Nn);
  };
  return /* @__PURE__ */ d("div", { className: "pa-chat-scroller-wrap", children: [
    r === "reconnecting" && /* @__PURE__ */ d("div", { className: "pa-chat-reconnect", children: [
      /* @__PURE__ */ s(ft, { inline: !0 }),
      " Reconnecting to live stream…"
    ] }),
    /* @__PURE__ */ s(
      "div",
      {
        className: "pa-chat-scroller",
        ref: m,
        onScroll: D,
        onWheel: L,
        children: e.length === 0 && !ee && !o ? (
          // While the initial replay is still in flight, show a spinner rather
          // than the "empty thread" copy — otherwise opening a thread with
          // history flashes "What should we explore?" for the replay
          // window before the transcript lands. (A fully blank slot here read
          // as the transcript vanishing on slow cold-start connects.)
          i ? /* @__PURE__ */ s("div", { className: "pa-chat-empty", "aria-busy": "true", "aria-label": "Loading conversation", children: /* @__PURE__ */ s(ft, {}) }) : /* @__PURE__ */ d("div", { className: "pa-chat-empty pa-chat-empty--prompt", children: [
            a ?? /* @__PURE__ */ s(no, {}),
            "What should we explore?"
          ] })
        ) : /* @__PURE__ */ d("div", { className: "pa-chat-content", ref: y, children: [
          o,
          he > 0 && /* @__PURE__ */ d("button", { type: "button", className: "pa-chat-load-older", onClick: $e, children: [
            "Show earlier messages (",
            he,
            " hidden)"
          ] }),
          ue.map((I, O) => {
            const q = !F.has(I.key);
            return q && F.add(I.key), /* @__PURE__ */ s("div", { className: "pa-chat-row", children: q && !h ? /* @__PURE__ */ d(
              Yt.div,
              {
                initial: { opacity: 0 },
                animate: { opacity: 1 },
                transition: { duration: 0.1 },
                children: [
                  ce[O] && /* @__PURE__ */ d("div", { className: "pa-chat-idle-gap", children: [
                    "idle ",
                    ce[O]
                  ] }),
                  /* @__PURE__ */ s(
                    xn,
                    {
                      item: I,
                      onRetry: l,
                      renderIncident: c,
                      agentNames: u,
                      minimalChrome: f
                    }
                  )
                ]
              }
            ) : /* @__PURE__ */ d(re, { children: [
              ce[O] && /* @__PURE__ */ d("div", { className: "pa-chat-idle-gap", children: [
                "idle ",
                ce[O]
              ] }),
              /* @__PURE__ */ s(
                xn,
                {
                  item: I,
                  onRetry: l,
                  renderIncident: c,
                  agentNames: u,
                  minimalChrome: f
                }
              )
            ] }) }, I.key);
          }),
          ee && /* @__PURE__ */ d("div", { className: "pa-chat-working pa-chat-pending-text", children: [
            /* @__PURE__ */ s(er, { tone: "agent" }),
            (n == null ? void 0 : n.text) ?? ae
          ] }),
          /* @__PURE__ */ s("div", { ref: v, className: "pa-chat-bottom-anchor", "aria-hidden": "true" })
        ] })
      }
    ),
    /* @__PURE__ */ s(ti, { children: !C && /* @__PURE__ */ d(
      Yt.button,
      {
        type: "button",
        className: "pa-chat-fab",
        onClick: Oe,
        initial: h ? !1 : { opacity: 0, y: 8 },
        animate: { opacity: 1, y: 0 },
        exit: h ? void 0 : { opacity: 0, y: 8 },
        transition: { duration: 0.15 },
        children: [
          "↓",
          M > 0 ? ` ${M} new` : ""
        ]
      }
    ) })
  ] });
}
function xn({
  item: e,
  onRetry: t,
  renderIncident: n,
  agentNames: r,
  minimalChrome: i
}) {
  switch (e.kind) {
    case "user":
      return /* @__PURE__ */ s(
        Zs,
        {
          item: e,
          onRetry: t,
          agentNames: r,
          minimalChrome: i
        }
      );
    case "turn":
      return /* @__PURE__ */ s(js, { item: e });
    case "goal":
      return /* @__PURE__ */ s(Vs, { item: e });
    case "error":
      return /* @__PURE__ */ s(Js, { item: e });
    case "incident":
      return n ? /* @__PURE__ */ s(re, { children: n(e.runId) }) : null;
    case "compaction":
      return /* @__PURE__ */ s(Ws, { item: e });
    default:
      return null;
  }
}
const Re = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center"
};
function uo({
  onSend: e,
  onInterrupt: t,
  disabled: n,
  busy: r,
  busyReason: i,
  autosendOnDictation: a,
  pushToDictateKey: o,
  hideDictation: l,
  autoReadAloud: c,
  onAutoReadAloudChange: u,
  thinking: f,
  onThinkingChange: h,
  audioPlaying: m,
  onStopAudio: y,
  onDictationStart: v
}) {
  const [b, C] = A(""), [g, M] = A(!1), $ = z(null), _ = z(!1), P = z(!1), j = z(v);
  U(() => {
    j.current = v;
  }, [v]);
  const x = yi(
    (k) => {
      var F;
      C((B) => B ? `${B} ${k}` : k), a && (_.current = !0), (F = $.current) == null || F.focus();
    },
    () => {
      var k;
      return (k = j.current) == null ? void 0 : k.call(j);
    }
  );
  U(() => {
    const k = $.current;
    if (!k) return;
    const F = () => {
      k.style.height = "auto", k.style.height = `${Math.min(k.scrollHeight, Math.round(window.innerHeight * 0.4))}px`;
    };
    return F(), window.addEventListener("resize", F), () => window.removeEventListener("resize", F);
  }, [b]), U(() => {
    var k;
    !n && !r && ((k = $.current) == null || k.focus());
  }, []);
  const N = z(n);
  U(() => {
    var k;
    N.current && !n && !r && ((k = $.current) == null || k.focus()), N.current = n;
  }, [n, r]);
  function S() {
    const k = b.trim();
    if (!(!k || n)) {
      if (r) {
        M(!0);
        return;
      }
      e(k), C("");
    }
  }
  U(() => {
    if (!g || r || n) return;
    M(!1);
    const k = b.trim();
    k && (e(k), C(""));
  }, [g, r, n, b, e]), U(() => {
    if (!_.current || x.state !== "idle") return;
    const k = b.trim();
    if (_.current = !1, !(!k || n)) {
      if (r) {
        M(!0);
        return;
      }
      e(k), C("");
    }
  }, [b, x.state, n, r, e]), U(() => {
    if (!o) return;
    const k = o.toLowerCase();
    function F(K) {
      K.repeat || (K.ctrlKey || K.metaKey) && K.key.toLowerCase() === k && (n || r || (K.preventDefault(), x.state === "idle" && (P.current = !0, x.toggle())));
    }
    function B(K) {
      const G = K.key.toLowerCase();
      G !== k && G !== "control" && G !== "meta" || P.current && (x.state === "recording" ? (P.current = !1, x.toggle()) : P.current = !1);
    }
    return window.addEventListener("keydown", F), window.addEventListener("keyup", B), () => {
      window.removeEventListener("keydown", F), window.removeEventListener("keyup", B);
    };
  }, [o, x, n, r]);
  let p = "", T = "";
  g && r ? (p = "Queued — sends when the agent finishes (Esc to cancel)", T = "is-queued") : r && i ? p = i : x.state === "recording" ? (p = P.current ? "Release to send" : "Recording — click to stop", T = "is-recording") : x.state === "transcribing" ? (p = "Transcribing", T = "is-transcribing") : x.error && (p = x.error, T = "is-error");
  const R = o ? `Dictate (or hold Ctrl+${o.toUpperCase()})` : "Dictate";
  return /* @__PURE__ */ d("div", { className: "refinement-composer", children: [
    /* @__PURE__ */ d("div", { className: `refinement-input-well${n ? " is-locked" : ""}`, children: [
      /* @__PURE__ */ s(
        "textarea",
        {
          ref: $,
          className: "refinement-composer__textarea",
          placeholder: "Write a message...",
          value: b,
          onChange: (k) => C(k.target.value),
          onKeyDown: (k) => {
            k.key === "Enter" && !k.shiftKey ? (k.preventDefault(), S()) : k.key === "Escape" && g && M(!1);
          },
          disabled: n,
          rows: 1
        }
      ),
      /* @__PURE__ */ d("div", { className: "refinement-well-toolbar", children: [
        h ? /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: `refinement-mode__icon ${f ? "is-thinking" : "is-fast"}`,
            "aria-label": f ? "Switch to Fast mode" : "Switch to Thinking mode",
            "aria-pressed": !!f,
            onClick: () => h(!f),
            title: f ? "Thinking mode — click for Fast" : "Fast mode — click for Thinking",
            children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: f ? /* @__PURE__ */ s(fo, {}) : /* @__PURE__ */ s(ho, {}) })
          }
        ) : /* @__PURE__ */ s("span", {}),
        /* @__PURE__ */ d("div", { className: "refinement-well-actions", children: [
          l ? null : /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: `refinement-well-btn refinement-mic is-${x.state}`,
              "aria-label": x.state === "recording" ? "Stop recording" : "Start dictation",
              onClick: () => x.toggle(),
              disabled: n || x.state === "transcribing",
              title: x.state === "recording" ? "Stop recording" : R,
              children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: x.state === "recording" ? /* @__PURE__ */ s(Sn, {}) : /* @__PURE__ */ s(mo, {}) })
            }
          ),
          u ? m && y ? /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: "refinement-well-btn refinement-auto-read is-stop",
              "aria-label": "Stop reading aloud",
              onClick: y,
              title: "Stop reading aloud",
              children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: /* @__PURE__ */ s(bo, {}) })
            }
          ) : /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: `refinement-well-btn refinement-auto-read${c ? " is-on" : ""}`,
              "aria-label": c ? "Disable auto read-aloud" : "Enable auto read-aloud",
              "aria-pressed": !!c,
              onClick: () => u(!c),
              title: c ? "Auto read-aloud is ON — assistant replies will be spoken" : "Auto read-aloud is OFF — click to have assistant replies spoken automatically",
              children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: c ? /* @__PURE__ */ s(po, {}) : /* @__PURE__ */ s(go, {}) })
            }
          ) : null,
          r && t && !n ? /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: "refinement-send-btn refinement-stop-turn is-active",
              onClick: t,
              "aria-label": "Stop the agent's current turn",
              title: "Stop the agent's current turn",
              children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: /* @__PURE__ */ s(Sn, {}) })
            }
          ) : /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: `refinement-send-btn${b.trim() ? " is-active" : ""}`,
              onClick: S,
              disabled: n || !b.trim(),
              title: r ? "Queue — sends when the agent finishes" : "Send (Enter — Shift+Enter for newline)",
              children: /* @__PURE__ */ s("span", { style: Re, "aria-hidden": "true", children: /* @__PURE__ */ s(yo, {}) })
            }
          )
        ] })
      ] })
    ] }),
    p ? /* @__PURE__ */ s("div", { className: `refinement-composer__hint ${T}`, children: p }) : null
  ] });
}
const Cn = 16, ke = {
  width: Cn,
  height: Cn,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": !0
};
function fo() {
  return /* @__PURE__ */ d("svg", { ...ke, children: [
    /* @__PURE__ */ s("path", { d: "M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44A2.5 2.5 0 0 1 4.5 17.5 2.5 2.5 0 0 1 3 13a2.5 2.5 0 0 1 .23-4A2.5 2.5 0 0 1 5 4.72 2.5 2.5 0 0 1 9.5 2Z" }),
    /* @__PURE__ */ s("path", { d: "M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.54-2.44 2.5 2.5 0 0 0 1.5-4.5 2.5 2.5 0 0 0-.23-4A2.5 2.5 0 0 0 19 4.72 2.5 2.5 0 0 0 14.5 2Z" })
  ] });
}
function ho() {
  return /* @__PURE__ */ s("svg", { ...ke, fill: "currentColor", stroke: "none", children: /* @__PURE__ */ s("path", { d: "M13 2 4.09 12.69a.5.5 0 0 0 .38.81H11l-1 8.5 8.91-10.69a.5.5 0 0 0-.38-.81H13l1-8.5Z" }) });
}
function mo() {
  return /* @__PURE__ */ d("svg", { ...ke, children: [
    /* @__PURE__ */ s("rect", { x: "9", y: "3", width: "6", height: "11", rx: "3" }),
    /* @__PURE__ */ s("path", { d: "M5 11a7 7 0 0 0 14 0" }),
    /* @__PURE__ */ s("line", { x1: "12", y1: "18", x2: "12", y2: "22" }),
    /* @__PURE__ */ s("line", { x1: "8", y1: "22", x2: "16", y2: "22" })
  ] });
}
function Sn() {
  return /* @__PURE__ */ s("svg", { ...ke, fill: "currentColor", stroke: "none", children: /* @__PURE__ */ s("rect", { x: "6", y: "6", width: "12", height: "12", rx: "1.5" }) });
}
function po() {
  return /* @__PURE__ */ d("svg", { ...ke, children: [
    /* @__PURE__ */ s("path", { d: "M11 5 6 9H3v6h3l5 4z" }),
    /* @__PURE__ */ s("path", { d: "M19.07 4.93a10 10 0 0 1 0 14.14" }),
    /* @__PURE__ */ s("path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07" })
  ] });
}
function go() {
  return /* @__PURE__ */ d("svg", { ...ke, children: [
    /* @__PURE__ */ s("path", { d: "M11 5 6 9H3v6h3l5 4z" }),
    /* @__PURE__ */ s("line", { x1: "17", y1: "9", x2: "22", y2: "14" }),
    /* @__PURE__ */ s("line", { x1: "22", y1: "9", x2: "17", y2: "14" })
  ] });
}
function yo() {
  return /* @__PURE__ */ d("svg", { ...ke, strokeWidth: 2.5, children: [
    /* @__PURE__ */ s("path", { d: "M12 19V5" }),
    /* @__PURE__ */ s("path", { d: "M5 12l7-7 7 7" })
  ] });
}
function bo() {
  return /* @__PURE__ */ d("svg", { ...ke, children: [
    /* @__PURE__ */ s("circle", { cx: "12", cy: "12", r: "9" }),
    /* @__PURE__ */ s("rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", fill: "currentColor", stroke: "none" })
  ] });
}
function vo(e) {
  return [...e].sort((t, n) => {
    const r = t.startedAt ? new Date(t.startedAt).getTime() : 0, i = n.startedAt ? new Date(n.startedAt).getTime() : 0;
    if (r !== i) return r - i;
    const a = t.createdAt ? new Date(t.createdAt).getTime() : 0, o = n.createdAt ? new Date(n.createdAt).getTime() : 0;
    return a - o;
  });
}
const wo = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "var(--sp-1)",
  padding: "var(--sp-2) 0"
}, Pr = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--sp-2)",
  padding: "5px 10px",
  borderRadius: "var(--radius-pill)",
  border: "1px solid var(--border)",
  background: "var(--surface)",
  color: "var(--text-primary)",
  cursor: "pointer",
  fontSize: "var(--fs-xs)",
  fontFamily: "var(--font-mono, monospace)",
  lineHeight: 1.2
}, ko = {
  ...Pr,
  borderColor: "var(--horizon-glow)",
  background: "color-mix(in oklab, var(--horizon-glow) 10%, var(--surface))"
}, _o = {
  width: 8,
  height: 8,
  borderRadius: "50%",
  flex: "0 0 auto"
}, No = {
  color: "var(--text-muted)",
  fontSize: "var(--fs-sm)",
  padding: "0 2px"
}, xo = {
  marginTop: "var(--sp-2)",
  border: "1px solid var(--border-subtle)",
  borderRadius: "var(--radius)",
  background: "var(--surface)",
  overflow: "hidden"
}, Co = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "var(--sp-2)",
  padding: "var(--sp-2) var(--sp-3)",
  borderBottom: "1px solid var(--border-subtle)",
  fontSize: "var(--fs-xs)",
  color: "var(--text-secondary)"
}, So = {
  maxHeight: 340,
  overflowY: "auto"
};
function Mo({ executions: e }) {
  const t = vo(e), [n, r] = A(null), i = t.find((a) => a.id === n) ?? null;
  return t.length === 0 ? /* @__PURE__ */ s("div", { style: { fontSize: "var(--fs-xs)", color: "var(--text-muted)", fontStyle: "italic" }, children: "No steps were recorded for this incident." }) : /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ s("div", { style: wo, role: "list", "aria-label": "Steps that ran", children: t.map((a, o) => {
      const l = a.id === n, c = a.nodeKey ?? `${a.nodeId.slice(0, 6)}…`;
      return /* @__PURE__ */ d(
        "span",
        {
          style: { display: "inline-flex", alignItems: "center" },
          role: "listitem",
          children: [
            o > 0 ? /* @__PURE__ */ s("span", { style: No, "aria-hidden": "true", children: "→" }) : null,
            /* @__PURE__ */ d(
              "button",
              {
                type: "button",
                style: l ? ko : Pr,
                onClick: () => r(l ? null : a.id),
                "aria-expanded": l,
                title: `${c} — ${a.status.toLowerCase()}`,
                children: [
                  /* @__PURE__ */ s("span", { style: { ..._o, background: To(a.status) }, "aria-hidden": "true" }),
                  c
                ]
              }
            )
          ]
        },
        a.id
      );
    }) }),
    i ? /* @__PURE__ */ d("div", { style: xo, children: [
      /* @__PURE__ */ d("div", { style: Co, children: [
        /* @__PURE__ */ s("span", { className: "t-mono", style: { color: "var(--text-primary)" }, children: i.nodeKey ?? `${i.nodeId.slice(0, 8)}…` }),
        /* @__PURE__ */ d("span", { style: { display: "inline-flex", gap: "var(--sp-2)", alignItems: "center" }, children: [
          /* @__PURE__ */ s("span", { className: `badge ${Io(i.status)}`, children: i.status }),
          /* @__PURE__ */ s("span", { children: Ot(i.startedAt ?? null, i.finishedAt ?? null) })
        ] })
      ] }),
      /* @__PURE__ */ s("div", { style: So, children: /* @__PURE__ */ s($o, { node: i }) })
    ] }) : /* @__PURE__ */ s("div", { style: { fontSize: "var(--fs-xs)", color: "var(--text-muted)", paddingTop: 2 }, children: "Select a step to read what happened." })
  ] });
}
function $o({ node: e }) {
  const t = e.input != null, n = e.output != null, r = e.error != null;
  return !t && !n && !r ? /* @__PURE__ */ s(
    "div",
    {
      className: "pa-chat-tool-detail",
      style: { fontSize: "var(--fs-xs)", color: "var(--text-muted)" },
      children: "No input or output was recorded for this step."
    }
  ) : /* @__PURE__ */ d("div", { className: "pa-chat-tool-detail", children: [
    t ? /* @__PURE__ */ s(St, { label: "input", children: /* @__PURE__ */ s(He, { value: e.input }) }) : null,
    n ? /* @__PURE__ */ s(St, { label: "output", children: /* @__PURE__ */ s(He, { value: e.output }) }) : null,
    r ? /* @__PURE__ */ s(St, { label: "error", danger: !0, children: /* @__PURE__ */ s(He, { value: e.error }) }) : null
  ] });
}
function St({
  label: e,
  danger: t,
  defaultOpen: n = !0,
  children: r
}) {
  const [i, a] = A(n);
  return /* @__PURE__ */ d("div", { children: [
    /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: "pa-chat-tool-pane-label",
        onClick: () => a((o) => !o),
        "aria-expanded": i,
        style: {
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          background: "transparent",
          border: 0,
          padding: 0,
          cursor: "pointer",
          ...t ? { color: "var(--status-danger)" } : {}
        },
        children: [
          /* @__PURE__ */ s("span", { "aria-hidden": "true", children: i ? "▾" : "▸" }),
          e
        ]
      }
    ),
    i ? r : null
  ] });
}
function To(e) {
  return e === "COMPLETED" ? "var(--status-completed)" : e === "FAILED" ? "var(--status-failed)" : e === "RUNNING" ? "var(--status-running)" : e === "PAUSED" ? "var(--status-input-required)" : e === "SKIPPED" ? "var(--status-neutral)" : "var(--status-pending)";
}
function Io(e) {
  return e === "COMPLETED" ? "badge--success" : e === "FAILED" ? "badge--danger" : e === "RUNNING" || e === "PAUSED" ? "badge--warning" : "badge--neutral";
}
const Ro = {
  COMPLETED: { label: "Fixed automatically", tone: "ok" },
  PAUSED: { label: "Needs a decision", tone: "warn" },
  FAILED: { label: "Didn’t finish", tone: "bad" },
  RUNNING: { label: "Working on it", tone: "info" },
  PENDING: { label: "Working on it", tone: "info" },
  CANCELLED: { label: "Stopped", tone: "neutral" },
  ABORTED: { label: "Stopped", tone: "neutral" }
};
function Vt(e) {
  return Ro[e] ?? { label: e, tone: "neutral" };
}
const Ao = {
  ok: { fg: "var(--status-completed)", bg: "var(--status-completed-bg)" },
  warn: { fg: "var(--status-input-required)", bg: "var(--status-input-required-bg)" },
  bad: { fg: "var(--status-failed)", bg: "var(--status-failed-bg)" },
  info: { fg: "var(--status-running)", bg: "var(--status-running-bg)" },
  neutral: { fg: "var(--status-neutral)", bg: "var(--status-neutral-bg)" }
};
function Dr(e) {
  return Ao[e];
}
const zo = {
  ok: "success",
  warn: "warning",
  bad: "danger",
  info: "info",
  neutral: "neutral"
};
function Er(e) {
  return `badge badge--${zo[e]}`;
}
const Po = ["device", "deviceId", "device_id", "robot", "robotId", "agv", "unit"], Do = ["message", "summary", "description", "alarm", "text", "title"];
function jr(e, t) {
  if (!e) return null;
  for (const n of t) {
    const r = e[n];
    if (typeof r == "string" && r.trim().length > 0) return r.trim();
  }
  return null;
}
function Lr(e) {
  return jr(e.input, Po);
}
function Or(e, t) {
  const n = jr(e.input, Do);
  return n ? Eo(n, 72) : t && t.trim().length > 0 ? t.trim() : `Run ${e.id.slice(0, 8)}…`;
}
function Eo(e, t) {
  const r = (e.split(new RegExp("(?<=[.!?])\\s"))[0] ?? e).replace(/\s+/g, " ").trim();
  return r.length <= t ? r.replace(/\.$/, "") : `${r.slice(0, t - 1).trimEnd()}…`;
}
function jo({
  runId: e,
  adapter: t,
  onDismiss: n
}) {
  const r = t.useIncidentRun(e), i = t.useIncidentNodeExecutions(e), a = r.data;
  if (r.isLoading || !a)
    return /* @__PURE__ */ s("div", { className: "injected-incident injected-incident--loading", children: /* @__PURE__ */ s(ft, {}) });
  const o = Vt(a.status), l = Dr(o.tone), c = Lr(a), u = Or(a, null), f = i.data ?? [];
  return /* @__PURE__ */ d(
    "div",
    {
      className: "injected-incident",
      style: { "--incident-tone": l.fg },
      "aria-label": `Incident: ${u}`,
      children: [
        /* @__PURE__ */ d("div", { className: "injected-incident__head", children: [
          /* @__PURE__ */ s("span", { className: "injected-incident__title", title: u, children: u }),
          /* @__PURE__ */ s("span", { className: Er(o.tone), children: o.label }),
          n ? /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: "injected-incident__dismiss",
              onClick: n,
              "aria-label": "Remove incident from chat",
              title: "Remove from chat",
              children: "✕"
            }
          ) : null
        ] }),
        /* @__PURE__ */ d("div", { className: "injected-incident__meta", children: [
          c ? /* @__PURE__ */ d(re, { children: [
            /* @__PURE__ */ s("span", { className: "t-mono", children: c }),
            /* @__PURE__ */ s("span", { "aria-hidden": "true", children: "·" })
          ] }) : null,
          /* @__PURE__ */ s("span", { children: rr(a.startedAt ?? a.createdAt) }),
          /* @__PURE__ */ s("span", { "aria-hidden": "true", children: "·" }),
          /* @__PURE__ */ d("span", { children: [
            f.length,
            " step",
            f.length === 1 ? "" : "s"
          ] })
        ] }),
        i.isLoading ? /* @__PURE__ */ s(ft, {}) : /* @__PURE__ */ s(Mo, { executions: f })
      ]
    }
  );
}
function Lo(e, t, n) {
  const r = new Set(n), i = /* @__PURE__ */ new Set(), a = [];
  for (const o of e)
    !i.has(o.runId) && !r.has(o.runId) && (i.add(o.runId), a.push(o));
  for (const o of t)
    !i.has(o) && !r.has(o) && (i.add(o), a.push({ runId: o }));
  return a;
}
const Oo = 6e4, Mn = "Stop — I interrupted this turn. Acknowledge briefly and wait.";
function Fo({
  groupId: e,
  threadId: t,
  thinking: n,
  onThinkingChange: r,
  onNavigate: i,
  onTurnComplete: a,
  autoReadAloud: o,
  onAutoReadAloudChange: l,
  initialMessage: c,
  renderLeadingSlot: u,
  renderToolCall: f,
  renderToolValueExtra: h,
  renderAboveComposer: m
}) {
  var ne;
  const y = pt(), { token: v, pageCatalog: b, voiceEnabled: C, incidentsAdapter: g } = Qe(), M = jt(), $ = Pi(e, t), _ = $.status ?? "STARTING", P = _ === "STOPPED" || _ === "FAILED", j = c != null && c.trim() ? c.trim() : null, [x, N] = A(
    () => j ? [
      {
        localId: "pa-initial",
        text: j,
        delivery: "now",
        kind: "instruction",
        wasWorking: !1
      }
    ] : []
  ), S = z(0), p = z(j), T = z("STARTING"), R = z(-1), w = z(/* @__PURE__ */ new Map()), [k, F] = A(0), [B, K] = A(null), G = z(null), D = z(0), L = J(() => {
    const E = G.current;
    if (E) {
      try {
        E.pause(), E.src = "";
      } catch {
      }
      G.current = null;
    }
    K(null);
  }, []), Z = J(
    async (E) => {
      if (!E.trim())
        return;
      L();
      const H = ++D.current;
      K({ loading: !0 });
      try {
        const Y = await mi(E, v);
        if (D.current !== H)
          return;
        const X = new Audio(Y);
        G.current = X;
        const V = () => {
          G.current === X && (G.current = null, K(null));
        };
        X.addEventListener("ended", V), X.addEventListener("error", V), K({ loading: !1 }), await X.play();
      } catch (Y) {
        console.error("PaChatView: TTS playback failed", Y), K(null), G.current = null;
      }
    },
    [L, v]
  );
  U(() => L, [L]);
  const ee = Q(() => {
    const E = [];
    for (const H of $.events)
      H.runId && E.push({ runId: H.runId, at: H.at });
    return E.reverse();
  }, [$.events]), ae = Q(
    () => g ? Lo(
      ee,
      M.injectionsFor(t),
      M.detachedFor(t)
    ) : [],
    [g, ee, M, t]
  ), se = Q(
    () => Oi({
      transcript: $.transcript,
      optimistic: x,
      events: $.events,
      incidents: ae,
      status: _
    }),
    [$.transcript, $.events, x, ae, _]
  ), ue = qe({
    // `delivery` is almost always 'now'; the Stop button sends 'interrupt',
    // which makes the host abort the in-flight run before delivering the turn
    // (see the PA host's delivery plan — steering).
    mutationFn: ({ content: E, delivery: H }) => y.http.post(`v1/persistent-agent-groups/${e}/agents/${t}/events`, {
      json: {
        kind: "instruction",
        delivery: H,
        content: E,
        turnOptions: { thinking: n, pageCatalog: b }
      }
    }).json()
  }), he = _ === "IDLE" || _ === "WAITING_FOR_INPUT";
  U(() => {
    const E = T.current;
    T.current = _, !(E !== "WORKING" || !he) && (a == null || a(p.current));
  }, [_]), U(() => {
    var X;
    if (!o || !C || !he) return;
    const E = $.transcript;
    let H = -1;
    for (let V = E.length - 1; V >= 0; V--)
      if (((X = E[V]) == null ? void 0 : X.type) === "user") {
        H = V;
        break;
      }
    if (H <= R.current) return;
    R.current = H;
    const Y = E.slice(H + 1).filter(
      (V) => V.type === "text"
    ).map((V) => V.text).join("");
    Y.trim() && (Z(Y), void 0);
  }, [_, he, $.transcript, o, C, Z]);
  const ye = ue.mutate, oe = J(
    (E, H, Y = "now") => {
      w.current.set(E, Date.now()), ye(
        { content: H, delivery: Y },
        {
          // Keep the optimistic bubble but mark it settled once the echo will
          // arrive (so it keeps a stable key), or failed so the user can retry.
          onSuccess: () => N(
            (X) => X.map((V) => V.localId === E ? { ...V, settled: !0 } : V)
          ),
          onError: () => N(
            (X) => X.map((V) => V.localId === E ? { ...V, failed: !0 } : V)
          )
        }
      );
    },
    [ye]
  ), ce = J(
    (E) => {
      const H = E.trim();
      if (!H)
        return;
      S.current += 1;
      const Y = `pa-${S.current}`;
      p.current === null && (p.current = H);
      const X = _ === "WORKING";
      N((V) => [
        ...V,
        { localId: Y, text: H, delivery: "now", kind: "instruction", wasWorking: X }
      ]), oe(Y, H);
    },
    [oe, _]
  ), Oe = J(() => {
    S.current += 1;
    const E = `pa-${S.current}`;
    N((H) => [
      ...H,
      {
        localId: E,
        text: Mn,
        delivery: "now",
        kind: "instruction",
        wasWorking: !0
      }
    ]), oe(E, Mn, "interrupt");
  }, [oe]);
  U(() => {
    const E = /* @__PURE__ */ new Set();
    for (const de of $.transcript)
      de.type === "user" && E.add(de.text.trim());
    const { changed: H, next: Y, nextDeadlineMs: X } = Hi(
      x,
      E,
      w.current,
      Date.now(),
      Oo
    );
    if (H) {
      N(Y);
      return;
    }
    if (X == null) return;
    const V = setTimeout(() => F((de) => de + 1), X + 50);
    return () => clearTimeout(V);
  }, [x, $.transcript, k]);
  const $e = z([]);
  U(() => {
    $e.current = x;
  }, [x]);
  const W = J(
    (E) => {
      const H = "optimistic-";
      if (!E.startsWith(H))
        return;
      const Y = E.slice(H.length), X = $e.current.find((V) => V.localId === Y && V.failed);
      X && (N((V) => V.filter((de) => de.localId !== Y)), ce(X.text));
    },
    [ce]
  ), I = z(/* @__PURE__ */ new Set()), O = z(/* @__PURE__ */ new Set()), q = z(null);
  U(() => {
    j && q.current !== t && (q.current = t, oe("pa-initial", j));
  }, [j, t, oe]);
  const te = z(/* @__PURE__ */ new Set()), _e = z(!1);
  U(() => {
    for (const E of $.transcript) {
      if (Ko(E)) {
        O.current.has(E.toolCallId) || (O.current.add(E.toolCallId), ut.publishResult({
          toolCallId: E.toolCallId,
          result: E.result,
          durationMs: E.durationMs
        }));
        continue;
      }
      if (!Bo(E) || (I.current.has(E.toolCallId) || (I.current.add(E.toolCallId), ut.publishCall({
        toolCallId: E.toolCallId,
        name: E.name,
        args: E.args,
        threadId: t
      })), E.name !== "navigate_to_page") || te.current.has(E.toolCallId))
        continue;
      const H = E.args, Y = typeof (H == null ? void 0 : H.url) == "string" ? H.url : null;
      if (Y) {
        if (!i) {
          _e.current || (_e.current = !0, console.warn(
            "@formant/chat: the agent issued a `navigate_to_page` tool call, but no `onNavigate` handler is configured on <ChatProvider>. Navigation was not performed."
          ));
          continue;
        }
        te.current.add(E.toolCallId), i(Y);
      }
    }
  }, [$.transcript, t, i]);
  const me = Q(() => ee.map((E) => E.runId), [ee]), Fe = J(
    (E) => g ? /* @__PURE__ */ s(
      jo,
      {
        runId: E,
        adapter: g,
        onDismiss: () => {
          M.detach(t, E), g.detachIncident(t, E);
        }
      }
    ) : null,
    [g, M, t]
  ), pe = (u == null ? void 0 : u({ threadId: t, feedRunIds: me })) ?? null, yt = Q(() => ({ groupId: e, threadId: t }), [e, t]), bt = Q(
    () => ({ renderToolCall: f, renderToolValueExtra: h }),
    [f, h]
  ), Te = Q(
    () => ({
      persistentAgentId: t,
      fetchImage: async (E) => {
        try {
          return await y.http.get(`v1/persistent-agents/${t}/images/${E}`).blob();
        } catch {
          return null;
        }
      }
    }),
    [y, t]
  );
  return /* @__PURE__ */ d("div", { className: "pa-chat-view", children: [
    /* @__PURE__ */ s("div", { className: "pa-chat-view__scroll", children: /* @__PURE__ */ s(Rs, { value: bt, children: /* @__PURE__ */ s(Na, { value: yt, children: /* @__PURE__ */ s(ja, { value: Te, children: /* @__PURE__ */ s(
      co,
      {
        items: se,
        status: _,
        activity: $.activity,
        connection: $.connection,
        onRetry: W,
        loading: !$.hasLoaded,
        leadingSlot: pe,
        renderIncident: g ? Fe : void 0,
        minimalChrome: !0
      },
      t
    ) }) }) }) }),
    ue.isError && /* @__PURE__ */ s("div", { className: "chat-launcher__error", children: String(((ne = ue.error) == null ? void 0 : ne.message) ?? "Failed to send message") }),
    (m == null ? void 0 : m({ threadId: t, transcript: $.transcript })) ?? null,
    /* @__PURE__ */ s(
      uo,
      {
        onSend: ce,
        onInterrupt: Oe,
        disabled: P,
        busy: _ === "WORKING",
        autosendOnDictation: C,
        pushToDictateKey: C ? "d" : void 0,
        hideDictation: !C,
        thinking: n,
        onThinkingChange: r,
        autoReadAloud: C ? o : void 0,
        onAutoReadAloudChange: C ? l : void 0,
        audioPlaying: B !== null,
        onStopAudio: L,
        onDictationStart: L
      }
    )
  ] });
}
function Wo(e) {
  return /* @__PURE__ */ s(Yn, { label: "Chat", children: /* @__PURE__ */ s(Fo, { ...e }) });
}
function Bo(e) {
  return e.type === "tool-call";
}
function Ko(e) {
  return e.type === "tool-result";
}
const Uo = `
@keyframes skeleton-pulse {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 0.8; }
}
`, $n = {
  background: "var(--surface-2)",
  borderRadius: "var(--radius-sm)",
  animation: "skeleton-pulse 1.5s ease-in-out infinite"
};
function Ho() {
  return /* @__PURE__ */ s("style", { children: Uo });
}
function Fr({ rows: e = 6 }) {
  return /* @__PURE__ */ d(re, { children: [
    /* @__PURE__ */ s(Ho, {}),
    /* @__PURE__ */ s(
      "div",
      {
        style: { display: "flex", flexDirection: "column", gap: 2, padding: "var(--sp-2, 8px)" },
        "aria-hidden": "true",
        children: Array.from({ length: e }, (t, n) => /* @__PURE__ */ d(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: 6,
              padding: "var(--sp-2, 8px) var(--sp-3, 12px)"
            },
            children: [
              /* @__PURE__ */ s("div", { style: { ...$n, width: `${72 - n % 3 * 14}%`, height: 12 } }),
              /* @__PURE__ */ s("div", { style: { ...$n, width: "34%", height: 9 } })
            ]
          },
          n
        ))
      }
    )
  ] });
}
function Go(e, t) {
  const n = `v1/persistent-agent-groups/${e}/agents`;
  return t === "me" ? `${n}?owner=me` : n;
}
function qo(e) {
  return e === "all" ? "all" : "me";
}
function Vo(e) {
  const { groupId: t, activePaThreadId: n, onSelectThread: r, onNewChat: i, newChatBusy: a, onPaArchived: o } = e, l = e.extraThreadRows ?? Jo, c = pt(), u = zn(), { ready: f, token: h, identityKey: m } = Qe(), [y, v] = A(() => {
    try {
      return qo(localStorage.getItem(Tn));
    } catch {
      return "me";
    }
  }), b = (N) => {
    v(N);
    try {
      localStorage.setItem(Tn, N);
    } catch {
    }
  }, C = Pn({
    // `owner` is part of the key so switching Mine/All refetches the right set.
    // `identityKey` scopes the cache per tenant so one org's list never leaks
    // into another after a sign-out / org-switch.
    queryKey: ["persistent-agents", "chat-threads", m, t, y],
    queryFn: () => c.http.get(Go(t, y)).json(),
    enabled: f && !!h
  }), g = qe({
    mutationFn: (N) => c.http.delete(`v1/persistent-agent-groups/${t}/agents/${N}`).json(),
    // Optimistic: drop the row from every cached list under this group (all the
    // owner-scoped sidebar keys AND the hook's owner-less resolution key) so the
    // sidebar row and — via the shared list feeding active-thread resolution —
    // the open transcript both clear in the same tick, instead of lingering for
    // the DELETE round-trip plus the follow-up refetch. Roll back on error;
    // reconcile on settle.
    onMutate: async (N) => {
      const S = ["persistent-agents", "chat-threads", m, t];
      await u.cancelQueries({ queryKey: S });
      const p = u.getQueriesData({ queryKey: S });
      return u.setQueriesData(
        { queryKey: S },
        (T) => T && {
          ...T,
          items: T.items.filter((R) => R.id !== N),
          total: Math.max(0, T.total - 1)
        }
      ), { prev: p };
    },
    onError: (N, S, p) => {
      for (const [T, R] of (p == null ? void 0 : p.prev) ?? []) u.setQueryData(T, R);
    },
    onSettled: () => (u.invalidateQueries({
      queryKey: ["persistent-agents", "chat-threads", m, t]
    }), void 0)
  }), M = qe({
    mutationFn: ({ id: N, name: S }) => c.http.patch(`v1/persistent-agent-groups/${t}/agents/${N}`, { json: { name: S } }).json(),
    onMutate: async ({ id: N, name: S }) => {
      const p = ["persistent-agents", "chat-threads", m, t];
      await u.cancelQueries({ queryKey: p });
      const T = u.getQueriesData({ queryKey: p });
      return u.setQueriesData(
        { queryKey: p },
        (R) => R && { ...R, items: R.items.map((w) => w.id === N ? { ...w, name: S } : w) }
      ), { prev: T };
    },
    onError: (N, S, p) => {
      for (const [T, R] of (p == null ? void 0 : p.prev) ?? []) u.setQueryData(T, R);
    },
    onSettled: () => (u.invalidateQueries({
      queryKey: ["persistent-agents", "chat-threads", m, t]
    }), void 0)
  }), [$, _] = A(null), P = (N, S) => {
    var R, w;
    const p = S.trim();
    _(null);
    const T = N.kind === "pa" ? N.title : N.row.title;
    !p || p === T || (N.kind === "pa" ? M.mutate({ id: N.id, name: p }) : (w = (R = N.row).onRename) == null || w.call(R, p));
  }, j = Q(
    () => {
      var N;
      return Xo({ paItems: ((N = C.data) == null ? void 0 : N.items) ?? [], extraRows: l });
    },
    [C.data, l]
  ), x = C.isLoading;
  return /* @__PURE__ */ d("div", { className: "thread-list", role: "navigation", "aria-label": "Chat history", children: [
    /* @__PURE__ */ d("div", { className: "thread-list__filter", role: "group", "aria-label": "Filter chats by owner", children: [
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: y === "all" ? "thread-list__filter-btn thread-list__filter-btn--active" : "thread-list__filter-btn",
          "aria-pressed": y === "all",
          onClick: () => b("all"),
          children: "All"
        }
      ),
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: y === "me" ? "thread-list__filter-btn thread-list__filter-btn--active" : "thread-list__filter-btn",
          "aria-pressed": y === "me",
          onClick: () => b("me"),
          children: "Mine"
        }
      )
    ] }),
    /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: "thread-list__new",
        onClick: i,
        disabled: a,
        title: "Start a new chat",
        children: [
          /* @__PURE__ */ s(el, {}),
          /* @__PURE__ */ s("span", { children: "New chat" })
        ]
      }
    ),
    x ? /* @__PURE__ */ s(Fr, { rows: 6 }) : C.error ? /* @__PURE__ */ d("div", { className: "thread-list__state thread-list__state--error", children: [
      "Failed to load: ",
      C.error.message
    ] }) : j.length === 0 ? /* @__PURE__ */ s("div", { className: "thread-list__state", children: "No prior chats." }) : /* @__PURE__ */ s("ul", { className: "thread-list__rows", children: j.map((N) => {
      const S = N.kind === "pa" ? N.id === n : N.row.active, p = N.kind === "pa" ? N.title : N.row.title, T = N.kind === "pa" ? N.iso : N.row.iso, R = N.kind === "pa" || !!N.row.onArchive, w = N.kind === "pa" ? "Remove chat" : N.row.archiveLabel ?? "Archive chat", k = `${N.kind}:${N.id}`, F = N.kind === "pa" || !!N.row.onRename, B = ($ == null ? void 0 : $.key) === k;
      return /* @__PURE__ */ d("li", { className: "thread-list__item", children: [
        B ? /* @__PURE__ */ s("div", { className: "thread-list__row thread-list__row--editing", children: /* @__PURE__ */ s(
          "input",
          {
            autoFocus: !0,
            className: "thread-list__title-input",
            value: $.value,
            "aria-label": "Rename chat",
            onChange: (K) => _({ key: k, value: K.target.value }),
            onKeyDown: (K) => {
              K.key === "Enter" ? P(N, $.value) : K.key === "Escape" && _(null);
            },
            onBlur: () => P(N, $.value)
          }
        ) }) : /* @__PURE__ */ d(
          "button",
          {
            type: "button",
            className: S ? "thread-list__row thread-list__row--active" : "thread-list__row",
            onClick: () => N.kind === "pa" ? r(N.data) : N.row.onSelect(),
            onDoubleClick: F ? () => _({ key: k, value: p }) : void 0,
            title: p,
            children: [
              /* @__PURE__ */ s("span", { className: "thread-list__title", children: p }),
              /* @__PURE__ */ s("span", { className: "thread-list__meta", children: Ei(T) })
            ]
          }
        ),
        F && !B ? /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: "thread-list__rename",
            title: "Rename chat",
            "aria-label": "Rename chat",
            onClick: (K) => {
              K.stopPropagation(), _({ key: k, value: p });
            },
            children: /* @__PURE__ */ s(tl, {})
          }
        ) : null,
        R && !B ? /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: "thread-list__archive",
            title: w,
            "aria-label": w,
            onClick: (K) => {
              var G, D;
              K.stopPropagation(), N.kind === "pa" ? (o == null || o(N.id), g.mutate(N.id)) : (D = (G = N.row).onArchive) == null || D.call(G);
            },
            children: "×"
          }
        ) : null
      ] }, k);
    }) })
  ] });
}
const Tn = "console.chatOwnerFilter", Jo = [];
function Xo(e) {
  const { paItems: t, extraRows: n } = e, r = t.map((a) => ({
    kind: "pa",
    id: a.id,
    title: a.name ?? "Untitled chat",
    ts: Qo(a),
    iso: Zo(a),
    data: a
  })), i = n.map((a) => ({
    kind: "extra",
    id: a.id,
    ts: a.ts,
    row: a
  }));
  return [...r, ...i].sort((a, o) => o.ts - a.ts);
}
function Tl(e) {
  const { id: t, paItems: n, extraIds: r, loading: i } = e;
  return r.includes(t) ? "extra" : n.some((a) => a.id === t) ? "pa" : i ? "loading" : "pa";
}
function Yo(e) {
  const t = e instanceof Date ? e.toISOString() : String(e), n = new Date(t).getTime();
  return Number.isNaN(n) ? 0 : n;
}
function Wr(e) {
  return e.lastMessageAt ?? e.startedAt;
}
function Qo(e) {
  return Yo(Wr(e));
}
function Zo(e) {
  const t = Wr(e);
  return t instanceof Date ? t.toISOString() : String(t);
}
function el() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: /* @__PURE__ */ s("path", { d: "M12 5v14M5 12h14" })
    }
  );
}
function tl() {
  return /* @__PURE__ */ d(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ s("path", { d: "M12 20h9" }),
        /* @__PURE__ */ s("path", { d: "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" })
      ]
    }
  );
}
function mt({ open: e, side: t }) {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      style: {
        transform: t === "left" === e ? void 0 : "rotate(180deg)",
        transition: "transform var(--dur-fast, 120ms) var(--ease-out, ease)"
      },
      children: /* @__PURE__ */ s("path", { d: "M15 18l-6-6 6-6" })
    }
  );
}
const nl = 60;
function Br({
  initial: e,
  min: t,
  max: n,
  handleSide: r,
  onCommit: i,
  onCollapse: a
}) {
  const o = J((g) => Math.min(n, Math.max(t, g)), [t, n]), [l, c] = A(() => o(e)), u = z(l);
  u.current = l;
  const f = z(null), h = z(!1), [m, y] = A(!1), v = J((g) => {
    g.preventDefault(), g.stopPropagation(), g.currentTarget.setPointerCapture(g.pointerId), f.current = { x: g.clientX, w: u.current }, h.current = !1, y(!0);
  }, []), b = J(
    (g) => {
      var j, x;
      const M = f.current;
      if (!M) return;
      const $ = g.clientX - M.x, _ = M.w + (r === "right" ? $ : -$);
      if (a && _ <= t - nl) {
        h.current = !0, f.current = null, y(!1);
        try {
          (x = (j = g.currentTarget).releasePointerCapture) == null || x.call(j, g.pointerId);
        } catch {
        }
        a();
        return;
      }
      const P = o(_);
      c(P), u.current = P;
    },
    [o, r, t, a]
  ), C = J(
    (g) => {
      var M, $;
      f.current && (f.current = null, y(!1), ($ = (M = g.currentTarget).releasePointerCapture) == null || $.call(M, g.pointerId), i == null || i(u.current));
    },
    [i]
  );
  return {
    width: l,
    dragging: m,
    handleProps: { onPointerDown: v, onPointerMove: b, onPointerUp: C }
  };
}
function Kr({
  side: e,
  dragging: t,
  handleProps: n
}) {
  return /* @__PURE__ */ s(
    "div",
    {
      className: `chat-resize-handle chat-resize-handle--${e}${t ? " is-dragging" : ""}`,
      role: "separator",
      "aria-orientation": "vertical",
      "aria-label": "Drag to resize",
      ...n
    }
  );
}
function rl({
  onClose: e,
  onNewChat: t,
  newChatBusy: n,
  title: r,
  sidebar: i,
  incidents: a,
  children: o,
  variant: l = "floating"
}) {
  const c = l === "docked", u = () => ({ w: window.innerWidth, h: window.innerHeight }), [f, h] = A(null), [m, y] = A(!1), [v, b] = A(() => wi(u())), [C, g] = A(!1), [M, $] = A(xi), [_, P] = A(!1), [j] = A(() => qn("launcherSidebarWidth", 200)), x = Br({
    initial: j,
    min: 160,
    max: 360,
    handleSide: "right",
    onCommit: (D) => Vn("launcherSidebarWidth", D),
    onCollapse: () => {
      $(!0), sn(!0);
    }
  }), N = z(v), S = z(f);
  U(() => {
    N.current = v;
  }, [v]), U(() => {
    S.current = f;
  }, [f]), U(() => {
    if (c || f) return;
    const D = u(), L = _i();
    if (L) {
      h(an(L, v, D));
      return;
    }
    h({
      x: Math.max(12, Math.round((D.w - v.w) / 2)),
      y: Math.max(12, Math.round((D.h - v.h) / 2))
    });
  }, [f, v]), U(() => {
    function D() {
      const L = u();
      b((Z) => Mt(Z, L)), h((Z) => Z && an(Z, N.current, L));
    }
    return window.addEventListener("resize", D), () => window.removeEventListener("resize", D);
  }, []);
  const p = z(null);
  U(() => {
    if (!m || _) return;
    function D(Z) {
      if (!p.current) return;
      const ee = u(), ae = In(Z.clientX - p.current.dx, 0, ee.w - N.current.w), se = In(Z.clientY - p.current.dy, 0, ee.h - N.current.h);
      h({ x: ae, y: se });
    }
    function L() {
      y(!1), p.current = null, S.current && Ni(S.current);
    }
    return window.addEventListener("pointermove", D), window.addEventListener("pointerup", L), () => {
      window.removeEventListener("pointermove", D), window.removeEventListener("pointerup", L);
    };
  }, [m, _]);
  const T = z(null), R = (D) => (L) => {
    _ || (L.preventDefault(), L.stopPropagation(), L.currentTarget.setPointerCapture(L.pointerId), T.current = {
      startX: L.clientX,
      startY: L.clientY,
      startW: v.w,
      startH: v.h,
      axis: D
    }, g(!0));
  }, w = (D) => {
    const L = T.current;
    if (!L) return;
    const Z = D.clientX - L.startX, ee = D.clientY - L.startY, ae = Mt(
      {
        w: L.axis === "s" ? L.startW : L.startW + Z,
        h: L.axis === "e" ? L.startH : L.startH + ee
      },
      u()
    );
    b(ae), N.current = ae;
  }, k = (D) => {
    var L, Z;
    T.current && (T.current = null, g(!1), (Z = (L = D.currentTarget).releasePointerCapture) == null || Z.call(L, D.pointerId), ki(N.current));
  }, F = () => $((D) => {
    const L = !D;
    return sn(L), L;
  });
  if (U(() => {
    function D(L) {
      L.key === "Escape" && (_ ? P(!1) : e());
    }
    return document.addEventListener("keydown", D), () => document.removeEventListener("keydown", D);
  }, [e, _]), !c && !f) return null;
  const B = c || _ || !f ? {} : { left: f.x, top: f.y, width: v.w, height: v.h }, K = !!i, G = /* @__PURE__ */ d(
    "div",
    {
      className: `chat-launcher__panel ${c ? "chat-launcher__panel--docked" : ""} ${_ ? "is-fullscreen" : ""} ${C ? "is-resizing" : ""}`,
      style: B,
      role: c ? "complementary" : "dialog",
      "aria-label": "Chat",
      children: [
        /* @__PURE__ */ d(
          "div",
          {
            className: `chat-launcher__drag-handle ${m ? "is-dragging" : ""} ${c || _ ? "is-locked" : ""}`,
            onPointerDown: (D) => {
              c || _ || D.target.closest(
                ".chat-launcher__close, .chat-launcher__new-chat, .chat-launcher__fullscreen"
              ) || f && (p.current = { dx: D.clientX - f.x, dy: D.clientY - f.y }, y(!0));
            },
            children: [
              /* @__PURE__ */ d("div", { className: "chat-launcher__title", children: [
                /* @__PURE__ */ s(ll, {}),
                /* @__PURE__ */ s("span", { children: r })
              ] }),
              /* @__PURE__ */ d("div", { className: "chat-launcher__actions", children: [
                /* @__PURE__ */ d(
                  "button",
                  {
                    type: "button",
                    className: `chat-launcher__new-chat${K && !M ? " chat-launcher__new-chat--rail-open" : ""}`,
                    "aria-label": "Start a new chat",
                    title: "Start a new chat",
                    onClick: t,
                    disabled: n,
                    children: [
                      /* @__PURE__ */ s(al, {}),
                      /* @__PURE__ */ s("span", { children: "New chat" })
                    ]
                  }
                ),
                c ? null : /* @__PURE__ */ s(
                  "button",
                  {
                    type: "button",
                    className: "chat-launcher__fullscreen",
                    "aria-label": _ ? "Exit fullscreen" : "Enter fullscreen",
                    "aria-pressed": _,
                    title: _ ? "Exit fullscreen" : "Enter fullscreen",
                    onClick: () => P((D) => !D),
                    children: _ ? /* @__PURE__ */ s(ol, {}) : /* @__PURE__ */ s(sl, {})
                  }
                ),
                /* @__PURE__ */ s(
                  "button",
                  {
                    type: "button",
                    className: "chat-launcher__close",
                    "aria-label": "Close chat",
                    onClick: e,
                    children: "✕"
                  }
                )
              ] })
            ]
          }
        ),
        /* @__PURE__ */ d("div", { className: "chat-launcher__body", children: [
          K && M ? /* @__PURE__ */ s("aside", { className: "chat-launcher__sidebar chat-launcher__sidebar--collapsed", children: /* @__PURE__ */ d(
            "button",
            {
              type: "button",
              className: "chat-launcher__sidebar-strip",
              onClick: F,
              "aria-label": "Show conversations",
              title: "Show conversations",
              children: [
                /* @__PURE__ */ s(mt, { open: !1, side: "left" }),
                /* @__PURE__ */ s("span", { className: "chat-launcher__vlabel", children: "Chats" })
              ]
            }
          ) }) : null,
          K && !M ? /* @__PURE__ */ d("aside", { className: "chat-launcher__sidebar", style: { flex: `0 0 ${x.width}px` }, children: [
            /* @__PURE__ */ d("div", { className: "chat-launcher__sidebar-head", children: [
              /* @__PURE__ */ s("span", { className: "chat-launcher__sidebar-title", children: "Chats" }),
              /* @__PURE__ */ s(
                "button",
                {
                  type: "button",
                  className: "chat-launcher__sidebar-toggle",
                  onClick: F,
                  "aria-label": "Hide conversations",
                  "aria-expanded": !0,
                  title: "Hide conversations",
                  children: /* @__PURE__ */ s(mt, { open: !0, side: "left" })
                }
              )
            ] }),
            i,
            /* @__PURE__ */ s(Kr, { side: "right", dragging: x.dragging, handleProps: x.handleProps })
          ] }) : null,
          /* @__PURE__ */ s("div", { className: "chat-launcher__main", children: o }),
          a
        ] }),
        !c && !_ ? /* @__PURE__ */ d(re, { children: [
          /* @__PURE__ */ s(
            "div",
            {
              className: "chat-launcher__resize-grip chat-launcher__resize-grip--e",
              role: "separator",
              "aria-orientation": "vertical",
              "aria-label": "Resize chat width",
              onPointerDown: R("e"),
              onPointerMove: w,
              onPointerUp: k,
              onPointerCancel: k
            }
          ),
          /* @__PURE__ */ s(
            "div",
            {
              className: "chat-launcher__resize-grip chat-launcher__resize-grip--s",
              role: "separator",
              "aria-orientation": "horizontal",
              "aria-label": "Resize chat height",
              onPointerDown: R("s"),
              onPointerMove: w,
              onPointerUp: k,
              onPointerCancel: k
            }
          ),
          /* @__PURE__ */ s(
            "div",
            {
              className: "chat-launcher__resize-grip chat-launcher__resize-grip--se",
              role: "separator",
              "aria-label": "Resize chat",
              onPointerDown: R("se"),
              onPointerMove: w,
              onPointerUp: k,
              onPointerCancel: k
            }
          )
        ] }) : null
      ]
    }
  );
  return c ? G : Et(G, document.body);
}
function il({ open: e, onToggle: t }) {
  return /* @__PURE__ */ s(
    "button",
    {
      type: "button",
      className: `chat-launcher__button fk-topbar__util fk-topbar__util--ai fk-tip fk-tip--below ${e ? "is-open" : ""}`,
      "data-tip": "Formant AI",
      "aria-pressed": e,
      "aria-label": e ? "Close chat" : "Open chat",
      onClick: t,
      style: { marginRight: "var(--sp-3)" },
      children: /* @__PURE__ */ d(
        "svg",
        {
          className: "icon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: 1.6,
          strokeLinejoin: "round",
          "aria-hidden": "true",
          children: [
            /* @__PURE__ */ s("path", { d: "M11 4l1.6 4.4L17 10l-4.4 1.6L11 16l-1.6-4.4L5 10l4.4-1.6Z" }),
            /* @__PURE__ */ s("path", { d: "M18.5 14.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8Z" })
          ]
        }
      )
    }
  );
}
function In(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function al() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: /* @__PURE__ */ s("path", { d: "M12 5v14M5 12h14" })
    }
  );
}
function sl() {
  return /* @__PURE__ */ d(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ s("polyline", { points: "15 3 21 3 21 9" }),
        /* @__PURE__ */ s("polyline", { points: "9 21 3 21 3 15" }),
        /* @__PURE__ */ s("line", { x1: "21", y1: "3", x2: "14", y2: "10" }),
        /* @__PURE__ */ s("line", { x1: "3", y1: "21", x2: "10", y2: "14" })
      ]
    }
  );
}
function ol() {
  return /* @__PURE__ */ d(
    "svg",
    {
      width: "12",
      height: "12",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ s("polyline", { points: "4 14 10 14 10 20" }),
        /* @__PURE__ */ s("polyline", { points: "20 10 14 10 14 4" }),
        /* @__PURE__ */ s("line", { x1: "14", y1: "10", x2: "21", y2: "3" }),
        /* @__PURE__ */ s("line", { x1: "3", y1: "21", x2: "10", y2: "14" })
      ]
    }
  );
}
function ll() {
  return /* @__PURE__ */ s(
    "svg",
    {
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 1.75,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true",
      children: /* @__PURE__ */ s("path", { d: "M21 11.5a8.38 8.38 0 0 1-8.5 8.5 8.5 8.5 0 0 1-3.7-.84L3 20l1.34-4.07A8.5 8.5 0 1 1 21 11.5z" })
    }
  );
}
const cl = 1440 * 60 * 1e3;
function ul({
  adapter: e,
  open: t,
  onToggle: n,
  onAddToChat: r,
  onAddToNewThread: i,
  minWidth: a = 300,
  maxWidth: o = 600
}) {
  const { items: l, isLoading: c, error: u } = e.useIncidentRuns(), { seenIds: f } = jt(), [h, m] = A("all"), [y, v] = A("any"), [b, C] = A(null), [g] = A(() => qn("incidentsRailWidth", 380)), { width: M, dragging: $, handleProps: _ } = Br({
    initial: g,
    min: a,
    max: o,
    handleSide: "left",
    onCommit: (x) => Vn("incidentsRailWidth", x),
    onCollapse: n
  }), P = Q(() => fl(l, h, y), [l, h, y]), j = Q(
    () => l.reduce((x, { run: N }) => Qt(N, f) ? x + 1 : x, 0),
    [l, f]
  );
  return t ? /* @__PURE__ */ d(
    "aside",
    {
      className: "incidents-rail incidents-rail--open",
      "aria-label": "Incidents",
      style: { "--incidents-rail-w": `${M}px` },
      children: [
        /* @__PURE__ */ s(Kr, { side: "left", dragging: $, handleProps: _ }),
        /* @__PURE__ */ d("div", { className: "incidents-rail__head", children: [
          /* @__PURE__ */ d("div", { className: "incidents-rail__title-row", children: [
            /* @__PURE__ */ s("span", { className: "incidents-rail__title", children: "Incidents" }),
            j > 0 ? /* @__PURE__ */ d("span", { className: "incidents-rail__new-badge", children: [
              j,
              " new"
            ] }) : null,
            /* @__PURE__ */ s("span", { className: "incidents-rail__count", children: c ? "" : `${P.length} shown` }),
            /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                className: "incidents-rail__collapse",
                onClick: n,
                "aria-label": "Hide incidents",
                "aria-expanded": !0,
                title: "Hide incidents",
                children: /* @__PURE__ */ s(mt, { open: !0, side: "right" })
              }
            )
          ] }),
          /* @__PURE__ */ d("div", { className: "incidents-rail__filters", children: [
            /* @__PURE__ */ s(
              Rn,
              {
                label: "Time",
                value: h,
                onChange: (x) => m(x),
                options: [
                  { value: "all", label: "All time" },
                  { value: "day", label: "Last 24 hours" }
                ]
              }
            ),
            /* @__PURE__ */ s(
              Rn,
              {
                label: "Outcome",
                value: y,
                onChange: (x) => v(x),
                options: [
                  { value: "any", label: "Any outcome" },
                  { value: "bad", label: "Didn’t finish" },
                  { value: "warn", label: "Needs a decision" },
                  { value: "info", label: "Working on it" },
                  { value: "ok", label: "Fixed automatically" },
                  { value: "neutral", label: "Stopped" }
                ]
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ s("div", { className: "incidents-rail__rows", children: c ? /* @__PURE__ */ s(Fr, { rows: 6 }) : u ? /* @__PURE__ */ d("div", { className: "alert alert--danger", style: { margin: "var(--sp-3)" }, children: [
          "Failed to load incidents: ",
          u.message
        ] }) : P.length === 0 ? /* @__PURE__ */ d("div", { className: "incidents-rail__empty", children: [
          /* @__PURE__ */ s("div", { className: "incidents-rail__empty-title", children: "No incidents" }),
          /* @__PURE__ */ s("div", { className: "incidents-rail__empty-desc", children: "Nothing matches these filters yet. Incidents appear here as workflows run." })
        ] }) : P.map((x) => /* @__PURE__ */ s(
          dl,
          {
            item: x,
            unseen: Qt(x.run, f),
            selected: b === x.run.id,
            onSelect: () => C((N) => N === x.run.id ? null : x.run.id),
            onAddToChat: () => r(x.run.id),
            onAddToNewThread: (N) => i(x.run.id, N)
          },
          x.run.id
        )) })
      ]
    }
  ) : /* @__PURE__ */ s(
    "aside",
    {
      className: "incidents-rail incidents-rail--collapsed",
      "aria-label": "Incidents (collapsed)",
      children: /* @__PURE__ */ d(
        "button",
        {
          type: "button",
          className: "incidents-rail__expand",
          onClick: n,
          "aria-label": j > 0 ? `Show incidents — ${j} new` : "Show incidents",
          "aria-expanded": !1,
          title: j > 0 ? `${j} new` : "Show incidents",
          children: [
            /* @__PURE__ */ s(mt, { open: !1, side: "right" }),
            /* @__PURE__ */ s("span", { className: "incidents-rail__vlabel", children: "Incidents" }),
            j > 0 ? /* @__PURE__ */ s("span", { className: "incidents-rail__strip-badge", children: j }) : null
          ]
        }
      )
    }
  );
}
function dl({
  item: e,
  unseen: t,
  selected: n,
  onSelect: r,
  onAddToChat: i,
  onAddToNewThread: a
}) {
  const { run: o, workflowName: l } = e, c = Vt(o.status), u = Dr(c.tone), f = Lr(o), h = Or(o, l), m = [
    "incident-row",
    t ? "incident-row--unseen" : "",
    n ? "incident-row--selected" : ""
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ d("div", { className: m, children: [
    /* @__PURE__ */ d(
      "button",
      {
        type: "button",
        className: "incident-row__hit",
        onClick: r,
        "aria-expanded": n,
        "aria-label": `Incident “${h}” — ${c.label}. Select for actions.`,
        children: [
          /* @__PURE__ */ s("span", { className: "incident-row__dot", style: { background: u.fg }, "aria-hidden": "true" }),
          /* @__PURE__ */ d("span", { className: "incident-row__main", children: [
            /* @__PURE__ */ s("span", { className: "incident-row__title", title: h, children: h }),
            /* @__PURE__ */ d("span", { className: "incident-row__meta", children: [
              f ? /* @__PURE__ */ d(re, { children: [
                /* @__PURE__ */ s("span", { className: "incident-row__device t-mono", children: f }),
                /* @__PURE__ */ s("span", { "aria-hidden": "true", children: "·" })
              ] }) : null,
              /* @__PURE__ */ s("span", { children: rr(o.startedAt ?? o.createdAt) }),
              /* @__PURE__ */ s("span", { className: Er(c.tone), children: c.label })
            ] })
          ] })
        ]
      }
    ),
    n ? /* @__PURE__ */ d("div", { className: "incident-row__actions", children: [
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: "btn btn--primary btn--sm",
          onClick: i,
          title: "Attach this incident to the current chat thread",
          children: "Add to chat"
        }
      ),
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: "btn btn--secondary btn--sm",
          onClick: () => a(h),
          title: "Open in a new thread scoped to this incident",
          children: "New thread"
        }
      )
    ] }) : null
  ] });
}
function Rn({
  label: e,
  value: t,
  onChange: n,
  options: r
}) {
  return /* @__PURE__ */ s("div", { className: "incidents-rail__filter", children: /* @__PURE__ */ s("select", { "aria-label": e, value: t, onChange: (i) => n(i.target.value), children: r.map((i) => /* @__PURE__ */ s("option", { value: i.value, children: i.label }, i.value)) }) });
}
function fl(e, t, n) {
  const r = t === "day" ? Date.now() - cl : 0;
  return e.filter(({ run: i }) => !(r > 0 && (i.startedAt ? new Date(i.startedAt).getTime() : new Date(i.createdAt).getTime()) < r || n !== "any" && Vt(i.status).tone !== n));
}
const An = "console.chatThinking";
function hl({
  open: e,
  onOpenChange: t,
  renderTrigger: n = !0,
  renderLeadingSlot: r,
  renderToolCall: i,
  renderToolValueExtra: a,
  variant: o = "floating"
} = {}) {
  const l = pt(), c = zn(), {
    ready: u,
    token: f,
    groupId: h,
    identityKey: m,
    onNavigate: y,
    incidentsAdapter: v,
    onNotify: b
  } = Qe(), C = jt(), [g, M] = A(!1), [$, _] = A(Ci), P = J(() => {
    _((W) => {
      const I = !W;
      return Si(I), I;
    });
  }, []), j = e !== void 0, x = j ? e : g, N = J(
    (W) => {
      j || M(W), t == null || t(W);
    },
    [j, t]
  ), [S, p] = A(null), [T, R] = A(!1), [w, k] = A(() => localStorage.getItem(An) !== "0"), F = J((W) => {
    localStorage.setItem(An, W ? "1" : "0"), k(W);
  }, []), [B, K] = A(!1), G = Pn({
    queryKey: ["persistent-agents", "chat-threads", m, h],
    queryFn: () => l.http.get(`v1/persistent-agent-groups/${h}/agents`).json(),
    enabled: u && !!f
  }), D = qe({
    mutationFn: () => l.http.post(`v1/persistent-agent-groups/${h}/agents`, { json: { initialFacts: [] } }).json(),
    onSuccess: (W) => {
      p({ id: W.id, name: W.name ?? null }), c.invalidateQueries({
        queryKey: ["persistent-agents", "chat-threads", m, h]
      });
    }
  }), L = qe({
    mutationFn: ({ id: W, name: I }) => l.http.patch(`v1/persistent-agent-groups/${h}/agents/${W}`, { json: { name: I } }).json(),
    onSuccess: (W) => {
      p((I) => (I == null ? void 0 : I.id) === W.id ? { id: W.id, name: W.name ?? null } : I), c.invalidateQueries({
        queryKey: ["persistent-agents", "chat-threads", m, h]
      });
    }
  }), Z = J(
    (W) => {
      var O;
      if ((S == null ? void 0 : S.id) !== W)
        return;
      const I = (((O = G.data) == null ? void 0 : O.items) ?? []).filter((q) => q.id !== W).sort(
        (q, te) => new Date(String(te.lastActivityAt ?? te.startedAt)).getTime() - new Date(String(q.lastActivityAt ?? q.startedAt)).getTime()
      );
      if (I[0]) {
        p({ id: I[0].id, name: I[0].name ?? null });
        return;
      }
      p(null), D.isPending || D.mutate();
    },
    [S, G.data, D]
  ), ee = (S == null ? void 0 : S.name) ?? "Chat", ae = J(() => {
    D.isPending || (p(null), D.mutate());
  }, [D]), se = J(() => {
    var O;
    if (S || D.isPending)
      return;
    if (G.isLoading) {
      R(!0);
      return;
    }
    const I = [...((O = G.data) == null ? void 0 : O.items) ?? []].sort(
      (q, te) => new Date(String(te.lastActivityAt ?? te.startedAt)).getTime() - new Date(String(q.lastActivityAt ?? q.startedAt)).getTime()
    )[0];
    if (I) {
      p({ id: I.id, name: I.name ?? null });
      return;
    }
    u && f ? D.mutate() : R(!0);
  }, [S, D, G.data, G.isLoading, u, f]), ue = J(() => N(!x), [x, N]), he = z(!1);
  U(() => {
    const W = he.current;
    he.current = x, x && !W && se();
  }, [x, se]), U(() => {
    function W(I) {
      I.repeat || (I.ctrlKey || I.metaKey) && I.key.toLowerCase() === "d" && (x || (I.preventDefault(), ue()));
    }
    return window.addEventListener("keydown", W), () => window.removeEventListener("keydown", W);
  }, [x, ue]), U(() => {
    var O;
    if (!T || !u || !f || S || D.isPending || G.isLoading)
      return;
    R(!1);
    const I = [...((O = G.data) == null ? void 0 : O.items) ?? []].sort(
      (q, te) => new Date(String(te.lastActivityAt ?? te.startedAt)).getTime() - new Date(String(q.lastActivityAt ?? q.startedAt)).getTime()
    )[0];
    if (I) {
      p({ id: I.id, name: I.name ?? null });
      return;
    }
    D.mutate();
  }, [T, u, f, S, D, G.isLoading, G.data]);
  const ye = z(!1), oe = J(
    (W) => {
      if (ye.current || !S || S.name !== null || !W)
        return;
      ye.current = !0;
      const I = W.length > 60 ? `${W.slice(0, 57)}…` : W;
      L.mutate({ id: S.id, name: I });
    },
    [S, L]
  ), ce = z(null);
  U(() => {
    S && ce.current !== S.id && (ce.current = S.id, ye.current = S.name !== null);
  }, [S]);
  const Oe = J(
    (W) => {
      if (!v) return;
      const I = () => b == null ? void 0 : b({ kind: "success", text: "Incident added to this chat" });
      if (S) {
        C.inject(S.id, W), v.attachIncident(S.id, W), I();
        return;
      }
      D.mutateAsync().then((O) => (C.inject(O.id, W), I(), v.attachIncident(O.id, W)));
    },
    [v, S, C, D, b]
  ), $e = J(
    (W, I) => {
      v && (D.mutateAsync().then((O) => (L.mutate({ id: O.id, name: I }), C.inject(O.id, W), v.attachIncident(O.id, W))), void 0);
    },
    [v, C, D, L]
  );
  return /* @__PURE__ */ d(re, { children: [
    n ? /* @__PURE__ */ s(il, { open: x, onToggle: ue }) : null,
    x ? /* @__PURE__ */ s(
      rl,
      {
        variant: o,
        onClose: () => N(!1),
        onNewChat: ae,
        newChatBusy: D.isPending,
        title: ee,
        incidents: v ? /* @__PURE__ */ s(
          ul,
          {
            adapter: v,
            open: $,
            onToggle: P,
            onAddToChat: Oe,
            onAddToNewThread: $e,
            minWidth: 240,
            maxWidth: 560
          }
        ) : null,
        sidebar: /* @__PURE__ */ s(
          Vo,
          {
            groupId: h,
            activePaThreadId: (S == null ? void 0 : S.id) ?? null,
            onSelectThread: (W) => p({ id: W.id, name: W.name ?? null }),
            onNewChat: ae,
            newChatBusy: D.isPending,
            onPaArchived: Z
          }
        ),
        children: D.error ? /* @__PURE__ */ d("div", { className: "chat-launcher__error", children: [
          "Failed to start chat: ",
          D.error.message
        ] }) : !u || !f ? /* @__PURE__ */ s("div", { className: "chat-launcher__loading", children: "Waiting for sign-in…" }) : S ? /* @__PURE__ */ s(
          Wo,
          {
            groupId: h,
            threadId: S.id,
            thinking: w,
            onThinkingChange: F,
            onNavigate: y,
            onTurnComplete: oe,
            autoReadAloud: B,
            onAutoReadAloudChange: K,
            renderLeadingSlot: r,
            renderToolCall: i,
            renderToolValueExtra: a
          },
          S.id
        ) : /* @__PURE__ */ s("div", { className: "chat-launcher__loading", children: "Starting chat…" })
      }
    ) : null
  ] });
}
function ml(e = {}) {
  return /* @__PURE__ */ s(Yn, { label: "Chat", children: /* @__PURE__ */ s(hl, { ...e }) });
}
const Il = ml;
export {
  co as AgentChat,
  ja as AgentImageSourceProvider,
  Yn as ChatErrorBoundary,
  Il as ChatLauncher,
  Cl as ChatProvider,
  mt as CollapseChevron,
  uo as Composer,
  Ea as ElicitationCard,
  Na as ElicitationScopeProvider,
  Ir as FleetDataView,
  oi as IncidentInjectionProvider,
  ul as IncidentsRail,
  ml as PaChatLauncher,
  Wo as PaChatView,
  Vo as PaThreadList,
  Kr as ResizeHandle,
  Rs as ToolRenderProvider,
  He as ToolValue,
  Zo as activityIso,
  Qo as activityMs,
  Ys as agentDisplayName,
  Xo as buildThreadRows,
  Oi as buildTimeline,
  $l as collectAgentSourceIds,
  sr as detectFleetData,
  _a as elicitationQuickActions,
  Sl as loadIncidentsRailOpen,
  qn as loadPanelWidth,
  Lo as mergeIncidents,
  Go as paAgentsPath,
  $a as parseRequestHumanInputCall,
  Tl as resolveThreadKind,
  Ml as saveIncidentsRailOpen,
  Vn as savePanelWidth,
  fi as setTheopolisBaseUrl,
  Xs as sourceLabel,
  xl as theopolisBaseUrl,
  Qe as useChatConfig,
  yi as useDictation,
  jt as useIncidentInjections,
  Br as useResizableWidth
};
//# sourceMappingURL=index.es.js.map
